!(function (e, t, i) {
    var n = window.matchMedia;
    "undefined" != typeof module && module.exports
        ? (module.exports = i(n))
        : "function" == typeof define && define.amd
        ? define(function () {
              return (t[e] = i(n));
          })
        : (t[e] = i(n));
})("enquire", this, function (n) {
    "use strict";
    function s(e, t) {
        for (var i = 0, n = e.length; i < n && !1 !== t(e[i], i); i++);
    }
    function r(e) {
        return "function" == typeof e;
    }
    function i(e) {
        (this.options = e).deferSetup || this.setup();
    }
    function a(e, t) {
        (this.query = e), (this.isUnconditional = t), (this.handlers = []), (this.mql = n(e));
        var i = this;
        (this.listener = function (e) {
            (i.mql = e), i.assess();
        }),
            this.mql.addListener(this.listener);
    }
    function e() {
        if (!n) throw new Error("matchMedia not present, legacy browsers require a polyfill");
        (this.queries = {}), (this.browserIsIncapable = !n("only all").matches);
    }
    return (
        (i.prototype = {
            setup: function () {
                this.options.setup && this.options.setup(), (this.initialised = !0);
            },
            on: function () {
                this.initialised || this.setup(), this.options.match && this.options.match();
            },
            off: function () {
                this.options.unmatch && this.options.unmatch();
            },
            destroy: function () {
                this.options.destroy ? this.options.destroy() : this.off();
            },
            equals: function (e) {
                return this.options === e || this.options.match === e;
            },
        }),
        (a.prototype = {
            addHandler: function (e) {
                var t = new i(e);
                this.handlers.push(t), this.matches() && t.on();
            },
            removeHandler: function (i) {
                var n = this.handlers;
                s(n, function (e, t) {
                    return e.equals(i) ? (e.destroy(), !n.splice(t, 1)) : void 0;
                });
            },
            matches: function () {
                return this.mql.matches || this.isUnconditional;
            },
            clear: function () {
                s(this.handlers, function (e) {
                    e.destroy();
                }),
                    this.mql.removeListener(this.listener),
                    (this.handlers.length = 0);
            },
            assess: function () {
                var t = this.matches() ? "on" : "off";
                s(this.handlers, function (e) {
                    e[t]();
                });
            },
        }),
        (e.prototype = {
            register: function (t, e, i) {
                var n = this.queries,
                    o = i && this.browserIsIncapable;
                return (
                    n[t] || (n[t] = new a(t, o)),
                    r(e) && (e = { match: e }),
                    "[object Array]" === Object.prototype.toString.apply(e) || (e = [e]),
                    s(e, function (e) {
                        r(e) && (e = { match: e }), n[t].addHandler(e);
                    }),
                    this
                );
            },
            unregister: function (e, t) {
                var i = this.queries[e];
                return i && (t ? i.removeHandler(t) : (i.clear(), delete this.queries[e])), this;
            },
        }),
        new e()
    );
}),
    (function (e, t) {
        "object" == typeof module && "object" == typeof module.exports
            ? (module.exports = e.document
                  ? t(e, !0)
                  : function (e) {
                        if (!e.document) throw new Error("jQuery requires a window with a document");
                        return t(e);
                    })
            : t(e);
    })("undefined" != typeof window ? window : this, function (x, e) {
        function a(e) {
            var t = !!e && "length" in e && e.length,
                i = Z.type(e);
            return "function" !== i && !Z.isWindow(e) && ("array" === i || 0 === t || ("number" == typeof t && 0 < t && t - 1 in e));
        }
        function t(e, i, n) {
            if (Z.isFunction(i))
                return Z.grep(e, function (e, t) {
                    return !!i.call(e, t, e) !== n;
                });
            if (i.nodeType)
                return Z.grep(e, function (e) {
                    return (e === i) !== n;
                });
            if ("string" == typeof i) {
                if (ae.test(i)) return Z.filter(i, e, n);
                i = Z.filter(i, e);
            }
            return Z.grep(e, function (e) {
                return -1 < Y.call(i, e) !== n;
            });
        }
        function i(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType; );
            return e;
        }
        function n() {
            W.removeEventListener("DOMContentLoaded", n), x.removeEventListener("load", n), Z.ready();
        }
        function o() {
            this.expando = Z.expando + o.uid++;
        }
        function l(e, t, i) {
            var n;
            if (void 0 === i && 1 === e.nodeType)
                if (((n = "data-" + t.replace(we, "-$&").toLowerCase()), "string" == typeof (i = e.getAttribute(n)))) {
                    try {
                        i = "true" === i || ("false" !== i && ("null" === i ? null : +i + "" === i ? +i : ye.test(i) ? Z.parseJSON(i) : i));
                    } catch (e) {}
                    me.set(e, t, i);
                } else i = void 0;
            return i;
        }
        function c(e, t, i, n) {
            var o,
                s = 1,
                r = 20,
                a = n
                    ? function () {
                          return n.cur();
                      }
                    : function () {
                          return Z.css(e, t, "");
                      },
                l = a(),
                c = (i && i[3]) || (Z.cssNumber[t] ? "" : "px"),
                d = (Z.cssNumber[t] || ("px" !== c && +l)) && $e.exec(Z.css(e, t));
            if (d && d[3] !== c) for (c = c || d[3], i = i || [], d = +l || 1; (d /= s = s || ".5"), Z.style(e, t, d + c), s !== (s = a() / l) && 1 !== s && --r; );
            return i && ((d = +d || +l || 0), (o = i[1] ? d + (i[1] + 1) * i[2] : +i[2]), n && ((n.unit = c), (n.start = d), (n.end = o))), o;
        }
        function v(e, t) {
            var i = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [];
            return void 0 === t || (t && Z.nodeName(e, t)) ? Z.merge([e], i) : i;
        }
        function g(e, t) {
            for (var i = 0, n = e.length; i < n; i++) ge.set(e[i], "globalEval", !t || ge.get(t[i], "globalEval"));
        }
        function m(e, t, i, n, o) {
            for (var s, r, a, l, c, d, u = t.createDocumentFragment(), p = [], f = 0, h = e.length; f < h; f++)
                if ((s = e[f]) || 0 === s)
                    if ("object" === Z.type(s)) Z.merge(p, s.nodeType ? [s] : s);
                    else if (Ne.test(s)) {
                        for (r = r || u.appendChild(t.createElement("div")), a = (Se.exec(s) || ["", ""])[1].toLowerCase(), l = Ae[a] || Ae._default, r.innerHTML = l[1] + Z.htmlPrefilter(s) + l[2], d = l[0]; d--; ) r = r.lastChild;
                        Z.merge(p, r.childNodes), ((r = u.firstChild).textContent = "");
                    } else p.push(t.createTextNode(s));
            for (u.textContent = "", f = 0; (s = p[f++]); )
                if (n && -1 < Z.inArray(s, n)) o && o.push(s);
                else if (((c = Z.contains(s.ownerDocument, s)), (r = v(u.appendChild(s), "script")), c && g(r), i)) for (d = 0; (s = r[d++]); ) Ce.test(s.type || "") && i.push(s);
            return u;
        }
        function s() {
            return !0;
        }
        function d() {
            return !1;
        }
        function r() {
            try {
                return W.activeElement;
            } catch (e) {}
        }
        function u(e, t, i, n, o, s) {
            var r, a;
            if ("object" == typeof t) {
                for (a in ("string" != typeof i && ((n = n || i), (i = void 0)), t)) u(e, a, i, n, t[a], s);
                return e;
            }
            if ((null == n && null == o ? ((o = i), (n = i = void 0)) : null == o && ("string" == typeof i ? ((o = n), (n = void 0)) : ((o = n), (n = i), (i = void 0))), !1 === o)) o = d;
            else if (!o) return e;
            return (
                1 === s &&
                    ((r = o),
                    ((o = function (e) {
                        return Z().off(e), r.apply(this, arguments);
                    }).guid = r.guid || (r.guid = Z.guid++))),
                e.each(function () {
                    Z.event.add(this, t, o, n, i);
                })
            );
        }
        function p(e, t) {
            return Z.nodeName(e, "table") && Z.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e;
        }
        function y(e) {
            return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
        }
        function w(e) {
            var t = Ie.exec(e.type);
            return t ? (e.type = t[1]) : e.removeAttribute("type"), e;
        }
        function f(e, t) {
            var i, n, o, s, r, a, l, c;
            if (1 === t.nodeType) {
                if (ge.hasData(e) && ((s = ge.access(e)), (r = ge.set(t, s)), (c = s.events))) for (o in (delete r.handle, (r.events = {}), c)) for (i = 0, n = c[o].length; i < n; i++) Z.event.add(t, o, c[o][i]);
                me.hasData(e) && ((a = me.access(e)), (l = Z.extend({}, a)), me.set(t, l));
            }
        }
        function b(i, n, o, s) {
            n = B.apply([], n);
            var e,
                t,
                r,
                a,
                l,
                c,
                d = 0,
                u = i.length,
                p = u - 1,
                f = n[0],
                h = Z.isFunction(f);
            if (h || (1 < u && "string" == typeof f && !K.checkClone && Le.test(f)))
                return i.each(function (e) {
                    var t = i.eq(e);
                    h && (n[0] = f.call(this, e, t.html())), b(t, n, o, s);
                });
            if (u && ((t = (e = m(n, i[0].ownerDocument, !1, i, s)).firstChild), 1 === e.childNodes.length && (e = t), t || s)) {
                for (a = (r = Z.map(v(e, "script"), y)).length; d < u; d++) (l = e), d !== p && ((l = Z.clone(l, !0, !0)), a && Z.merge(r, v(l, "script"))), o.call(i[d], l, d);
                if (a)
                    for (c = r[r.length - 1].ownerDocument, Z.map(r, w), d = 0; d < a; d++)
                        (l = r[d]), Ce.test(l.type || "") && !ge.access(l, "globalEval") && Z.contains(c, l) && (l.src ? Z._evalUrl && Z._evalUrl(l.src) : Z.globalEval(l.textContent.replace(Me, "")));
            }
            return i;
        }
        function h(e, t, i) {
            for (var n, o = t ? Z.filter(t, e) : e, s = 0; null != (n = o[s]); s++) i || 1 !== n.nodeType || Z.cleanData(v(n)), n.parentNode && (i && Z.contains(n.ownerDocument, n) && g(v(n, "script")), n.parentNode.removeChild(n));
            return e;
        }
        function k(e, t) {
            var i = Z(t.createElement(e)).appendTo(t.body),
                n = Z.css(i[0], "display");
            return i.detach(), n;
        }
        function $(e) {
            var t = W,
                i = Ye[e];
            return (
                i || (("none" !== (i = k(e, t)) && i) || ((t = (qe = (qe || Z("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement))[0].contentDocument).write(), t.close(), (i = k(e, t)), qe.detach()), (Ye[e] = i)),
                i
            );
        }
        function T(e, t, i) {
            var n,
                o,
                s,
                r,
                a = e.style;
            return (
                ("" !== (r = (i = i || Ve(e)) ? i.getPropertyValue(t) || i[t] : void 0) && void 0 !== r) || Z.contains(e.ownerDocument, e) || (r = Z.style(e, t)),
                i && !K.pixelMarginRight() && Ge.test(r) && Qe.test(t) && ((n = a.width), (o = a.minWidth), (s = a.maxWidth), (a.minWidth = a.maxWidth = a.width = r), (r = i.width), (a.width = n), (a.minWidth = o), (a.maxWidth = s)),
                void 0 !== r ? r + "" : r
            );
        }
        function S(e, t) {
            return {
                get: function () {
                    return e() ? void delete this.get : (this.get = t).apply(this, arguments);
                },
            };
        }
        function C(e) {
            if (e in nt) return e;
            for (var t = e[0].toUpperCase() + e.slice(1), i = it.length; i--; ) if ((e = it[i] + t) in nt) return e;
        }
        function A(e, t, i) {
            var n = $e.exec(t);
            return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t;
        }
        function E(e, t, i, n, o) {
            for (var s = i === (n ? "border" : "content") ? 4 : "width" === t ? 1 : 0, r = 0; s < 4; s += 2)
                "margin" === i && (r += Z.css(e, i + xe[s], !0, o)),
                    n
                        ? ("content" === i && (r -= Z.css(e, "padding" + xe[s], !0, o)), "margin" !== i && (r -= Z.css(e, "border" + xe[s] + "Width", !0, o)))
                        : ((r += Z.css(e, "padding" + xe[s], !0, o)), "padding" !== i && (r += Z.css(e, "border" + xe[s] + "Width", !0, o)));
            return r;
        }
        function N(e, t, i) {
            var n = !0,
                o = "width" === t ? e.offsetWidth : e.offsetHeight,
                s = Ve(e),
                r = "border-box" === Z.css(e, "boxSizing", !1, s);
            if ((W.msFullscreenElement && x.top !== x && e.getClientRects().length && (o = Math.round(100 * e.getBoundingClientRect()[t])), o <= 0 || null == o)) {
                if ((((o = T(e, t, s)) < 0 || null == o) && (o = e.style[t]), Ge.test(o))) return o;
                (n = r && (K.boxSizingReliable() || o === e.style[t])), (o = parseFloat(o) || 0);
            }
            return o + E(e, t, i || (r ? "border" : "content"), n, s) + "px";
        }
        function j(e, t) {
            for (var i, n, o, s = [], r = 0, a = e.length; r < a; r++)
                (n = e[r]).style &&
                    ((s[r] = ge.get(n, "olddisplay")),
                    (i = n.style.display),
                    t
                        ? (s[r] || "none" !== i || (n.style.display = ""), "" === n.style.display && be(n) && (s[r] = ge.access(n, "olddisplay", $(n.nodeName))))
                        : ((o = be(n)), ("none" === i && o) || ge.set(n, "olddisplay", o ? i : Z.css(n, "display"))));
            for (r = 0; r < a; r++) (n = e[r]).style && ((t && "none" !== n.style.display && "" !== n.style.display) || (n.style.display = t ? s[r] || "" : "none"));
            return e;
        }
        function O(e, t, i, n, o) {
            return new O.prototype.init(e, t, i, n, o);
        }
        function D() {
            return (
                x.setTimeout(function () {
                    ot = void 0;
                }),
                (ot = Z.now())
            );
        }
        function _(e, t) {
            var i,
                n = 0,
                o = { height: e };
            for (t = t ? 1 : 0; n < 4; n += 2 - t) o["margin" + (i = xe[n])] = o["padding" + i] = e;
            return t && (o.opacity = o.width = e), o;
        }
        function H(e, t, i) {
            for (var n, o = (P.tweeners[t] || []).concat(P.tweeners["*"]), s = 0, r = o.length; s < r; s++) if ((n = o[s].call(i, t, e))) return n;
        }
        function P(s, e, t) {
            var i,
                r,
                n = 0,
                o = P.prefilters.length,
                a = Z.Deferred().always(function () {
                    delete l.elem;
                }),
                l = function () {
                    if (r) return !1;
                    for (var e = ot || D(), t = Math.max(0, c.startTime + c.duration - e), i = 1 - (t / c.duration || 0), n = 0, o = c.tweens.length; n < o; n++) c.tweens[n].run(i);
                    return a.notifyWith(s, [c, i, t]), i < 1 && o ? t : (a.resolveWith(s, [c]), !1);
                },
                c = a.promise({
                    elem: s,
                    props: Z.extend({}, e),
                    opts: Z.extend(!0, { specialEasing: {}, easing: Z.easing._default }, t),
                    originalProperties: e,
                    originalOptions: t,
                    startTime: ot || D(),
                    duration: t.duration,
                    tweens: [],
                    createTween: function (e, t) {
                        var i = Z.Tween(s, c.opts, e, t, c.opts.specialEasing[e] || c.opts.easing);
                        return c.tweens.push(i), i;
                    },
                    stop: function (e) {
                        var t = 0,
                            i = e ? c.tweens.length : 0;
                        if (r) return this;
                        for (r = !0; t < i; t++) c.tweens[t].run(1);
                        return e ? (a.notifyWith(s, [c, 1, 0]), a.resolveWith(s, [c, e])) : a.rejectWith(s, [c, e]), this;
                    },
                }),
                d = c.props;
            for (
                (function (e, t) {
                    var i, n, o, s, r;
                    for (i in e)
                        if (((o = t[(n = Z.camelCase(i))]), (s = e[i]), Z.isArray(s) && ((o = s[1]), (s = e[i] = s[0])), i !== n && ((e[n] = s), delete e[i]), (r = Z.cssHooks[n]) && ("expand" in r)))
                            for (i in ((s = r.expand(s)), delete e[n], s)) (i in e) || ((e[i] = s[i]), (t[i] = o));
                        else t[n] = o;
                })(d, c.opts.specialEasing);
                n < o;
                n++
            )
                if ((i = P.prefilters[n].call(c, s, d, c.opts))) return Z.isFunction(i.stop) && (Z._queueHooks(c.elem, c.opts.queue).stop = Z.proxy(i.stop, i)), i;
            return (
                Z.map(d, H, c),
                Z.isFunction(c.opts.start) && c.opts.start.call(s, c),
                Z.fx.timer(Z.extend(l, { elem: s, anim: c, queue: c.opts.queue })),
                c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always)
            );
        }
        function L(e) {
            return (e.getAttribute && e.getAttribute("class")) || "";
        }
        function I(s) {
            return function (e, t) {
                "string" != typeof e && ((t = e), (e = "*"));
                var i,
                    n = 0,
                    o = e.toLowerCase().match(fe) || [];
                if (Z.isFunction(t)) for (; (i = o[n++]); ) "+" === i[0] ? ((i = i.slice(1) || "*"), (s[i] = s[i] || []).unshift(t)) : (s[i] = s[i] || []).push(t);
            };
        }
        function M(t, o, s, r) {
            function a(e) {
                var n;
                return (
                    (l[e] = !0),
                    Z.each(t[e] || [], function (e, t) {
                        var i = t(o, s, r);
                        return "string" != typeof i || c || l[i] ? (c ? !(n = i) : void 0) : (o.dataTypes.unshift(i), a(i), !1);
                    }),
                    n
                );
            }
            var l = {},
                c = t === Et;
            return a(o.dataTypes[0]) || (!l["*"] && a("*"));
        }
        function z(e, t) {
            var i,
                n,
                o = Z.ajaxSettings.flatOptions || {};
            for (i in t) void 0 !== t[i] && ((o[i] ? e : (n = n || {}))[i] = t[i]);
            return n && Z.extend(!0, e, n), e;
        }
        function q(e) {
            return Z.isWindow(e) ? e : 9 === e.nodeType && e.defaultView;
        }
        function F(e, t) {
            return t.toUpperCase();
        }
        var R = [],
            W = x.document,
            U = R.slice,
            B = R.concat,
            X = R.push,
            Y = R.indexOf,
            Q = {},
            G = Q.toString,
            V = Q.hasOwnProperty,
            K = {},
            Z = function (e, t) {
                return new Z.fn.init(e, t);
            },
            J = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
            ee = /^-ms-/,
            te = /-([\da-z])/gi;
        (Z.fn = Z.prototype = {
            jquery: "3.5.1",
            constructor: Z,
            selector: "",
            length: 0,
            toArray: function () {
                return U.call(this);
            },
            get: function (e) {
                return null != e ? (e < 0 ? this[e + this.length] : this[e]) : U.call(this);
            },
            pushStack: function (e) {
                var t = Z.merge(this.constructor(), e);
                return (t.prevObject = this), (t.context = this.context), t;
            },
            each: function (e) {
                return Z.each(this, e);
            },
            map: function (i) {
                return this.pushStack(
                    Z.map(this, function (e, t) {
                        return i.call(e, t, e);
                    })
                );
            },
            slice: function () {
                return this.pushStack(U.apply(this, arguments));
            },
            first: function () {
                return this.eq(0);
            },
            last: function () {
                return this.eq(-1);
            },
            eq: function (e) {
                var t = this.length,
                    i = +e + (e < 0 ? t : 0);
                return this.pushStack(0 <= i && i < t ? [this[i]] : []);
            },
            end: function () {
                return this.prevObject || this.constructor();
            },
            push: X,
            sort: R.sort,
            splice: R.splice,
        }),
            (Z.extend = Z.fn.extend = function () {
                var e,
                    t,
                    i,
                    n,
                    o,
                    s,
                    r = arguments[0] || {},
                    a = 1,
                    l = arguments.length,
                    c = !1;
                for ("boolean" == typeof r && ((c = r), (r = arguments[a] || {}), a++), "object" == typeof r || Z.isFunction(r) || (r = {}), a === l && ((r = this), a--); a < l; a++)
                    if (null != (e = arguments[a]))
                        for (t in e)
                            (i = r[t]),
                                r !== (n = e[t]) &&
                                    (c && n && (Z.isPlainObject(n) || (o = Z.isArray(n))) ? ((s = o ? ((o = !1), i && Z.isArray(i) ? i : []) : i && Z.isPlainObject(i) ? i : {}), (r[t] = Z.extend(c, s, n))) : void 0 !== n && (r[t] = n));
                return r;
            }),
            Z.extend({
                expando: "jQuery" + ("2.2.3" + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function (e) {
                    throw new Error(e);
                },
                noop: function () {},
                isFunction: function (e) {
                    return "function" === Z.type(e);
                },
                isArray: Array.isArray,
                isWindow: function (e) {
                    return null != e && e === e.window;
                },
                isNumeric: function (e) {
                    var t = e && e.toString();
                    return !Z.isArray(e) && 0 <= t - parseFloat(t) + 1;
                },
                isPlainObject: function (e) {
                    var t;
                    if ("object" !== Z.type(e) || e.nodeType || Z.isWindow(e)) return !1;
                    if (e.constructor && !V.call(e, "constructor") && !V.call(e.constructor.prototype || {}, "isPrototypeOf")) return !1;
                    for (t in e);
                    return void 0 === t || V.call(e, t);
                },
                isEmptyObject: function (e) {
                    var t;
                    for (t in e) return !1;
                    return !0;
                },
                type: function (e) {
                    return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? Q[G.call(e)] || "object" : typeof e;
                },
                globalEval: function (e) {
                    var t,
                        i = eval;
                    (e = Z.trim(e)) && (1 === e.indexOf("use strict") ? (((t = W.createElement("script")).text = e), W.head.appendChild(t).parentNode.removeChild(t)) : i(e));
                },
                camelCase: function (e) {
                    return e.replace(ee, "ms-").replace(te, F);
                },
                nodeName: function (e, t) {
                    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
                },
                each: function (e, t) {
                    var i,
                        n = 0;
                    if (a(e)) for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++);
                    else for (n in e) if (!1 === t.call(e[n], n, e[n])) break;
                    return e;
                },
                trim: function (e) {
                    return null == e ? "" : (e + "").replace(J, "");
                },
                makeArray: function (e, t) {
                    var i = t || [];
                    return null != e && (a(Object(e)) ? Z.merge(i, "string" == typeof e ? [e] : e) : X.call(i, e)), i;
                },
                inArray: function (e, t, i) {
                    return null == t ? -1 : Y.call(t, e, i);
                },
                merge: function (e, t) {
                    for (var i = +t.length, n = 0, o = e.length; n < i; n++) e[o++] = t[n];
                    return (e.length = o), e;
                },
                grep: function (e, t, i) {
                    for (var n = [], o = 0, s = e.length, r = !i; o < s; o++) !t(e[o], o) != r && n.push(e[o]);
                    return n;
                },
                map: function (e, t, i) {
                    var n,
                        o,
                        s = 0,
                        r = [];
                    if (a(e)) for (n = e.length; s < n; s++) null != (o = t(e[s], s, i)) && r.push(o);
                    else for (s in e) null != (o = t(e[s], s, i)) && r.push(o);
                    return B.apply([], r);
                },
                guid: 1,
                proxy: function (e, t) {
                    var i, n, o;
                    return (
                        "string" == typeof t && ((i = e[t]), (t = e), (e = i)),
                        Z.isFunction(e)
                            ? ((n = U.call(arguments, 2)),
                              ((o = function () {
                                  return e.apply(t || this, n.concat(U.call(arguments)));
                              }).guid = e.guid = e.guid || Z.guid++),
                              o)
                            : void 0
                    );
                },
                now: Date.now,
                support: K,
            }),
            "function" == typeof Symbol && (Z.fn[Symbol.iterator] = R[Symbol.iterator]),
            Z.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
                Q["[object " + t + "]"] = t.toLowerCase();
            });
        var ie = (function (i) {
            function b(e, t, i, n) {
                var o,
                    s,
                    r,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p = t && t.ownerDocument,
                    f = t ? t.nodeType : 9;
                if (((i = i || []), "string" != typeof e || !e || (1 !== f && 9 !== f && 11 !== f))) return i;
                if (!n && ((t ? t.ownerDocument || t : I) !== N && E(t), (t = t || N), O)) {
                    if (11 !== f && (c = fe.exec(e)))
                        if ((o = c[1])) {
                            if (9 === f) {
                                if (!(r = t.getElementById(o))) return i;
                                if (r.id === o) return i.push(r), i;
                            } else if (p && (r = p.getElementById(o)) && P(t, r) && r.id === o) return i.push(r), i;
                        } else {
                            if (c[2]) return Q.apply(i, t.getElementsByTagName(e)), i;
                            if ((o = c[3]) && m.getElementsByClassName && t.getElementsByClassName) return Q.apply(i, t.getElementsByClassName(o)), i;
                        }
                    if (m.qsa && !R[e + " "] && (!D || !D.test(e))) {
                        if (1 !== f) (p = t), (u = e);
                        else if ("object" !== t.nodeName.toLowerCase()) {
                            for ((a = t.getAttribute("id")) ? (a = a.replace(ve, "\\$&")) : t.setAttribute("id", (a = L)), s = (d = T(e)).length, l = le.test(a) ? "#" + a : "[id='" + a + "']"; s--; ) d[s] = l + " " + v(d[s]);
                            (u = d.join(",")), (p = (he.test(e) && h(t.parentNode)) || t);
                        }
                        if (u)
                            try {
                                return Q.apply(i, p.querySelectorAll(u)), i;
                            } catch (e) {
                            } finally {
                                a === L && t.removeAttribute("id");
                            }
                    }
                }
                return w(e.replace(ne, "$1"), t, i, n);
            }
            function e() {
                var n = [];
                return function e(t, i) {
                    return n.push(t + " ") > x.cacheLength && delete e[n.shift()], (e[t + " "] = i);
                };
            }
            function u(e) {
                return (e[L] = !0), e;
            }
            function o(e) {
                var t = N.createElement("div");
                try {
                    return !!e(t);
                } catch (e) {
                    return !1;
                } finally {
                    t.parentNode && t.parentNode.removeChild(t), (t = null);
                }
            }
            function t(e, t) {
                for (var i = e.split("|"), n = i.length; n--; ) x.attrHandle[i[n]] = t;
            }
            function l(e, t) {
                var i = t && e,
                    n = i && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || 1 << 31) - (~e.sourceIndex || 1 << 31);
                if (n) return n;
                if (i) for (; (i = i.nextSibling); ) if (i === t) return -1;
                return e ? 1 : -1;
            }
            function n(r) {
                return u(function (s) {
                    return (
                        (s = +s),
                        u(function (e, t) {
                            for (var i, n = r([], e.length, s), o = n.length; o--; ) e[(i = n[o])] && (e[i] = !(t[i] = e[i]));
                        })
                    );
                });
            }
            function h(e) {
                return e && void 0 !== e.getElementsByTagName && e;
            }
            function s() {}
            function v(e) {
                for (var t = 0, i = e.length, n = ""; t < i; t++) n += e[t].value;
                return n;
            }
            function p(a, e, t) {
                var l = e.dir,
                    c = t && "parentNode" === l,
                    d = z++;
                return e.first
                    ? function (e, t, i) {
                          for (; (e = e[l]); ) if (1 === e.nodeType || c) return a(e, t, i);
                      }
                    : function (e, t, i) {
                          var n,
                              o,
                              s,
                              r = [M, d];
                          if (i) {
                              for (; (e = e[l]); ) if ((1 === e.nodeType || c) && a(e, t, i)) return !0;
                          } else
                              for (; (e = e[l]); )
                                  if (1 === e.nodeType || c) {
                                      if ((n = (o = (s = e[L] || (e[L] = {}))[e.uniqueID] || (s[e.uniqueID] = {}))[l]) && n[0] === M && n[1] === d) return (r[2] = n[2]);
                                      if (((o[l] = r)[2] = a(e, t, i))) return !0;
                                  }
                      };
            }
            function f(o) {
                return 1 < o.length
                    ? function (e, t, i) {
                          for (var n = o.length; n--; ) if (!o[n](e, t, i)) return !1;
                          return !0;
                      }
                    : o[0];
            }
            function k(e, t, i, n, o) {
                for (var s, r = [], a = 0, l = e.length, c = null != t; a < l; a++) (s = e[a]) && ((i && !i(s, n, o)) || (r.push(s), c && t.push(a)));
                return r;
            }
            function $(e) {
                for (
                    var o,
                        t,
                        i,
                        n = e.length,
                        s = x.relative[e[0].type],
                        r = s || x.relative[" "],
                        a = s ? 1 : 0,
                        l = p(
                            function (e) {
                                return e === o;
                            },
                            r,
                            !0
                        ),
                        c = p(
                            function (e) {
                                return -1 < V(o, e);
                            },
                            r,
                            !0
                        ),
                        d = [
                            function (e, t, i) {
                                var n = (!s && (i || t !== S)) || ((o = t).nodeType ? l : c)(e, t, i);
                                return (o = null), n;
                            },
                        ];
                    a < n;
                    a++
                )
                    if ((t = x.relative[e[a].type])) d = [p(f(d), t)];
                    else {
                        if ((t = x.filter[e[a].type].apply(null, e[a].matches))[L]) {
                            for (i = ++a; i < n && !x.relative[e[i].type]; i++);
                            return (function e(f, h, v, g, m, t) {
                                return (
                                    g && !g[L] && (g = e(g)),
                                    m && !m[L] && (m = e(m, t)),
                                    u(function (e, t, i, n) {
                                        var o,
                                            s,
                                            r,
                                            a = [],
                                            l = [],
                                            c = t.length,
                                            d =
                                                e ||
                                                (function (e, t, i) {
                                                    for (var n = 0, o = t.length; n < o; n++) b(e, t[n], i);
                                                    return i;
                                                })(h || "*", i.nodeType ? [i] : i, []),
                                            u = !f || (!e && h) ? d : k(d, a, f, i, n),
                                            p = v ? (m || (e ? f : c || g) ? [] : t) : u;
                                        if ((v && v(u, p, i, n), g)) for (o = k(p, l), g(o, [], i, n), s = o.length; s--; ) (r = o[s]) && (p[l[s]] = !(u[l[s]] = r));
                                        if (e) {
                                            if (m || f) {
                                                if (m) {
                                                    for (o = [], s = p.length; s--; ) (r = p[s]) && o.push((u[s] = r));
                                                    m(null, (p = []), o, n);
                                                }
                                                for (s = p.length; s--; ) (r = p[s]) && -1 < (o = m ? V(e, r) : a[s]) && (e[o] = !(t[o] = r));
                                            }
                                        } else (p = k(p === t ? p.splice(c, p.length) : p)), m ? m(null, t, p, n) : Q.apply(t, p);
                                    })
                                );
                            })(1 < a && f(d), 1 < a && v(e.slice(0, a - 1).concat({ value: " " === e[a - 2].type ? "*" : "" })).replace(ne, "$1"), t, a < i && $(e.slice(a, i)), i < n && $((e = e.slice(i))), i < n && v(e));
                        }
                        d.push(t);
                    }
                return f(d);
            }
            function g(e, t, i) {
                var n = "0x" + t - 65536;
                return n != n || i ? t : n < 0 ? String.fromCharCode(65536 + n) : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320);
            }
            function r() {
                E();
            }
            var a,
                m,
                x,
                c,
                d,
                T,
                y,
                w,
                S,
                C,
                A,
                E,
                N,
                j,
                O,
                D,
                _,
                H,
                P,
                L = "sizzle" + +new Date(),
                I = i.document,
                M = 0,
                z = 0,
                q = e(),
                F = e(),
                R = e(),
                W = function (e, t) {
                    return e === t && (A = !0), 0;
                },
                U = {}.hasOwnProperty,
                B = [],
                X = B.pop,
                Y = B.push,
                Q = B.push,
                G = B.slice,
                V = function (e, t) {
                    for (var i = 0, n = e.length; i < n; i++) if (e[i] === t) return i;
                    return -1;
                },
                K = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                Z = "[\\x20\\t\\r\\n\\f]",
                J = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
                ee = "\\[" + Z + "*(" + J + ")(?:" + Z + "*([*^$|!~]?=)" + Z + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + J + "))|)" + Z + "*\\]",
                te = ":(" + J + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + ee + ")*)|.*)\\)|)",
                ie = new RegExp(Z + "+", "g"),
                ne = new RegExp("^" + Z + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Z + "+$", "g"),
                oe = new RegExp("^" + Z + "*," + Z + "*"),
                se = new RegExp("^" + Z + "*([>+~]|" + Z + ")" + Z + "*"),
                re = new RegExp("=" + Z + "*([^\\]'\"]*?)" + Z + "*\\]", "g"),
                ae = new RegExp(te),
                le = new RegExp("^" + J + "$"),
                ce = {
                    ID: new RegExp("^#(" + J + ")"),
                    CLASS: new RegExp("^\\.(" + J + ")"),
                    TAG: new RegExp("^(" + J + "|[*])"),
                    ATTR: new RegExp("^" + ee),
                    PSEUDO: new RegExp("^" + te),
                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + Z + "*(even|odd|(([+-]|)(\\d*)n|)" + Z + "*(?:([+-]|)" + Z + "*(\\d+)|))" + Z + "*\\)|)", "i"),
                    bool: new RegExp("^(?:" + K + ")$", "i"),
                    needsContext: new RegExp("^" + Z + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + Z + "*((?:-\\d)?\\d*)" + Z + "*\\)|)(?=[^-]|$)", "i"),
                },
                de = /^(?:input|select|textarea|button)$/i,
                ue = /^h\d$/i,
                pe = /^[^{]+\{\s*\[native \w/,
                fe = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                he = /[+~]/,
                ve = /'|\\/g,
                ge = new RegExp("\\\\([\\da-f]{1,6}" + Z + "?|(" + Z + ")|.)", "ig");
            try {
                Q.apply((B = G.call(I.childNodes)), I.childNodes), B[I.childNodes.length].nodeType;
            } catch (i) {
                Q = {
                    apply: B.length
                        ? function (e, t) {
                              Y.apply(e, G.call(t));
                          }
                        : function (e, t) {
                              for (var i = e.length, n = 0; (e[i++] = t[n++]); );
                              e.length = i - 1;
                          },
                };
            }
            for (a in ((m = b.support = {}),
            (d = b.isXML = function (e) {
                var t = e && (e.ownerDocument || e).documentElement;
                return !!t && "HTML" !== t.nodeName;
            }),
            (E = b.setDocument = function (e) {
                var t,
                    i,
                    n = e ? e.ownerDocument || e : I;
                return (
                    n !== N &&
                        9 === n.nodeType &&
                        n.documentElement &&
                        ((j = (N = n).documentElement),
                        (O = !d(N)),
                        (i = N.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", r, !1) : i.attachEvent && i.attachEvent("onunload", r)),
                        (m.attributes = o(function (e) {
                            return (e.className = "i"), !e.getAttribute("className");
                        })),
                        (m.getElementsByTagName = o(function (e) {
                            return e.appendChild(N.createComment("")), !e.getElementsByTagName("*").length;
                        })),
                        (m.getElementsByClassName = pe.test(N.getElementsByClassName)),
                        (m.getById = o(function (e) {
                            return (j.appendChild(e).id = L), !N.getElementsByName || !N.getElementsByName(L).length;
                        })),
                        m.getById
                            ? ((x.find.ID = function (e, t) {
                                  if (void 0 !== t.getElementById && O) {
                                      var i = t.getElementById(e);
                                      return i ? [i] : [];
                                  }
                              }),
                              (x.filter.ID = function (e) {
                                  var t = e.replace(ge, g);
                                  return function (e) {
                                      return e.getAttribute("id") === t;
                                  };
                              }))
                            : (delete x.find.ID,
                              (x.filter.ID = function (e) {
                                  var i = e.replace(ge, g);
                                  return function (e) {
                                      var t = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                      return t && t.value === i;
                                  };
                              })),
                        (x.find.TAG = m.getElementsByTagName
                            ? function (e, t) {
                                  return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : m.qsa ? t.querySelectorAll(e) : void 0;
                              }
                            : function (e, t) {
                                  var i,
                                      n = [],
                                      o = 0,
                                      s = t.getElementsByTagName(e);
                                  if ("*" !== e) return s;
                                  for (; (i = s[o++]); ) 1 === i.nodeType && n.push(i);
                                  return n;
                              }),
                        (x.find.CLASS =
                            m.getElementsByClassName &&
                            function (e, t) {
                                return void 0 !== t.getElementsByClassName && O ? t.getElementsByClassName(e) : void 0;
                            }),
                        (_ = []),
                        (D = []),
                        (m.qsa = pe.test(N.querySelectorAll)) &&
                            (o(function (e) {
                                (j.appendChild(e).innerHTML = "<a id='" + L + "'></a><select id='" + L + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                    e.querySelectorAll("[msallowcapture^='']").length && D.push("[*^$]=" + Z + "*(?:''|\"\")"),
                                    e.querySelectorAll("[selected]").length || D.push("\\[" + Z + "*(?:value|" + K + ")"),
                                    e.querySelectorAll("[id~=" + L + "-]").length || D.push("~="),
                                    e.querySelectorAll(":checked").length || D.push(":checked"),
                                    e.querySelectorAll("a#" + L + "+*").length || D.push(".#.+[+~]");
                            }),
                            o(function (e) {
                                var t = N.createElement("input");
                                t.setAttribute("type", "hidden"),
                                    e.appendChild(t).setAttribute("name", "D"),
                                    e.querySelectorAll("[name=d]").length && D.push("name" + Z + "*[*^$|!~]?="),
                                    e.querySelectorAll(":enabled").length || D.push(":enabled", ":disabled"),
                                    e.querySelectorAll("*,:x"),
                                    D.push(",.*:");
                            })),
                        (m.matchesSelector = pe.test((H = j.matches || j.webkitMatchesSelector || j.mozMatchesSelector || j.oMatchesSelector || j.msMatchesSelector))) &&
                            o(function (e) {
                                (m.disconnectedMatch = H.call(e, "div")), H.call(e, "[s!='']:x"), _.push("!=", te);
                            }),
                        (D = D.length && new RegExp(D.join("|"))),
                        (_ = _.length && new RegExp(_.join("|"))),
                        (t = pe.test(j.compareDocumentPosition)),
                        (P =
                            t || pe.test(j.contains)
                                ? function (e, t) {
                                      var i = 9 === e.nodeType ? e.documentElement : e,
                                          n = t && t.parentNode;
                                      return e === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n)));
                                  }
                                : function (e, t) {
                                      if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                      return !1;
                                  }),
                        (W = t
                            ? function (e, t) {
                                  if (e === t) return (A = !0), 0;
                                  var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                  return (
                                      i ||
                                      (1 & (i = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!m.sortDetached && t.compareDocumentPosition(e) === i)
                                          ? e === N || (e.ownerDocument === I && P(I, e))
                                              ? -1
                                              : t === N || (t.ownerDocument === I && P(I, t))
                                              ? 1
                                              : C
                                              ? V(C, e) - V(C, t)
                                              : 0
                                          : 4 & i
                                          ? -1
                                          : 1)
                                  );
                              }
                            : function (e, t) {
                                  if (e === t) return (A = !0), 0;
                                  var i,
                                      n = 0,
                                      o = e.parentNode,
                                      s = t.parentNode,
                                      r = [e],
                                      a = [t];
                                  if (!o || !s) return e === N ? -1 : t === N ? 1 : o ? -1 : s ? 1 : C ? V(C, e) - V(C, t) : 0;
                                  if (o === s) return l(e, t);
                                  for (i = e; (i = i.parentNode); ) r.unshift(i);
                                  for (i = t; (i = i.parentNode); ) a.unshift(i);
                                  for (; r[n] === a[n]; ) n++;
                                  return n ? l(r[n], a[n]) : r[n] === I ? -1 : a[n] === I ? 1 : 0;
                              })),
                    N
                );
            }),
            (b.matches = function (e, t) {
                return b(e, null, null, t);
            }),
            (b.matchesSelector = function (e, t) {
                if (((e.ownerDocument || e) !== N && E(e), (t = t.replace(re, "='$1']")), m.matchesSelector && O && !R[t + " "] && (!_ || !_.test(t)) && (!D || !D.test(t))))
                    try {
                        var i = H.call(e, t);
                        if (i || m.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return i;
                    } catch (e) {}
                return 0 < b(t, N, null, [e]).length;
            }),
            (b.contains = function (e, t) {
                return (e.ownerDocument || e) !== N && E(e), P(e, t);
            }),
            (b.attr = function (e, t) {
                (e.ownerDocument || e) !== N && E(e);
                var i = x.attrHandle[t.toLowerCase()],
                    n = i && U.call(x.attrHandle, t.toLowerCase()) ? i(e, t, !O) : void 0;
                return void 0 !== n ? n : m.attributes || !O ? e.getAttribute(t) : (n = e.getAttributeNode(t)) && n.specified ? n.value : null;
            }),
            (b.error = function (e) {
                throw new Error("Syntax error, unrecognized expression: " + e);
            }),
            (b.uniqueSort = function (e) {
                var t,
                    i = [],
                    n = 0,
                    o = 0;
                if (((A = !m.detectDuplicates), (C = !m.sortStable && e.slice(0)), e.sort(W), A)) {
                    for (; (t = e[o++]); ) t === e[o] && (n = i.push(o));
                    for (; n--; ) e.splice(i[n], 1);
                }
                return (C = null), e;
            }),
            (c = b.getText = function (e) {
                var t,
                    i = "",
                    n = 0,
                    o = e.nodeType;
                if (o) {
                    if (1 === o || 9 === o || 11 === o) {
                        if ("string" == typeof e.textContent) return e.textContent;
                        for (e = e.firstChild; e; e = e.nextSibling) i += c(e);
                    } else if (3 === o || 4 === o) return e.nodeValue;
                } else for (; (t = e[n++]); ) i += c(t);
                return i;
            }),
            ((x = b.selectors = {
                cacheLength: 50,
                createPseudo: u,
                match: ce,
                attrHandle: {},
                find: {},
                relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
                preFilter: {
                    ATTR: function (e) {
                        return (e[1] = e[1].replace(ge, g)), (e[3] = (e[3] || e[4] || e[5] || "").replace(ge, g)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                    },
                    CHILD: function (e) {
                        return (
                            (e[1] = e[1].toLowerCase()),
                            "nth" === e[1].slice(0, 3) ? (e[3] || b.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && b.error(e[0]),
                            e
                        );
                    },
                    PSEUDO: function (e) {
                        var t,
                            i = !e[6] && e[2];
                        return ce.CHILD.test(e[0])
                            ? null
                            : (e[3] ? (e[2] = e[4] || e[5] || "") : i && ae.test(i) && (t = T(i, !0)) && (t = i.indexOf(")", i.length - t) - i.length) && ((e[0] = e[0].slice(0, t)), (e[2] = i.slice(0, t))), e.slice(0, 3));
                    },
                },
                filter: {
                    TAG: function (e) {
                        var t = e.replace(ge, g).toLowerCase();
                        return "*" === e
                            ? function () {
                                  return !0;
                              }
                            : function (e) {
                                  return e.nodeName && e.nodeName.toLowerCase() === t;
                              };
                    },
                    CLASS: function (e) {
                        var t = q[e + " "];
                        return (
                            t ||
                            ((t = new RegExp("(^|" + Z + ")" + e + "(" + Z + "|$)")) &&
                                q(e, function (e) {
                                    return t.test(("string" == typeof e.className && e.className) || (void 0 !== e.getAttribute && e.getAttribute("class")) || "");
                                }))
                        );
                    },
                    ATTR: function (i, n, o) {
                        return function (e) {
                            var t = b.attr(e, i);
                            return null == t
                                ? "!=" === n
                                : !n ||
                                      ((t += ""),
                                      "=" === n
                                          ? t === o
                                          : "!=" === n
                                          ? t !== o
                                          : "^=" === n
                                          ? o && 0 === t.indexOf(o)
                                          : "*=" === n
                                          ? o && -1 < t.indexOf(o)
                                          : "$=" === n
                                          ? o && t.slice(-o.length) === o
                                          : "~=" === n
                                          ? -1 < (" " + t.replace(ie, " ") + " ").indexOf(o)
                                          : "|=" === n && (t === o || t.slice(0, o.length + 1) === o + "-"));
                        };
                    },
                    CHILD: function (h, e, t, v, g) {
                        var m = "nth" !== h.slice(0, 3),
                            y = "last" !== h.slice(-4),
                            w = "of-type" === e;
                        return 1 === v && 0 === g
                            ? function (e) {
                                  return !!e.parentNode;
                              }
                            : function (e, t, i) {
                                  var n,
                                      o,
                                      s,
                                      r,
                                      a,
                                      l,
                                      c = m != y ? "nextSibling" : "previousSibling",
                                      d = e.parentNode,
                                      u = w && e.nodeName.toLowerCase(),
                                      p = !i && !w,
                                      f = !1;
                                  if (d) {
                                      if (m) {
                                          for (; c; ) {
                                              for (r = e; (r = r[c]); ) if (w ? r.nodeName.toLowerCase() === u : 1 === r.nodeType) return !1;
                                              l = c = "only" === h && !l && "nextSibling";
                                          }
                                          return !0;
                                      }
                                      if (((l = [y ? d.firstChild : d.lastChild]), y && p)) {
                                          for (
                                              f = (a = (n = (o = (s = (r = d)[L] || (r[L] = {}))[r.uniqueID] || (s[r.uniqueID] = {}))[h] || [])[0] === M && n[1]) && n[2], r = a && d.childNodes[a];
                                              (r = (++a && r && r[c]) || (f = a = 0) || l.pop());

                                          )
                                              if (1 === r.nodeType && ++f && r === e) {
                                                  o[h] = [M, a, f];
                                                  break;
                                              }
                                      } else if ((p && (f = a = (n = (o = (s = (r = e)[L] || (r[L] = {}))[r.uniqueID] || (s[r.uniqueID] = {}))[h] || [])[0] === M && n[1]), !1 === f))
                                          for (
                                              ;
                                              (r = (++a && r && r[c]) || (f = a = 0) || l.pop()) &&
                                              ((w ? r.nodeName.toLowerCase() !== u : 1 !== r.nodeType) || !++f || (p && ((o = (s = r[L] || (r[L] = {}))[r.uniqueID] || (s[r.uniqueID] = {}))[h] = [M, f]), r !== e));

                                          );
                                      return (f -= g) === v || (f % v == 0 && 0 <= f / v);
                                  }
                              };
                    },
                    PSEUDO: function (e, s) {
                        var t,
                            r = x.pseudos[e] || x.setFilters[e.toLowerCase()] || b.error("unsupported pseudo: " + e);
                        return r[L]
                            ? r(s)
                            : 1 < r.length
                            ? ((t = [e, e, "", s]),
                              x.setFilters.hasOwnProperty(e.toLowerCase())
                                  ? u(function (e, t) {
                                        for (var i, n = r(e, s), o = n.length; o--; ) e[(i = V(e, n[o]))] = !(t[i] = n[o]);
                                    })
                                  : function (e) {
                                        return r(e, 0, t);
                                    })
                            : r;
                    },
                },
                pseudos: {
                    not: u(function (e) {
                        var n = [],
                            o = [],
                            a = y(e.replace(ne, "$1"));
                        return a[L]
                            ? u(function (e, t, i, n) {
                                  for (var o, s = a(e, null, n, []), r = e.length; r--; ) (o = s[r]) && (e[r] = !(t[r] = o));
                              })
                            : function (e, t, i) {
                                  return (n[0] = e), a(n, null, i, o), (n[0] = null), !o.pop();
                              };
                    }),
                    has: u(function (t) {
                        return function (e) {
                            return 0 < b(t, e).length;
                        };
                    }),
                    contains: u(function (t) {
                        return (
                            (t = t.replace(ge, g)),
                            function (e) {
                                return -1 < (e.textContent || e.innerText || c(e)).indexOf(t);
                            }
                        );
                    }),
                    lang: u(function (i) {
                        return (
                            le.test(i || "") || b.error("unsupported lang: " + i),
                            (i = i.replace(ge, g).toLowerCase()),
                            function (e) {
                                var t;
                                do {
                                    if ((t = O ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))) return (t = t.toLowerCase()) === i || 0 === t.indexOf(i + "-");
                                } while ((e = e.parentNode) && 1 === e.nodeType);
                                return !1;
                            }
                        );
                    }),
                    target: function (e) {
                        var t = i.location && i.location.hash;
                        return t && t.slice(1) === e.id;
                    },
                    root: function (e) {
                        return e === j;
                    },
                    focus: function (e) {
                        return e === N.activeElement && (!N.hasFocus || N.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                    },
                    enabled: function (e) {
                        return !1 === e.disabled;
                    },
                    disabled: function (e) {
                        return !0 === e.disabled;
                    },
                    checked: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                    },
                    selected: function (e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                    },
                    empty: function (e) {
                        for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                        return !0;
                    },
                    parent: function (e) {
                        return !x.pseudos.empty(e);
                    },
                    header: function (e) {
                        return ue.test(e.nodeName);
                    },
                    input: function (e) {
                        return de.test(e.nodeName);
                    },
                    button: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && "button" === e.type) || "button" === t;
                    },
                    text: function (e) {
                        var t;
                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                    },
                    first: n(function () {
                        return [0];
                    }),
                    last: n(function (e, t) {
                        return [t - 1];
                    }),
                    eq: n(function (e, t, i) {
                        return [i < 0 ? i + t : i];
                    }),
                    even: n(function (e, t) {
                        for (var i = 0; i < t; i += 2) e.push(i);
                        return e;
                    }),
                    odd: n(function (e, t) {
                        for (var i = 1; i < t; i += 2) e.push(i);
                        return e;
                    }),
                    lt: n(function (e, t, i) {
                        for (var n = i < 0 ? i + t : i; 0 <= --n; ) e.push(n);
                        return e;
                    }),
                    gt: n(function (e, t, i) {
                        for (var n = i < 0 ? i + t : i; ++n < t; ) e.push(n);
                        return e;
                    }),
                },
            }).pseudos.nth = x.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                x.pseudos[a] = (function (t) {
                    return function (e) {
                        return "input" === e.nodeName.toLowerCase() && e.type === t;
                    };
                })(a);
            for (a in { submit: !0, reset: !0 })
                x.pseudos[a] = (function (i) {
                    return function (e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t || "button" === t) && e.type === i;
                    };
                })(a);
            return (
                (s.prototype = x.filters = x.pseudos),
                (x.setFilters = new s()),
                (T = b.tokenize = function (e, t) {
                    var i,
                        n,
                        o,
                        s,
                        r,
                        a,
                        l,
                        c = F[e + " "];
                    if (c) return t ? 0 : c.slice(0);
                    for (r = e, a = [], l = x.preFilter; r; ) {
                        for (s in ((i && !(n = oe.exec(r))) || (n && (r = r.slice(n[0].length) || r), a.push((o = []))),
                        (i = !1),
                        (n = se.exec(r)) && ((i = n.shift()), o.push({ value: i, type: n[0].replace(ne, " ") }), (r = r.slice(i.length))),
                        x.filter))
                            !(n = ce[s].exec(r)) || (l[s] && !(n = l[s](n))) || ((i = n.shift()), o.push({ value: i, type: s, matches: n }), (r = r.slice(i.length)));
                        if (!i) break;
                    }
                    return t ? r.length : r ? b.error(e) : F(e, a).slice(0);
                }),
                (y = b.compile = function (e, t) {
                    var i,
                        g,
                        m,
                        y,
                        w,
                        n = [],
                        o = [],
                        s = R[e + " "];
                    if (!s) {
                        for (i = (t = t || T(e)).length; i--; ) (s = $(t[i]))[L] ? n.push(s) : o.push(s);
                        (s = R(e, ((g = o), (y = 0 < (m = n).length), (w = 0 < g.length), y ? u(r) : r))).selector = e;
                    }
                    function r(e, t, i, n, o) {
                        var s,
                            r,
                            a,
                            l = 0,
                            c = "0",
                            d = e && [],
                            u = [],
                            p = S,
                            f = e || (w && x.find.TAG("*", o)),
                            h = (M += null == p ? 1 : Math.random() || 0.1),
                            v = f.length;
                        for (o && (S = t === N || t || o); c !== v && null != (s = f[c]); c++) {
                            if (w && s) {
                                for (r = 0, t || s.ownerDocument === N || (E(s), (i = !O)); (a = g[r++]); )
                                    if (a(s, t || N, i)) {
                                        n.push(s);
                                        break;
                                    }
                                o && (M = h);
                            }
                            y && ((s = !a && s) && l--, e && d.push(s));
                        }
                        if (((l += c), y && c !== l)) {
                            for (r = 0; (a = m[r++]); ) a(d, u, t, i);
                            if (e) {
                                if (0 < l) for (; c--; ) d[c] || u[c] || (u[c] = X.call(n));
                                u = k(u);
                            }
                            Q.apply(n, u), o && !e && 0 < u.length && 1 < l + m.length && b.uniqueSort(n);
                        }
                        return o && ((M = h), (S = p)), d;
                    }
                    return s;
                }),
                (w = b.select = function (e, t, i, n) {
                    var o,
                        s,
                        r,
                        a,
                        l,
                        c = "function" == typeof e && e,
                        d = !n && T((e = c.selector || e));
                    if (((i = i || []), 1 === d.length)) {
                        if (2 < (s = d[0] = d[0].slice(0)).length && "ID" === (r = s[0]).type && m.getById && 9 === t.nodeType && O && x.relative[s[1].type]) {
                            if (!(t = (x.find.ID(r.matches[0].replace(ge, g), t) || [])[0])) return i;
                            c && (t = t.parentNode), (e = e.slice(s.shift().value.length));
                        }
                        for (o = ce.needsContext.test(e) ? 0 : s.length; o-- && ((r = s[o]), !x.relative[(a = r.type)]); )
                            if ((l = x.find[a]) && (n = l(r.matches[0].replace(ge, g), (he.test(s[0].type) && h(t.parentNode)) || t))) {
                                if ((s.splice(o, 1), !(e = n.length && v(s)))) return Q.apply(i, n), i;
                                break;
                            }
                    }
                    return (c || y(e, d))(n, t, !O, i, !t || (he.test(e) && h(t.parentNode)) || t), i;
                }),
                (m.sortStable = L.split("").sort(W).join("") === L),
                (m.detectDuplicates = !!A),
                E(),
                (m.sortDetached = o(function (e) {
                    return 1 & e.compareDocumentPosition(N.createElement("div"));
                })),
                o(function (e) {
                    return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
                }) ||
                    t("type|href|height|width", function (e, t, i) {
                        return i ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                    }),
                (m.attributes &&
                    o(function (e) {
                        return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                    })) ||
                    t("value", function (e, t, i) {
                        return i || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue;
                    }),
                o(function (e) {
                    return null == e.getAttribute("disabled");
                }) ||
                    t(K, function (e, t, i) {
                        var n;
                        return i ? void 0 : !0 === e[t] ? t.toLowerCase() : (n = e.getAttributeNode(t)) && n.specified ? n.value : null;
                    }),
                b
            );
        })(x);
        function ne(e, t, i) {
            for (var n = [], o = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
                if (1 === e.nodeType) {
                    if (o && Z(e).is(i)) break;
                    n.push(e);
                }
            return n;
        }
        function oe(e, t) {
            for (var i = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && i.push(e);
            return i;
        }
        (Z.find = ie), (Z.expr = ie.selectors), (Z.expr[":"] = Z.expr.pseudos), (Z.uniqueSort = Z.unique = ie.uniqueSort), (Z.text = ie.getText), (Z.isXMLDoc = ie.isXML), (Z.contains = ie.contains);
        var se = Z.expr.match.needsContext,
            re = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
            ae = /^.[^:#\[\.,]*$/;
        (Z.filter = function (e, t, i) {
            var n = t[0];
            return (
                i && (e = ":not(" + e + ")"),
                1 === t.length && 1 === n.nodeType
                    ? Z.find.matchesSelector(n, e)
                        ? [n]
                        : []
                    : Z.find.matches(
                          e,
                          Z.grep(t, function (e) {
                              return 1 === e.nodeType;
                          })
                      )
            );
        }),
            Z.fn.extend({
                find: function (e) {
                    var t,
                        i = this.length,
                        n = [],
                        o = this;
                    if ("string" != typeof e)
                        return this.pushStack(
                            Z(e).filter(function () {
                                for (t = 0; t < i; t++) if (Z.contains(o[t], this)) return !0;
                            })
                        );
                    for (t = 0; t < i; t++) Z.find(e, o[t], n);
                    return ((n = this.pushStack(1 < i ? Z.unique(n) : n)).selector = this.selector ? this.selector + " " + e : e), n;
                },
                filter: function (e) {
                    return this.pushStack(t(this, e || [], !1));
                },
                not: function (e) {
                    return this.pushStack(t(this, e || [], !0));
                },
                is: function (e) {
                    return !!t(this, "string" == typeof e && se.test(e) ? Z(e) : e || [], !1).length;
                },
            });
        var le,
            ce = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
        ((Z.fn.init = function (e, t, i) {
            var n, o;
            if (!e) return this;
            if (((i = i || le), "string" != typeof e))
                return e.nodeType
                    ? ((this.context = this[0] = e), (this.length = 1), this)
                    : Z.isFunction(e)
                    ? void 0 !== i.ready
                        ? i.ready(e)
                        : e(Z)
                    : (void 0 !== e.selector && ((this.selector = e.selector), (this.context = e.context)), Z.makeArray(e, this));
            if (!(n = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : ce.exec(e)) || (!n[1] && t)) return !t || t.jquery ? (t || i).find(e) : this.constructor(t).find(e);
            if (n[1]) {
                if (((t = t instanceof Z ? t[0] : t), Z.merge(this, Z.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : W, !0)), re.test(n[1]) && Z.isPlainObject(t)))
                    for (n in t) Z.isFunction(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
                return this;
            }
            return (o = W.getElementById(n[2])) && o.parentNode && ((this.length = 1), (this[0] = o)), (this.context = W), (this.selector = e), this;
        }).prototype = Z.fn),
            (le = Z(W));
        var de = /^(?:parents|prev(?:Until|All))/,
            ue = { children: !0, contents: !0, next: !0, prev: !0 };
        Z.fn.extend({
            has: function (e) {
                var t = Z(e, this),
                    i = t.length;
                return this.filter(function () {
                    for (var e = 0; e < i; e++) if (Z.contains(this, t[e])) return !0;
                });
            },
            closest: function (e, t) {
                for (var i, n = 0, o = this.length, s = [], r = se.test(e) || "string" != typeof e ? Z(e, t || this.context) : 0; n < o; n++)
                    for (i = this[n]; i && i !== t; i = i.parentNode)
                        if (i.nodeType < 11 && (r ? -1 < r.index(i) : 1 === i.nodeType && Z.find.matchesSelector(i, e))) {
                            s.push(i);
                            break;
                        }
                return this.pushStack(1 < s.length ? Z.uniqueSort(s) : s);
            },
            index: function (e) {
                return e ? ("string" == typeof e ? Y.call(Z(e), this[0]) : Y.call(this, e.jquery ? e[0] : e)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            },
            add: function (e, t) {
                return this.pushStack(Z.uniqueSort(Z.merge(this.get(), Z(e, t))));
            },
            addBack: function (e) {
                return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
            },
        }),
            Z.each(
                {
                    parent: function (e) {
                        var t = e.parentNode;
                        return t && 11 !== t.nodeType ? t : null;
                    },
                    parents: function (e) {
                        return ne(e, "parentNode");
                    },
                    parentsUntil: function (e, t, i) {
                        return ne(e, "parentNode", i);
                    },
                    next: function (e) {
                        return i(e, "nextSibling");
                    },
                    prev: function (e) {
                        return i(e, "previousSibling");
                    },
                    nextAll: function (e) {
                        return ne(e, "nextSibling");
                    },
                    prevAll: function (e) {
                        return ne(e, "previousSibling");
                    },
                    nextUntil: function (e, t, i) {
                        return ne(e, "nextSibling", i);
                    },
                    prevUntil: function (e, t, i) {
                        return ne(e, "previousSibling", i);
                    },
                    siblings: function (e) {
                        return oe((e.parentNode || {}).firstChild, e);
                    },
                    children: function (e) {
                        return oe(e.firstChild);
                    },
                    contents: function (e) {
                        return e.contentDocument || Z.merge([], e.childNodes);
                    },
                },
                function (n, o) {
                    Z.fn[n] = function (e, t) {
                        var i = Z.map(this, o, e);
                        return "Until" !== n.slice(-5) && (t = e), t && "string" == typeof t && (i = Z.filter(t, i)), 1 < this.length && (ue[n] || Z.uniqueSort(i), de.test(n) && i.reverse()), this.pushStack(i);
                    };
                }
            );
        var pe,
            fe = /\S+/g;
        function he(e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
        }
        (Z.Callbacks = function (n) {
            var i;
            function o() {
                for (r = n.once, t = s = !0; l.length; c = -1) for (e = l.shift(); ++c < a.length; ) !1 === a[c].apply(e[0], e[1]) && n.stopOnFalse && ((c = a.length), (e = !1));
                n.memory || (e = !1), (s = !1), r && (a = e ? [] : "");
            }
            n =
                "string" == typeof n
                    ? ((i = {}),
                      Z.each(n.match(fe) || [], function (e, t) {
                          i[t] = !0;
                      }),
                      i)
                    : Z.extend({}, n);
            var s,
                e,
                t,
                r,
                a = [],
                l = [],
                c = -1,
                d = {
                    add: function () {
                        return (
                            a &&
                                (e && !s && ((c = a.length - 1), l.push(e)),
                                (function i(e) {
                                    Z.each(e, function (e, t) {
                                        Z.isFunction(t) ? (n.unique && d.has(t)) || a.push(t) : t && t.length && "string" !== Z.type(t) && i(t);
                                    });
                                })(arguments),
                                e && !s && o()),
                            this
                        );
                    },
                    remove: function () {
                        return (
                            Z.each(arguments, function (e, t) {
                                for (var i; -1 < (i = Z.inArray(t, a, i)); ) a.splice(i, 1), i <= c && c--;
                            }),
                            this
                        );
                    },
                    has: function (e) {
                        return e ? -1 < Z.inArray(e, a) : 0 < a.length;
                    },
                    empty: function () {
                        return (a = a && []), this;
                    },
                    disable: function () {
                        return (r = l = []), (a = e = ""), this;
                    },
                    disabled: function () {
                        return !a;
                    },
                    lock: function () {
                        return (r = l = []), e || (a = e = ""), this;
                    },
                    locked: function () {
                        return !!r;
                    },
                    fireWith: function (e, t) {
                        return r || ((t = [e, (t = t || []).slice ? t.slice() : t]), l.push(t), s || o()), this;
                    },
                    fire: function () {
                        return d.fireWith(this, arguments), this;
                    },
                    fired: function () {
                        return !!t;
                    },
                };
            return d;
        }),
            Z.extend({
                Deferred: function (e) {
                    var s = [
                            ["resolve", "done", Z.Callbacks("once memory"), "resolved"],
                            ["reject", "fail", Z.Callbacks("once memory"), "rejected"],
                            ["notify", "progress", Z.Callbacks("memory")],
                        ],
                        o = "pending",
                        r = {
                            state: function () {
                                return o;
                            },
                            always: function () {
                                return a.done(arguments).fail(arguments), this;
                            },
                            then: function () {
                                var o = arguments;
                                return Z.Deferred(function (n) {
                                    Z.each(s, function (e, t) {
                                        var i = Z.isFunction(o[e]) && o[e];
                                        a[t[1]](function () {
                                            var e = i && i.apply(this, arguments);
                                            e && Z.isFunction(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[t[0] + "With"](this === r ? n.promise() : this, i ? [e] : arguments);
                                        });
                                    }),
                                        (o = null);
                                }).promise();
                            },
                            promise: function (e) {
                                return null != e ? Z.extend(e, r) : r;
                            },
                        },
                        a = {};
                    return (
                        (r.pipe = r.then),
                        Z.each(s, function (e, t) {
                            var i = t[2],
                                n = t[3];
                            (r[t[1]] = i.add),
                                n &&
                                    i.add(
                                        function () {
                                            o = n;
                                        },
                                        s[1 ^ e][2].disable,
                                        s[2][2].lock
                                    ),
                                (a[t[0]] = function () {
                                    return a[t[0] + "With"](this === a ? r : this, arguments), this;
                                }),
                                (a[t[0] + "With"] = i.fireWith);
                        }),
                        r.promise(a),
                        e && e.call(a, a),
                        a
                    );
                },
                when: function (e) {
                    function t(t, i, n) {
                        return function (e) {
                            (i[t] = this), (n[t] = 1 < arguments.length ? U.call(arguments) : e), n === o ? c.notifyWith(i, n) : --l || c.resolveWith(i, n);
                        };
                    }
                    var o,
                        i,
                        n,
                        s = 0,
                        r = U.call(arguments),
                        a = r.length,
                        l = 1 !== a || (e && Z.isFunction(e.promise)) ? a : 0,
                        c = 1 === l ? e : Z.Deferred();
                    if (1 < a) for (o = new Array(a), i = new Array(a), n = new Array(a); s < a; s++) r[s] && Z.isFunction(r[s].promise) ? r[s].promise().progress(t(s, i, o)).done(t(s, n, r)).fail(c.reject) : --l;
                    return l || c.resolveWith(n, r), c.promise();
                },
            }),
            (Z.fn.ready = function (e) {
                return Z.ready.promise().done(e), this;
            }),
            Z.extend({
                isReady: !1,
                readyWait: 1,
                holdReady: function (e) {
                    e ? Z.readyWait++ : Z.ready(!0);
                },
                ready: function (e) {
                    (!0 === e ? --Z.readyWait : Z.isReady) || ((Z.isReady = !0) !== e && 0 < --Z.readyWait) || (pe.resolveWith(W, [Z]), Z.fn.triggerHandler && (Z(W).triggerHandler("ready"), Z(W).off("ready")));
                },
            }),
            (Z.ready.promise = function (e) {
                return (
                    pe ||
                        ((pe = Z.Deferred()), "complete" === W.readyState || ("loading" !== W.readyState && !W.documentElement.doScroll) ? x.setTimeout(Z.ready) : (W.addEventListener("DOMContentLoaded", n), x.addEventListener("load", n))),
                    pe.promise(e)
                );
            }),
            Z.ready.promise();
        var ve = function (e, t, i, n, o, s, r) {
            var a = 0,
                l = e.length,
                c = null == i;
            if ("object" === Z.type(i)) for (a in ((o = !0), i)) ve(e, t, a, i[a], !0, s, r);
            else if (
                void 0 !== n &&
                ((o = !0),
                Z.isFunction(n) || (r = !0),
                c &&
                    (t = r
                        ? (t.call(e, n), null)
                        : ((c = t),
                          function (e, t, i) {
                              return c.call(Z(e), i);
                          })),
                t)
            )
                for (; a < l; a++) t(e[a], i, r ? n : n.call(e[a], a, t(e[a], i)));
            return o ? e : c ? t.call(e) : l ? t(e[0], i) : s;
        };
        (o.uid = 1),
            (o.prototype = {
                register: function (e, t) {
                    var i = t || {};
                    return e.nodeType ? (e[this.expando] = i) : Object.defineProperty(e, this.expando, { value: i, writable: !0, configurable: !0 }), e[this.expando];
                },
                cache: function (e) {
                    if (!he(e)) return {};
                    var t = e[this.expando];
                    return t || ((t = {}), he(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
                },
                set: function (e, t, i) {
                    var n,
                        o = this.cache(e);
                    if ("string" == typeof t) o[t] = i;
                    else for (n in t) o[n] = t[n];
                    return o;
                },
                get: function (e, t) {
                    return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][t];
                },
                access: function (e, t, i) {
                    var n;
                    return void 0 === t || (t && "string" == typeof t && void 0 === i) ? (void 0 !== (n = this.get(e, t)) ? n : this.get(e, Z.camelCase(t))) : (this.set(e, t, i), void 0 !== i ? i : t);
                },
                remove: function (e, t) {
                    var i,
                        n,
                        o,
                        s = e[this.expando];
                    if (void 0 !== s) {
                        if (void 0 === t) this.register(e);
                        else {
                            i = (n = Z.isArray(t) ? t.concat(t.map(Z.camelCase)) : ((o = Z.camelCase(t)), t in s ? [t, o] : (n = o) in s ? [n] : n.match(fe) || [])).length;
                            for (; i--; ) delete s[n[i]];
                        }
                        (void 0 !== t && !Z.isEmptyObject(s)) || (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                    }
                },
                hasData: function (e) {
                    var t = e[this.expando];
                    return void 0 !== t && !Z.isEmptyObject(t);
                },
            });
        var ge = new o(),
            me = new o(),
            ye = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            we = /[A-Z]/g;
        function be(e, t) {
            return (e = t || e), "none" === Z.css(e, "display") || !Z.contains(e.ownerDocument, e);
        }
        Z.extend({
            hasData: function (e) {
                return me.hasData(e) || ge.hasData(e);
            },
            data: function (e, t, i) {
                return me.access(e, t, i);
            },
            removeData: function (e, t) {
                me.remove(e, t);
            },
            _data: function (e, t, i) {
                return ge.access(e, t, i);
            },
            _removeData: function (e, t) {
                ge.remove(e, t);
            },
        }),
            Z.fn.extend({
                data: function (n, e) {
                    var t,
                        i,
                        o,
                        s = this[0],
                        r = s && s.attributes;
                    if (void 0 !== n)
                        return "object" == typeof n
                            ? this.each(function () {
                                  me.set(this, n);
                              })
                            : ve(
                                  this,
                                  function (t) {
                                      var e, i;
                                      if (s && void 0 === t) {
                                          if (void 0 !== (e = me.get(s, n) || me.get(s, n.replace(we, "-$&").toLowerCase()))) return e;
                                          if (((i = Z.camelCase(n)), void 0 !== (e = me.get(s, i)))) return e;
                                          if (void 0 !== (e = l(s, i, void 0))) return e;
                                      } else
                                          (i = Z.camelCase(n)),
                                              this.each(function () {
                                                  var e = me.get(this, i);
                                                  me.set(this, i, t), -1 < n.indexOf("-") && void 0 !== e && me.set(this, n, t);
                                              });
                                  },
                                  null,
                                  e,
                                  1 < arguments.length,
                                  null,
                                  !0
                              );
                    if (this.length && ((o = me.get(s)), 1 === s.nodeType && !ge.get(s, "hasDataAttrs"))) {
                        for (t = r.length; t--; ) r[t] && 0 === (i = r[t].name).indexOf("data-") && ((i = Z.camelCase(i.slice(5))), l(s, i, o[i]));
                        ge.set(s, "hasDataAttrs", !0);
                    }
                    return o;
                },
                removeData: function (e) {
                    return this.each(function () {
                        me.remove(this, e);
                    });
                },
            }),
            Z.extend({
                queue: function (e, t, i) {
                    var n;
                    return e ? ((t = (t || "fx") + "queue"), (n = ge.get(e, t)), i && (!n || Z.isArray(i) ? (n = ge.access(e, t, Z.makeArray(i))) : n.push(i)), n || []) : void 0;
                },
                dequeue: function (e, t) {
                    t = t || "fx";
                    var i = Z.queue(e, t),
                        n = i.length,
                        o = i.shift(),
                        s = Z._queueHooks(e, t);
                    "inprogress" === o && ((o = i.shift()), n--),
                        o &&
                            ("fx" === t && i.unshift("inprogress"),
                            delete s.stop,
                            o.call(
                                e,
                                function () {
                                    Z.dequeue(e, t);
                                },
                                s
                            )),
                        !n && s && s.empty.fire();
                },
                _queueHooks: function (e, t) {
                    var i = t + "queueHooks";
                    return (
                        ge.get(e, i) ||
                        ge.access(e, i, {
                            empty: Z.Callbacks("once memory").add(function () {
                                ge.remove(e, [t + "queue", i]);
                            }),
                        })
                    );
                },
            }),
            Z.fn.extend({
                queue: function (t, i) {
                    var e = 2;
                    return (
                        "string" != typeof t && ((i = t), (t = "fx"), e--),
                        arguments.length < e
                            ? Z.queue(this[0], t)
                            : void 0 === i
                            ? this
                            : this.each(function () {
                                  var e = Z.queue(this, t, i);
                                  Z._queueHooks(this, t), "fx" === t && "inprogress" !== e[0] && Z.dequeue(this, t);
                              })
                    );
                },
                dequeue: function (e) {
                    return this.each(function () {
                        Z.dequeue(this, e);
                    });
                },
                clearQueue: function (e) {
                    return this.queue(e || "fx", []);
                },
                promise: function (e, t) {
                    function i() {
                        --o || s.resolveWith(r, [r]);
                    }
                    var n,
                        o = 1,
                        s = Z.Deferred(),
                        r = this,
                        a = this.length;
                    for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; a--; ) (n = ge.get(r[a], e + "queueHooks")) && n.empty && (o++, n.empty.add(i));
                    return i(), s.promise(t);
                },
            });
        var ke = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            $e = new RegExp("^(?:([+-])=|)(" + ke + ")([a-z%]*)$", "i"),
            xe = ["Top", "Right", "Bottom", "Left"],
            Te = /^(?:checkbox|radio)$/i,
            Se = /<([\w:-]+)/,
            Ce = /^$|\/(?:java|ecma)script/i,
            Ae = {
                option: [1, "<select multiple='multiple'>", "</select>"],
                thead: [1, "<table>", "</table>"],
                col: [2, "<table><colgroup>", "</colgroup></table>"],
                tr: [2, "<table><tbody>", "</tbody></table>"],
                td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                _default: [0, "", ""],
            };
        (Ae.optgroup = Ae.option), (Ae.tbody = Ae.tfoot = Ae.colgroup = Ae.caption = Ae.thead), (Ae.th = Ae.td);
        var Ee,
            Ne = /<|&#?\w+;/,
            je = W.createDocumentFragment().appendChild(W.createElement("div"));
        (Ee = W.createElement("input")).setAttribute("type", "radio"),
            Ee.setAttribute("checked", "checked"),
            Ee.setAttribute("name", "t"),
            je.appendChild(Ee),
            (K.checkClone = je.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (je.innerHTML = "<textarea>x</textarea>"),
            (K.noCloneChecked = !!je.cloneNode(!0).lastChild.defaultValue);
        var Oe = /^key/,
            De = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            _e = /^([^.]*)(?:\.(.+)|)/;
        (Z.event = {
            global: {},
            add: function (t, e, i, n, o) {
                var s,
                    r,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p,
                    f,
                    h,
                    v,
                    g = ge.get(t);
                if (g)
                    for (
                        i.handler && ((i = (s = i).handler), (o = s.selector)),
                            i.guid || (i.guid = Z.guid++),
                            (l = g.events) || (l = g.events = {}),
                            (r = g.handle) ||
                                (r = g.handle = function (e) {
                                    return void 0 !== Z && Z.event.triggered !== e.type ? Z.event.dispatch.apply(t, arguments) : void 0;
                                }),
                            c = (e = (e || "").match(fe) || [""]).length;
                        c--;

                    )
                        (f = v = (a = _e.exec(e[c]) || [])[1]),
                            (h = (a[2] || "").split(".").sort()),
                            f &&
                                ((u = Z.event.special[f] || {}),
                                (f = (o ? u.delegateType : u.bindType) || f),
                                (u = Z.event.special[f] || {}),
                                (d = Z.extend({ type: f, origType: v, data: n, handler: i, guid: i.guid, selector: o, needsContext: o && Z.expr.match.needsContext.test(o), namespace: h.join(".") }, s)),
                                (p = l[f]) || (((p = l[f] = []).delegateCount = 0), (u.setup && !1 !== u.setup.call(t, n, h, r)) || (t.addEventListener && t.addEventListener(f, r))),
                                u.add && (u.add.call(t, d), d.handler.guid || (d.handler.guid = i.guid)),
                                o ? p.splice(p.delegateCount++, 0, d) : p.push(d),
                                (Z.event.global[f] = !0));
            },
            remove: function (e, t, i, n, o) {
                var s,
                    r,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p,
                    f,
                    h,
                    v,
                    g = ge.hasData(e) && ge.get(e);
                if (g && (l = g.events)) {
                    for (c = (t = (t || "").match(fe) || [""]).length; c--; )
                        if (((f = v = (a = _e.exec(t[c]) || [])[1]), (h = (a[2] || "").split(".").sort()), f)) {
                            for (u = Z.event.special[f] || {}, p = l[(f = (n ? u.delegateType : u.bindType) || f)] || [], a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), r = s = p.length; s--; )
                                (d = p[s]),
                                    (!o && v !== d.origType) ||
                                        (i && i.guid !== d.guid) ||
                                        (a && !a.test(d.namespace)) ||
                                        (n && n !== d.selector && ("**" !== n || !d.selector)) ||
                                        (p.splice(s, 1), d.selector && p.delegateCount--, u.remove && u.remove.call(e, d));
                            r && !p.length && ((u.teardown && !1 !== u.teardown.call(e, h, g.handle)) || Z.removeEvent(e, f, g.handle), delete l[f]);
                        } else for (f in l) Z.event.remove(e, f + t[c], i, n, !0);
                    Z.isEmptyObject(l) && ge.remove(e, "handle events");
                }
            },
            dispatch: function (e) {
                e = Z.event.fix(e);
                var t,
                    i,
                    n,
                    o,
                    s,
                    r = [],
                    a = U.call(arguments),
                    l = (ge.get(this, "events") || {})[e.type] || [],
                    c = Z.event.special[e.type] || {};
                if ((((a[0] = e).delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, e))) {
                    for (r = Z.event.handlers.call(this, e, l), t = 0; (o = r[t++]) && !e.isPropagationStopped(); )
                        for (e.currentTarget = o.elem, i = 0; (s = o.handlers[i++]) && !e.isImmediatePropagationStopped(); )
                            (e.rnamespace && !e.rnamespace.test(s.namespace)) ||
                                ((e.handleObj = s), (e.data = s.data), void 0 !== (n = ((Z.event.special[s.origType] || {}).handle || s.handler).apply(o.elem, a)) && !1 === (e.result = n) && (e.preventDefault(), e.stopPropagation()));
                    return c.postDispatch && c.postDispatch.call(this, e), e.result;
                }
            },
            handlers: function (e, t) {
                var i,
                    n,
                    o,
                    s,
                    r = [],
                    a = t.delegateCount,
                    l = e.target;
                if (a && l.nodeType && ("click" !== e.type || isNaN(e.button) || e.button < 1))
                    for (; l !== this; l = l.parentNode || this)
                        if (1 === l.nodeType && (!0 !== l.disabled || "click" !== e.type)) {
                            for (n = [], i = 0; i < a; i++) void 0 === n[(o = (s = t[i]).selector + " ")] && (n[o] = s.needsContext ? -1 < Z(o, this).index(l) : Z.find(o, this, null, [l]).length), n[o] && n.push(s);
                            n.length && r.push({ elem: l, handlers: n });
                        }
                return a < t.length && r.push({ elem: this, handlers: t.slice(a) }), r;
            },
            props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
            fixHooks: {},
            keyHooks: {
                props: "char charCode key keyCode".split(" "),
                filter: function (e, t) {
                    return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e;
                },
            },
            mouseHooks: {
                props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
                filter: function (e, t) {
                    var i,
                        n,
                        o,
                        s = t.button;
                    return (
                        null == e.pageX &&
                            null != t.clientX &&
                            ((n = (i = e.target.ownerDocument || W).documentElement),
                            (o = i.body),
                            (e.pageX = t.clientX + ((n && n.scrollLeft) || (o && o.scrollLeft) || 0) - ((n && n.clientLeft) || (o && o.clientLeft) || 0)),
                            (e.pageY = t.clientY + ((n && n.scrollTop) || (o && o.scrollTop) || 0) - ((n && n.clientTop) || (o && o.clientTop) || 0))),
                        e.which || void 0 === s || (e.which = 1 & s ? 1 : 2 & s ? 3 : 4 & s ? 2 : 0),
                        e
                    );
                },
            },
            fix: function (e) {
                if (e[Z.expando]) return e;
                var t,
                    i,
                    n,
                    o = e.type,
                    s = e,
                    r = this.fixHooks[o];
                for (r || (this.fixHooks[o] = r = De.test(o) ? this.mouseHooks : Oe.test(o) ? this.keyHooks : {}), n = r.props ? this.props.concat(r.props) : this.props, e = new Z.Event(s), t = n.length; t--; ) e[(i = n[t])] = s[i];
                return e.target || (e.target = W), 3 === e.target.nodeType && (e.target = e.target.parentNode), r.filter ? r.filter(e, s) : e;
            },
            special: {
                load: { noBubble: !0 },
                focus: {
                    trigger: function () {
                        return this !== r() && this.focus ? (this.focus(), !1) : void 0;
                    },
                    delegateType: "focusin",
                },
                blur: {
                    trigger: function () {
                        return this === r() && this.blur ? (this.blur(), !1) : void 0;
                    },
                    delegateType: "focusout",
                },
                click: {
                    trigger: function () {
                        return "checkbox" === this.type && this.click && Z.nodeName(this, "input") ? (this.click(), !1) : void 0;
                    },
                    _default: function (e) {
                        return Z.nodeName(e.target, "a");
                    },
                },
                beforeunload: {
                    postDispatch: function (e) {
                        void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                    },
                },
            },
        }),
            (Z.removeEvent = function (e, t, i) {
                e.removeEventListener && e.removeEventListener(t, i);
            }),
            (Z.Event = function (e, t) {
                return this instanceof Z.Event
                    ? (e && e.type ? ((this.originalEvent = e), (this.type = e.type), (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? s : d)) : (this.type = e),
                      t && Z.extend(this, t),
                      (this.timeStamp = (e && e.timeStamp) || Z.now()),
                      void (this[Z.expando] = !0))
                    : new Z.Event(e, t);
            }),
            (Z.Event.prototype = {
                constructor: Z.Event,
                isDefaultPrevented: d,
                isPropagationStopped: d,
                isImmediatePropagationStopped: d,
                preventDefault: function () {
                    var e = this.originalEvent;
                    (this.isDefaultPrevented = s), e && e.preventDefault();
                },
                stopPropagation: function () {
                    var e = this.originalEvent;
                    (this.isPropagationStopped = s), e && e.stopPropagation();
                },
                stopImmediatePropagation: function () {
                    var e = this.originalEvent;
                    (this.isImmediatePropagationStopped = s), e && e.stopImmediatePropagation(), this.stopPropagation();
                },
            }),
            Z.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, o) {
                Z.event.special[e] = {
                    delegateType: o,
                    bindType: o,
                    handle: function (e) {
                        var t,
                            i = e.relatedTarget,
                            n = e.handleObj;
                        return (i && (i === this || Z.contains(this, i))) || ((e.type = n.origType), (t = n.handler.apply(this, arguments)), (e.type = o)), t;
                    },
                };
            }),
            Z.fn.extend({
                on: function (e, t, i, n) {
                    return u(this, e, t, i, n);
                },
                one: function (e, t, i, n) {
                    return u(this, e, t, i, n, 1);
                },
                off: function (e, t, i) {
                    var n, o;
                    if (e && e.preventDefault && e.handleObj) return (n = e.handleObj), Z(e.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
                    if ("object" != typeof e)
                        return (
                            (!1 !== t && "function" != typeof t) || ((i = t), (t = void 0)),
                            !1 === i && (i = d),
                            this.each(function () {
                                Z.event.remove(this, e, i, t);
                            })
                        );
                    for (o in e) this.off(o, t, e[o]);
                    return this;
                },
            });
        var He = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
            Pe = /<script|<style|<link/i,
            Le = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Ie = /^true\/(.*)/,
            Me = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
        function ze(e, t, i, n) {
            var o,
                s,
                r = {};
            for (s in t) (r[s] = e.style[s]), (e.style[s] = t[s]);
            for (s in ((o = i.apply(e, n || [])), t)) e.style[s] = r[s];
            return o;
        }
        Z.extend({
            htmlPrefilter: function (e) {
                return e.replace(He, "<$1></$2>");
            },
            clone: function (e, t, i) {
                var n,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c,
                    d = e.cloneNode(!0),
                    u = Z.contains(e.ownerDocument, e);
                if (!(K.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || Z.isXMLDoc(e)))
                    for (r = v(d), n = 0, o = (s = v(e)).length; n < o; n++)
                        (a = s[n]), "input" === (c = (l = r[n]).nodeName.toLowerCase()) && Te.test(a.type) ? (l.checked = a.checked) : ("input" !== c && "textarea" !== c) || (l.defaultValue = a.defaultValue);
                if (t)
                    if (i) for (s = s || v(e), r = r || v(d), n = 0, o = s.length; n < o; n++) f(s[n], r[n]);
                    else f(e, d);
                return 0 < (r = v(d, "script")).length && g(r, !u && v(e, "script")), d;
            },
            cleanData: function (e) {
                for (var t, i, n, o = Z.event.special, s = 0; void 0 !== (i = e[s]); s++)
                    if (he(i)) {
                        if ((t = i[ge.expando])) {
                            if (t.events) for (n in t.events) o[n] ? Z.event.remove(i, n) : Z.removeEvent(i, n, t.handle);
                            i[ge.expando] = void 0;
                        }
                        i[me.expando] && (i[me.expando] = void 0);
                    }
            },
        }),
            Z.fn.extend({
                domManip: b,
                detach: function (e) {
                    return h(this, e, !0);
                },
                remove: function (e) {
                    return h(this, e);
                },
                text: function (e) {
                    return ve(
                        this,
                        function (e) {
                            return void 0 === e
                                ? Z.text(this)
                                : this.empty().each(function () {
                                      (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                                  });
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                append: function () {
                    return b(this, arguments, function (e) {
                        (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || p(this, e).appendChild(e);
                    });
                },
                prepend: function () {
                    return b(this, arguments, function (e) {
                        var t;
                        (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (t = p(this, e)).insertBefore(e, t.firstChild);
                    });
                },
                before: function () {
                    return b(this, arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this);
                    });
                },
                after: function () {
                    return b(this, arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                    });
                },
                empty: function () {
                    for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (Z.cleanData(v(e, !1)), (e.textContent = ""));
                    return this;
                },
                clone: function (e, t) {
                    return (
                        (e = null != e && e),
                        (t = null == t ? e : t),
                        this.map(function () {
                            return Z.clone(this, e, t);
                        })
                    );
                },
                html: function (e) {
                    return ve(
                        this,
                        function (e) {
                            var t = this[0] || {},
                                i = 0,
                                n = this.length;
                            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                            if ("string" == typeof e && !Pe.test(e) && !Ae[(Se.exec(e) || ["", ""])[1].toLowerCase()]) {
                                e = Z.htmlPrefilter(e);
                                try {
                                    for (; i < n; i++) 1 === (t = this[i] || {}).nodeType && (Z.cleanData(v(t, !1)), (t.innerHTML = e));
                                    t = 0;
                                } catch (e) {}
                            }
                            t && this.empty().append(e);
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                replaceWith: function () {
                    var i = [];
                    return b(
                        this,
                        arguments,
                        function (e) {
                            var t = this.parentNode;
                            Z.inArray(this, i) < 0 && (Z.cleanData(v(this)), t && t.replaceChild(e, this));
                        },
                        i
                    );
                },
            }),
            Z.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, r) {
                Z.fn[e] = function (e) {
                    for (var t, i = [], n = Z(e), o = n.length - 1, s = 0; s <= o; s++) (t = s === o ? this : this.clone(!0)), Z(n[s])[r](t), X.apply(i, t.get());
                    return this.pushStack(i);
                };
            });
        var qe,
            Fe,
            Re,
            We,
            Ue,
            Be,
            Xe,
            Ye = { HTML: "block", BODY: "block" },
            Qe = /^margin/,
            Ge = new RegExp("^(" + ke + ")(?!px)[a-z%]+$", "i"),
            Ve = function (e) {
                var t = e.ownerDocument.defaultView;
                return (t && t.opener) || (t = x), t.getComputedStyle(e);
            },
            Ke = W.documentElement;
        function Ze() {
            (Xe.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"), (Xe.innerHTML = ""), Ke.appendChild(Be);
            var e = x.getComputedStyle(Xe);
            (Fe = "1%" !== e.top), (Ue = "2px" === e.marginLeft), (Re = "4px" === e.width), (Xe.style.marginRight = "50%"), (We = "4px" === e.marginRight), Ke.removeChild(Be);
        }
        (Be = W.createElement("div")),
            (Xe = W.createElement("div")).style &&
                ((Xe.style.backgroundClip = "content-box"),
                (Xe.cloneNode(!0).style.backgroundClip = ""),
                (K.clearCloneStyle = "content-box" === Xe.style.backgroundClip),
                (Be.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
                Be.appendChild(Xe),
                Z.extend(K, {
                    pixelPosition: function () {
                        return Ze(), Fe;
                    },
                    boxSizingReliable: function () {
                        return null == Re && Ze(), Re;
                    },
                    pixelMarginRight: function () {
                        return null == Re && Ze(), We;
                    },
                    reliableMarginLeft: function () {
                        return null == Re && Ze(), Ue;
                    },
                    reliableMarginRight: function () {
                        var e,
                            t = Xe.appendChild(W.createElement("div"));
                        return (
                            (t.style.cssText = Xe.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
                            (t.style.marginRight = t.style.width = "0"),
                            (Xe.style.width = "1px"),
                            Ke.appendChild(Be),
                            (e = !parseFloat(x.getComputedStyle(t).marginRight)),
                            Ke.removeChild(Be),
                            Xe.removeChild(t),
                            e
                        );
                    },
                }));
        var Je = /^(none|table(?!-c[ea]).+)/,
            et = { position: "absolute", visibility: "hidden", display: "block" },
            tt = { letterSpacing: "0", fontWeight: "400" },
            it = ["Webkit", "O", "Moz", "ms"],
            nt = W.createElement("div").style;
        Z.extend({
            cssHooks: {
                opacity: {
                    get: function (e, t) {
                        if (t) {
                            var i = T(e, "opacity");
                            return "" === i ? "1" : i;
                        }
                    },
                },
            },
            cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 },
            cssProps: { float: "cssFloat" },
            style: function (e, t, i, n) {
                if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                    var o,
                        s,
                        r,
                        a = Z.camelCase(t),
                        l = e.style;
                    return (
                        (t = Z.cssProps[a] || (Z.cssProps[a] = C(a) || a)),
                        (r = Z.cssHooks[t] || Z.cssHooks[a]),
                        void 0 === i
                            ? r && "get" in r && void 0 !== (o = r.get(e, !1, n))
                                ? o
                                : l[t]
                            : ("string" == (s = typeof i) && (o = $e.exec(i)) && o[1] && ((i = c(e, t, o)), (s = "number")),
                              void (
                                  null != i &&
                                  i == i &&
                                  ("number" === s && (i += (o && o[3]) || (Z.cssNumber[a] ? "" : "px")),
                                  K.clearCloneStyle || "" !== i || 0 !== t.indexOf("background") || (l[t] = "inherit"),
                                  (r && "set" in r && void 0 === (i = r.set(e, i, n))) || (l[t] = i))
                              ))
                    );
                }
            },
            css: function (e, t, i, n) {
                var o,
                    s,
                    r,
                    a = Z.camelCase(t);
                return (
                    (t = Z.cssProps[a] || (Z.cssProps[a] = C(a) || a)),
                    (r = Z.cssHooks[t] || Z.cssHooks[a]) && "get" in r && (o = r.get(e, !0, i)),
                    void 0 === o && (o = T(e, t, n)),
                    "normal" === o && t in tt && (o = tt[t]),
                    "" === i || i ? ((s = parseFloat(o)), !0 === i || isFinite(s) ? s || 0 : o) : o
                );
            },
        }),
            Z.each(["height", "width"], function (e, r) {
                Z.cssHooks[r] = {
                    get: function (e, t, i) {
                        return t
                            ? Je.test(Z.css(e, "display")) && 0 === e.offsetWidth
                                ? ze(e, et, function () {
                                      return N(e, r, i);
                                  })
                                : N(e, r, i)
                            : void 0;
                    },
                    set: function (e, t, i) {
                        var n,
                            o = i && Ve(e),
                            s = i && E(e, r, i, "border-box" === Z.css(e, "boxSizing", !1, o), o);
                        return s && (n = $e.exec(t)) && "px" !== (n[3] || "px") && ((e.style[r] = t), (t = Z.css(e, r))), A(0, t, s);
                    },
                };
            }),
            (Z.cssHooks.marginLeft = S(K.reliableMarginLeft, function (e, t) {
                return t
                    ? (parseFloat(T(e, "marginLeft")) ||
                          e.getBoundingClientRect().left -
                              ze(e, { marginLeft: 0 }, function () {
                                  return e.getBoundingClientRect().left;
                              })) + "px"
                    : void 0;
            })),
            (Z.cssHooks.marginRight = S(K.reliableMarginRight, function (e, t) {
                return t ? ze(e, { display: "inline-block" }, T, [e, "marginRight"]) : void 0;
            })),
            Z.each({ margin: "", padding: "", border: "Width" }, function (o, s) {
                (Z.cssHooks[o + s] = {
                    expand: function (e) {
                        for (var t = 0, i = {}, n = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++) i[o + xe[t] + s] = n[t] || n[t - 2] || n[0];
                        return i;
                    },
                }),
                    Qe.test(o) || (Z.cssHooks[o + s].set = A);
            }),
            Z.fn.extend({
                css: function (e, t) {
                    return ve(
                        this,
                        function (e, t, i) {
                            var n,
                                o,
                                s = {},
                                r = 0;
                            if (Z.isArray(t)) {
                                for (n = Ve(e), o = t.length; r < o; r++) s[t[r]] = Z.css(e, t[r], !1, n);
                                return s;
                            }
                            return void 0 !== i ? Z.style(e, t, i) : Z.css(e, t);
                        },
                        e,
                        t,
                        1 < arguments.length
                    );
                },
                show: function () {
                    return j(this, !0);
                },
                hide: function () {
                    return j(this);
                },
                toggle: function (e) {
                    return "boolean" == typeof e
                        ? e
                            ? this.show()
                            : this.hide()
                        : this.each(function () {
                              be(this) ? Z(this).show() : Z(this).hide();
                          });
                },
            }),
            (((Z.Tween = O).prototype = {
                constructor: O,
                init: function (e, t, i, n, o, s) {
                    (this.elem = e), (this.prop = i), (this.easing = o || Z.easing._default), (this.options = t), (this.start = this.now = this.cur()), (this.end = n), (this.unit = s || (Z.cssNumber[i] ? "" : "px"));
                },
                cur: function () {
                    var e = O.propHooks[this.prop];
                    return e && e.get ? e.get(this) : O.propHooks._default.get(this);
                },
                run: function (e) {
                    var t,
                        i = O.propHooks[this.prop];
                    return (
                        this.options.duration ? (this.pos = t = Z.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration)) : (this.pos = t = e),
                        (this.now = (this.end - this.start) * t + this.start),
                        this.options.step && this.options.step.call(this.elem, this.now, this),
                        i && i.set ? i.set(this) : O.propHooks._default.set(this),
                        this
                    );
                },
            }).init.prototype = O.prototype),
            ((O.propHooks = {
                _default: {
                    get: function (e) {
                        var t;
                        return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop]) ? e.elem[e.prop] : (t = Z.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
                    },
                    set: function (e) {
                        Z.fx.step[e.prop] ? Z.fx.step[e.prop](e) : 1 !== e.elem.nodeType || (null == e.elem.style[Z.cssProps[e.prop]] && !Z.cssHooks[e.prop]) ? (e.elem[e.prop] = e.now) : Z.style(e.elem, e.prop, e.now + e.unit);
                    },
                },
            }).scrollTop = O.propHooks.scrollLeft = {
                set: function (e) {
                    e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                },
            }),
            (Z.easing = {
                linear: function (e) {
                    return e;
                },
                swing: function (e) {
                    return 0.5 - Math.cos(e * Math.PI) / 2;
                },
                _default: "swing",
            }),
            (Z.fx = O.prototype.init),
            (Z.fx.step = {});
        var ot,
            st,
            rt,
            at,
            lt,
            ct = /^(?:toggle|show|hide)$/,
            dt = /queueHooks$/;
        (Z.Animation = Z.extend(P, {
            tweeners: {
                "*": [
                    function (e, t) {
                        var i = this.createTween(e, t);
                        return c(i.elem, e, $e.exec(t), i), i;
                    },
                ],
            },
            tweener: function (e, t) {
                for (var i, n = 0, o = (e = Z.isFunction(e) ? ((t = e), ["*"]) : e.match(fe)).length; n < o; n++) (i = e[n]), (P.tweeners[i] = P.tweeners[i] || []), P.tweeners[i].unshift(t);
            },
            prefilters: [
                function (t, e, i) {
                    var n,
                        o,
                        s,
                        r,
                        a,
                        l,
                        c,
                        d = this,
                        u = {},
                        p = t.style,
                        f = t.nodeType && be(t),
                        h = ge.get(t, "fxshow");
                    for (n in (i.queue ||
                        (null == (a = Z._queueHooks(t, "fx")).unqueued &&
                            ((a.unqueued = 0),
                            (l = a.empty.fire),
                            (a.empty.fire = function () {
                                a.unqueued || l();
                            })),
                        a.unqueued++,
                        d.always(function () {
                            d.always(function () {
                                a.unqueued--, Z.queue(t, "fx").length || a.empty.fire();
                            });
                        })),
                    1 === t.nodeType &&
                        ("height" in e || "width" in e) &&
                        ((i.overflow = [p.overflow, p.overflowX, p.overflowY]),
                        "inline" === ("none" === (c = Z.css(t, "display")) ? ge.get(t, "olddisplay") || $(t.nodeName) : c) && "none" === Z.css(t, "float") && (p.display = "inline-block")),
                    i.overflow &&
                        ((p.overflow = "hidden"),
                        d.always(function () {
                            (p.overflow = i.overflow[0]), (p.overflowX = i.overflow[1]), (p.overflowY = i.overflow[2]);
                        })),
                    e))
                        if (((o = e[n]), ct.exec(o))) {
                            if ((delete e[n], (s = s || "toggle" === o), o === (f ? "hide" : "show"))) {
                                if ("show" !== o || !h || void 0 === h[n]) continue;
                                f = !0;
                            }
                            u[n] = (h && h[n]) || Z.style(t, n);
                        } else c = void 0;
                    if (Z.isEmptyObject(u)) "inline" === ("none" === c ? $(t.nodeName) : c) && (p.display = c);
                    else
                        for (n in (h ? "hidden" in h && (f = h.hidden) : (h = ge.access(t, "fxshow", {})),
                        s && (h.hidden = !f),
                        f
                            ? Z(t).show()
                            : d.done(function () {
                                  Z(t).hide();
                              }),
                        d.done(function () {
                            var e;
                            for (e in (ge.remove(t, "fxshow"), u)) Z.style(t, e, u[e]);
                        }),
                        u))
                            (r = H(f ? h[n] : 0, n, d)), n in h || ((h[n] = r.start), f && ((r.end = r.start), (r.start = "width" === n || "height" === n ? 1 : 0)));
                },
            ],
            prefilter: function (e, t) {
                t ? P.prefilters.unshift(e) : P.prefilters.push(e);
            },
        })),
            (Z.speed = function (e, t, i) {
                var n = e && "object" == typeof e ? Z.extend({}, e) : { complete: i || (!i && t) || (Z.isFunction(e) && e), duration: e, easing: (i && t) || (t && !Z.isFunction(t) && t) };
                return (
                    (n.duration = Z.fx.off ? 0 : "number" == typeof n.duration ? n.duration : n.duration in Z.fx.speeds ? Z.fx.speeds[n.duration] : Z.fx.speeds._default),
                    (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
                    (n.old = n.complete),
                    (n.complete = function () {
                        Z.isFunction(n.old) && n.old.call(this), n.queue && Z.dequeue(this, n.queue);
                    }),
                    n
                );
            }),
            Z.fn.extend({
                fadeTo: function (e, t, i, n) {
                    return this.filter(be).css("opacity", 0).show().end().animate({ opacity: t }, e, i, n);
                },
                animate: function (t, e, i, n) {
                    function o() {
                        var e = P(this, Z.extend({}, t), r);
                        (s || ge.get(this, "finish")) && e.stop(!0);
                    }
                    var s = Z.isEmptyObject(t),
                        r = Z.speed(e, i, n);
                    return (o.finish = o), s || !1 === r.queue ? this.each(o) : this.queue(r.queue, o);
                },
                stop: function (o, e, s) {
                    function r(e) {
                        var t = e.stop;
                        delete e.stop, t(s);
                    }
                    return (
                        "string" != typeof o && ((s = e), (e = o), (o = void 0)),
                        e && !1 !== o && this.queue(o || "fx", []),
                        this.each(function () {
                            var e = !0,
                                t = null != o && o + "queueHooks",
                                i = Z.timers,
                                n = ge.get(this);
                            if (t) n[t] && n[t].stop && r(n[t]);
                            else for (t in n) n[t] && n[t].stop && dt.test(t) && r(n[t]);
                            for (t = i.length; t--; ) i[t].elem !== this || (null != o && i[t].queue !== o) || (i[t].anim.stop(s), (e = !1), i.splice(t, 1));
                            (!e && s) || Z.dequeue(this, o);
                        })
                    );
                },
                finish: function (r) {
                    return (
                        !1 !== r && (r = r || "fx"),
                        this.each(function () {
                            var e,
                                t = ge.get(this),
                                i = t[r + "queue"],
                                n = t[r + "queueHooks"],
                                o = Z.timers,
                                s = i ? i.length : 0;
                            for (t.finish = !0, Z.queue(this, r, []), n && n.stop && n.stop.call(this, !0), e = o.length; e--; ) o[e].elem === this && o[e].queue === r && (o[e].anim.stop(!0), o.splice(e, 1));
                            for (e = 0; e < s; e++) i[e] && i[e].finish && i[e].finish.call(this);
                            delete t.finish;
                        })
                    );
                },
            }),
            Z.each(["toggle", "show", "hide"], function (e, n) {
                var o = Z.fn[n];
                Z.fn[n] = function (e, t, i) {
                    return null == e || "boolean" == typeof e ? o.apply(this, arguments) : this.animate(_(n, !0), e, t, i);
                };
            }),
            Z.each({ slideDown: _("show"), slideUp: _("hide"), slideToggle: _("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, n) {
                Z.fn[e] = function (e, t, i) {
                    return this.animate(n, e, t, i);
                };
            }),
            (Z.timers = []),
            (Z.fx.tick = function () {
                var e,
                    t = 0,
                    i = Z.timers;
                for (ot = Z.now(); t < i.length; t++) (e = i[t])() || i[t] !== e || i.splice(t--, 1);
                i.length || Z.fx.stop(), (ot = void 0);
            }),
            (Z.fx.timer = function (e) {
                Z.timers.push(e), e() ? Z.fx.start() : Z.timers.pop();
            }),
            (Z.fx.interval = 13),
            (Z.fx.start = function () {
                st = st || x.setInterval(Z.fx.tick, Z.fx.interval);
            }),
            (Z.fx.stop = function () {
                x.clearInterval(st), (st = null);
            }),
            (Z.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (Z.fn.delay = function (n, e) {
                return (
                    (n = (Z.fx && Z.fx.speeds[n]) || n),
                    (e = e || "fx"),
                    this.queue(e, function (e, t) {
                        var i = x.setTimeout(e, n);
                        t.stop = function () {
                            x.clearTimeout(i);
                        };
                    })
                );
            }),
            (rt = W.createElement("input")),
            (lt = (at = W.createElement("select")).appendChild(W.createElement("option"))),
            (rt.type = "checkbox"),
            (K.checkOn = "" !== rt.value),
            (K.optSelected = lt.selected),
            (at.disabled = !0),
            (K.optDisabled = !lt.disabled),
            ((rt = W.createElement("input")).value = "t"),
            (rt.type = "radio"),
            (K.radioValue = "t" === rt.value);
        var ut,
            pt = Z.expr.attrHandle;
        Z.fn.extend({
            attr: function (e, t) {
                return ve(this, Z.attr, e, t, 1 < arguments.length);
            },
            removeAttr: function (e) {
                return this.each(function () {
                    Z.removeAttr(this, e);
                });
            },
        }),
            Z.extend({
                attr: function (e, t, i) {
                    var n,
                        o,
                        s = e.nodeType;
                    if (3 !== s && 8 !== s && 2 !== s)
                        return void 0 === e.getAttribute
                            ? Z.prop(e, t, i)
                            : ((1 === s && Z.isXMLDoc(e)) || ((t = t.toLowerCase()), (o = Z.attrHooks[t] || (Z.expr.match.bool.test(t) ? ut : void 0))),
                              void 0 !== i
                                  ? null === i
                                      ? void Z.removeAttr(e, t)
                                      : o && "set" in o && void 0 !== (n = o.set(e, i, t))
                                      ? n
                                      : (e.setAttribute(t, i + ""), i)
                                  : !(o && "get" in o && null !== (n = o.get(e, t))) && null == (n = Z.find.attr(e, t))
                                  ? void 0
                                  : n);
                },
                attrHooks: {
                    type: {
                        set: function (e, t) {
                            if (!K.radioValue && "radio" === t && Z.nodeName(e, "input")) {
                                var i = e.value;
                                return e.setAttribute("type", t), i && (e.value = i), t;
                            }
                        },
                    },
                },
                removeAttr: function (e, t) {
                    var i,
                        n,
                        o = 0,
                        s = t && t.match(fe);
                    if (s && 1 === e.nodeType) for (; (i = s[o++]); ) (n = Z.propFix[i] || i), Z.expr.match.bool.test(i) && (e[n] = !1), e.removeAttribute(i);
                },
            }),
            (ut = {
                set: function (e, t, i) {
                    return !1 === t ? Z.removeAttr(e, i) : e.setAttribute(i, i), i;
                },
            }),
            Z.each(Z.expr.match.bool.source.match(/\w+/g), function (e, t) {
                var s = pt[t] || Z.find.attr;
                pt[t] = function (e, t, i) {
                    var n, o;
                    return i || ((o = pt[t]), (pt[t] = n), (n = null != s(e, t, i) ? t.toLowerCase() : null), (pt[t] = o)), n;
                };
            });
        var ft = /^(?:input|select|textarea|button)$/i,
            ht = /^(?:a|area)$/i;
        Z.fn.extend({
            prop: function (e, t) {
                return ve(this, Z.prop, e, t, 1 < arguments.length);
            },
            removeProp: function (e) {
                return this.each(function () {
                    delete this[Z.propFix[e] || e];
                });
            },
        }),
            Z.extend({
                prop: function (e, t, i) {
                    var n,
                        o,
                        s = e.nodeType;
                    if (3 !== s && 8 !== s && 2 !== s)
                        return (
                            (1 === s && Z.isXMLDoc(e)) || ((t = Z.propFix[t] || t), (o = Z.propHooks[t])),
                            void 0 !== i ? (o && "set" in o && void 0 !== (n = o.set(e, i, t)) ? n : (e[t] = i)) : o && "get" in o && null !== (n = o.get(e, t)) ? n : e[t]
                        );
                },
                propHooks: {
                    tabIndex: {
                        get: function (e) {
                            var t = Z.find.attr(e, "tabindex");
                            return t ? parseInt(t, 10) : ft.test(e.nodeName) || (ht.test(e.nodeName) && e.href) ? 0 : -1;
                        },
                    },
                },
                propFix: { for: "htmlFor", class: "className" },
            }),
            K.optSelected ||
                (Z.propHooks.selected = {
                    get: function (e) {
                        var t = e.parentNode;
                        return t && t.parentNode && t.parentNode.selectedIndex, null;
                    },
                    set: function (e) {
                        var t = e.parentNode;
                        t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                    },
                }),
            Z.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
                Z.propFix[this.toLowerCase()] = this;
            });
        var vt = /[\t\r\n\f]/g;
        Z.fn.extend({
            addClass: function (t) {
                var e,
                    i,
                    n,
                    o,
                    s,
                    r,
                    a,
                    l = 0;
                if (Z.isFunction(t))
                    return this.each(function (e) {
                        Z(this).addClass(t.call(this, e, L(this)));
                    });
                if ("string" == typeof t && t)
                    for (e = t.match(fe) || []; (i = this[l++]); )
                        if (((o = L(i)), (n = 1 === i.nodeType && (" " + o + " ").replace(vt, " ")))) {
                            for (r = 0; (s = e[r++]); ) n.indexOf(" " + s + " ") < 0 && (n += s + " ");
                            o !== (a = Z.trim(n)) && i.setAttribute("class", a);
                        }
                return this;
            },
            removeClass: function (t) {
                var e,
                    i,
                    n,
                    o,
                    s,
                    r,
                    a,
                    l = 0;
                if (Z.isFunction(t))
                    return this.each(function (e) {
                        Z(this).removeClass(t.call(this, e, L(this)));
                    });
                if (!arguments.length) return this.attr("class", "");
                if ("string" == typeof t && t)
                    for (e = t.match(fe) || []; (i = this[l++]); )
                        if (((o = L(i)), (n = 1 === i.nodeType && (" " + o + " ").replace(vt, " ")))) {
                            for (r = 0; (s = e[r++]); ) for (; -1 < n.indexOf(" " + s + " "); ) n = n.replace(" " + s + " ", " ");
                            o !== (a = Z.trim(n)) && i.setAttribute("class", a);
                        }
                return this;
            },
            toggleClass: function (o, t) {
                var s = typeof o;
                return "boolean" == typeof t && "string" == s
                    ? t
                        ? this.addClass(o)
                        : this.removeClass(o)
                    : Z.isFunction(o)
                    ? this.each(function (e) {
                          Z(this).toggleClass(o.call(this, e, L(this), t), t);
                      })
                    : this.each(function () {
                          var e, t, i, n;
                          if ("string" == s) for (t = 0, i = Z(this), n = o.match(fe) || []; (e = n[t++]); ) i.hasClass(e) ? i.removeClass(e) : i.addClass(e);
                          else (void 0 !== o && "boolean" != s) || ((e = L(this)) && ge.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", (!e && !1 !== o && ge.get(this, "__className__")) || ""));
                      });
            },
            hasClass: function (e) {
                for (var t, i = 0, n = " " + e + " "; (t = this[i++]); ) if (1 === t.nodeType && -1 < (" " + L(t) + " ").replace(vt, " ").indexOf(n)) return !0;
                return !1;
            },
        });
        var gt = /\r/g,
            mt = /[\x20\t\r\n\f]+/g;
        Z.fn.extend({
            val: function (i) {
                var n,
                    e,
                    o,
                    t = this[0];
                return arguments.length
                    ? ((o = Z.isFunction(i)),
                      this.each(function (e) {
                          var t;
                          1 === this.nodeType &&
                              (null == (t = o ? i.call(this, e, Z(this).val()) : i)
                                  ? (t = "")
                                  : "number" == typeof t
                                  ? (t += "")
                                  : Z.isArray(t) &&
                                    (t = Z.map(t, function (e) {
                                        return null == e ? "" : e + "";
                                    })),
                              ((n = Z.valHooks[this.type] || Z.valHooks[this.nodeName.toLowerCase()]) && "set" in n && void 0 !== n.set(this, t, "value")) || (this.value = t));
                      }))
                    : t
                    ? (n = Z.valHooks[t.type] || Z.valHooks[t.nodeName.toLowerCase()]) && "get" in n && void 0 !== (e = n.get(t, "value"))
                        ? e
                        : "string" == typeof (e = t.value)
                        ? e.replace(gt, "")
                        : null == e
                        ? ""
                        : e
                    : void 0;
            },
        }),
            Z.extend({
                valHooks: {
                    option: {
                        get: function (e) {
                            var t = Z.find.attr(e, "value");
                            return null != t ? t : Z.trim(Z.text(e)).replace(mt, " ");
                        },
                    },
                    select: {
                        get: function (e) {
                            for (var t, i, n = e.options, o = e.selectedIndex, s = "select-one" === e.type || o < 0, r = s ? null : [], a = s ? o + 1 : n.length, l = o < 0 ? a : s ? o : 0; l < a; l++)
                                if (((i = n[l]).selected || l === o) && (K.optDisabled ? !i.disabled : null === i.getAttribute("disabled")) && (!i.parentNode.disabled || !Z.nodeName(i.parentNode, "optgroup"))) {
                                    if (((t = Z(i).val()), s)) return t;
                                    r.push(t);
                                }
                            return r;
                        },
                        set: function (e, t) {
                            for (var i, n, o = e.options, s = Z.makeArray(t), r = o.length; r--; ) ((n = o[r]).selected = -1 < Z.inArray(Z.valHooks.option.get(n), s)) && (i = !0);
                            return i || (e.selectedIndex = -1), s;
                        },
                    },
                },
            }),
            Z.each(["radio", "checkbox"], function () {
                (Z.valHooks[this] = {
                    set: function (e, t) {
                        return Z.isArray(t) ? (e.checked = -1 < Z.inArray(Z(e).val(), t)) : void 0;
                    },
                }),
                    K.checkOn ||
                        (Z.valHooks[this].get = function (e) {
                            return null === e.getAttribute("value") ? "on" : e.value;
                        });
            });
        var yt = /^(?:focusinfocus|focusoutblur)$/;
        Z.extend(Z.event, {
            trigger: function (e, t, i, n) {
                var o,
                    s,
                    r,
                    a,
                    l,
                    c,
                    d = [i || W],
                    u = V.call(e, "type") ? e.type : e,
                    p = V.call(e, "namespace") ? e.namespace.split(".") : [],
                    f = (s = i = i || W);
                if (
                    3 !== i.nodeType &&
                    8 !== i.nodeType &&
                    !yt.test(u + Z.event.triggered) &&
                    (-1 < u.indexOf(".") && ((u = (p = u.split(".")).shift()), p.sort()),
                    (a = u.indexOf(":") < 0 && "on" + u),
                    ((e = e[Z.expando] ? e : new Z.Event(u, "object" == typeof e && e)).isTrigger = n ? 2 : 3),
                    (e.namespace = p.join(".")),
                    (e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                    (e.result = void 0),
                    e.target || (e.target = i),
                    (t = null == t ? [e] : Z.makeArray(t, [e])),
                    (c = Z.event.special[u] || {}),
                    n || !c.trigger || !1 !== c.trigger.apply(i, t))
                ) {
                    if (!n && !c.noBubble && !Z.isWindow(i)) {
                        for (r = c.delegateType || u, yt.test(r + u) || (f = f.parentNode); f; f = f.parentNode) d.push(f), (s = f);
                        s === (i.ownerDocument || W) && d.push(s.defaultView || s.parentWindow || x);
                    }
                    for (o = 0; (f = d[o++]) && !e.isPropagationStopped(); )
                        (e.type = 1 < o ? r : c.bindType || u),
                            (l = (ge.get(f, "events") || {})[e.type] && ge.get(f, "handle")) && l.apply(f, t),
                            (l = a && f[a]) && l.apply && he(f) && ((e.result = l.apply(f, t)), !1 === e.result && e.preventDefault());
                    return (
                        (e.type = u),
                        n ||
                            e.isDefaultPrevented() ||
                            (c._default && !1 !== c._default.apply(d.pop(), t)) ||
                            !he(i) ||
                            (a && Z.isFunction(i[u]) && !Z.isWindow(i) && ((s = i[a]) && (i[a] = null), i[(Z.event.triggered = u)](), (Z.event.triggered = void 0), s && (i[a] = s))),
                        e.result
                    );
                }
            },
            simulate: function (e, t, i) {
                var n = Z.extend(new Z.Event(), i, { type: e, isSimulated: !0 });
                Z.event.trigger(n, null, t), n.isDefaultPrevented() && i.preventDefault();
            },
        }),
            Z.fn.extend({
                trigger: function (e, t) {
                    return this.each(function () {
                        Z.event.trigger(e, t, this);
                    });
                },
                triggerHandler: function (e, t) {
                    var i = this[0];
                    return i ? Z.event.trigger(e, t, i, !0) : void 0;
                },
            }),
            Z.each(
                "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),
                function (e, i) {
                    Z.fn[i] = function (e, t) {
                        return 0 < arguments.length ? this.on(i, null, e, t) : this.trigger(i);
                    };
                }
            ),
            Z.fn.extend({
                hover: function (e, t) {
                    return this.mouseenter(e).mouseleave(t || e);
                },
            }),
            (K.focusin = "onfocusin" in x),
            K.focusin ||
                Z.each({ focus: "focusin", blur: "focusout" }, function (i, n) {
                    function o(e) {
                        Z.event.simulate(n, e.target, Z.event.fix(e));
                    }
                    Z.event.special[n] = {
                        setup: function () {
                            var e = this.ownerDocument || this,
                                t = ge.access(e, n);
                            t || e.addEventListener(i, o, !0), ge.access(e, n, (t || 0) + 1);
                        },
                        teardown: function () {
                            var e = this.ownerDocument || this,
                                t = ge.access(e, n) - 1;
                            t ? ge.access(e, n, t) : (e.removeEventListener(i, o, !0), ge.remove(e, n));
                        },
                    };
                });
        var wt = x.location,
            bt = Z.now(),
            kt = /\?/;
        (Z.parseJSON = function (e) {
            return JSON.parse(e + "");
        }),
            (Z.parseXML = function (e) {
                var t;
                if (!e || "string" != typeof e) return null;
                try {
                    t = new x.DOMParser().parseFromString(e, "text/xml");
                } catch (e) {
                    t = void 0;
                }
                return (t && !t.getElementsByTagName("parsererror").length) || Z.error("Invalid XML: " + e), t;
            });
        var $t = /#.*$/,
            xt = /([?&])_=[^&]*/,
            Tt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            St = /^(?:GET|HEAD)$/,
            Ct = /^\/\//,
            At = {},
            Et = {},
            Nt = "*/".concat("*"),
            jt = W.createElement("a");
        (jt.href = wt.href),
            Z.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: wt.href,
                    type: "GET",
                    isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(wt.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: { "*": Nt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                    contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                    responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                    converters: { "* text": String, "text html": !0, "text json": Z.parseJSON, "text xml": Z.parseXML },
                    flatOptions: { url: !0, context: !0 },
                },
                ajaxSetup: function (e, t) {
                    return t ? z(z(e, Z.ajaxSettings), t) : z(Z.ajaxSettings, e);
                },
                ajaxPrefilter: I(At),
                ajaxTransport: I(Et),
                ajax: function (e, t) {
                    function i(e, t, i, n) {
                        var o,
                            s,
                            r,
                            a,
                            l,
                            c = t;
                        2 !== k &&
                            ((k = 2),
                            f && x.clearTimeout(f),
                            (d = void 0),
                            (p = n || ""),
                            ($.readyState = 0 < e ? 4 : 0),
                            (o = (200 <= e && e < 300) || 304 === e),
                            i &&
                                (a = (function (e, t, i) {
                                    for (var n, o, s, r, a = e.contents, l = e.dataTypes; "*" === l[0]; ) l.shift(), void 0 === n && (n = e.mimeType || t.getResponseHeader("Content-Type"));
                                    if (n)
                                        for (o in a)
                                            if (a[o] && a[o].test(n)) {
                                                l.unshift(o);
                                                break;
                                            }
                                    if (l[0] in i) s = l[0];
                                    else {
                                        for (o in i) {
                                            if (!l[0] || e.converters[o + " " + l[0]]) {
                                                s = o;
                                                break;
                                            }
                                            r = r || o;
                                        }
                                        s = s || r;
                                    }
                                    return s ? (s !== l[0] && l.unshift(s), i[s]) : void 0;
                                })(v, $, i)),
                            (a = (function (e, t, i, n) {
                                var o,
                                    s,
                                    r,
                                    a,
                                    l,
                                    c = {},
                                    d = e.dataTypes.slice();
                                if (d[1]) for (r in e.converters) c[r.toLowerCase()] = e.converters[r];
                                for (s = d.shift(); s; )
                                    if ((e.responseFields[s] && (i[e.responseFields[s]] = t), !l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (l = s), (s = d.shift())))
                                        if ("*" === s) s = l;
                                        else if ("*" !== l && l !== s) {
                                            if (!(r = c[l + " " + s] || c["* " + s]))
                                                for (o in c)
                                                    if ((a = o.split(" "))[1] === s && (r = c[l + " " + a[0]] || c["* " + a[0]])) {
                                                        !0 === r ? (r = c[o]) : !0 !== c[o] && ((s = a[0]), d.unshift(a[1]));
                                                        break;
                                                    }
                                            if (!0 !== r)
                                                if (r && e.throws) t = r(t);
                                                else
                                                    try {
                                                        t = r(t);
                                                    } catch (e) {
                                                        return { state: "parsererror", error: r ? e : "No conversion from " + l + " to " + s };
                                                    }
                                        }
                                return { state: "success", data: t };
                            })(v, a, $, o)),
                            o
                                ? (v.ifModified && ((l = $.getResponseHeader("Last-Modified")) && (Z.lastModified[u] = l), (l = $.getResponseHeader("etag")) && (Z.etag[u] = l)),
                                  204 === e || "HEAD" === v.type ? (c = "nocontent") : 304 === e ? (c = "notmodified") : ((c = a.state), (s = a.data), (o = !(r = a.error))))
                                : ((r = c), (!e && c) || ((c = "error"), e < 0 && (e = 0))),
                            ($.status = e),
                            ($.statusText = (t || c) + ""),
                            o ? y.resolveWith(g, [s, c, $]) : y.rejectWith(g, [$, c, r]),
                            $.statusCode(b),
                            (b = void 0),
                            h && m.trigger(o ? "ajaxSuccess" : "ajaxError", [$, v, o ? s : r]),
                            w.fireWith(g, [$, c]),
                            h && (m.trigger("ajaxComplete", [$, v]), --Z.active || Z.event.trigger("ajaxStop")));
                    }
                    "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
                    var d,
                        u,
                        p,
                        n,
                        f,
                        o,
                        h,
                        s,
                        v = Z.ajaxSetup({}, t),
                        g = v.context || v,
                        m = v.context && (g.nodeType || g.jquery) ? Z(g) : Z.event,
                        y = Z.Deferred(),
                        w = Z.Callbacks("once memory"),
                        b = v.statusCode || {},
                        r = {},
                        a = {},
                        k = 0,
                        l = "canceled",
                        $ = {
                            readyState: 0,
                            getResponseHeader: function (e) {
                                var t;
                                if (2 === k) {
                                    if (!n) for (n = {}; (t = Tt.exec(p)); ) n[t[1].toLowerCase()] = t[2];
                                    t = n[e.toLowerCase()];
                                }
                                return null == t ? null : t;
                            },
                            getAllResponseHeaders: function () {
                                return 2 === k ? p : null;
                            },
                            setRequestHeader: function (e, t) {
                                var i = e.toLowerCase();
                                return k || ((e = a[i] = a[i] || e), (r[e] = t)), this;
                            },
                            overrideMimeType: function (e) {
                                return k || (v.mimeType = e), this;
                            },
                            statusCode: function (e) {
                                var t;
                                if (e)
                                    if (k < 2) for (t in e) b[t] = [b[t], e[t]];
                                    else $.always(e[$.status]);
                                return this;
                            },
                            abort: function (e) {
                                var t = e || l;
                                return d && d.abort(t), i(0, t), this;
                            },
                        };
                    if (
                        ((y.promise($).complete = w.add),
                        ($.success = $.done),
                        ($.error = $.fail),
                        (v.url = ((e || v.url || wt.href) + "").replace($t, "").replace(Ct, wt.protocol + "//")),
                        (v.type = t.method || t.type || v.method || v.type),
                        (v.dataTypes = Z.trim(v.dataType || "*")
                            .toLowerCase()
                            .match(fe) || [""]),
                        null == v.crossDomain)
                    ) {
                        o = W.createElement("a");
                        try {
                            (o.href = v.url), o.href, (v.crossDomain = jt.protocol + "//" + jt.host != o.protocol + "//" + o.host);
                        } catch (e) {
                            v.crossDomain = !0;
                        }
                    }
                    if ((v.data && v.processData && "string" != typeof v.data && (v.data = Z.param(v.data, v.traditional)), M(At, v, t, $), 2 === k)) return $;
                    for (s in ((h = Z.event && v.global) && 0 == Z.active++ && Z.event.trigger("ajaxStart"),
                    (v.type = v.type.toUpperCase()),
                    (v.hasContent = !St.test(v.type)),
                    (u = v.url),
                    v.hasContent || (v.data && ((u = v.url += (kt.test(u) ? "&" : "?") + v.data), delete v.data), !1 === v.cache && (v.url = xt.test(u) ? u.replace(xt, "$1_=" + bt++) : u + (kt.test(u) ? "&" : "?") + "_=" + bt++)),
                    v.ifModified && (Z.lastModified[u] && $.setRequestHeader("If-Modified-Since", Z.lastModified[u]), Z.etag[u] && $.setRequestHeader("If-None-Match", Z.etag[u])),
                    ((v.data && v.hasContent && !1 !== v.contentType) || t.contentType) && $.setRequestHeader("Content-Type", v.contentType),
                    $.setRequestHeader("Accept", v.dataTypes[0] && v.accepts[v.dataTypes[0]] ? v.accepts[v.dataTypes[0]] + ("*" !== v.dataTypes[0] ? ", " + Nt + "; q=0.01" : "") : v.accepts["*"]),
                    v.headers))
                        $.setRequestHeader(s, v.headers[s]);
                    if (v.beforeSend && (!1 === v.beforeSend.call(g, $, v) || 2 === k)) return $.abort();
                    for (s in ((l = "abort"), { success: 1, error: 1, complete: 1 })) $[s](v[s]);
                    if ((d = M(Et, v, t, $))) {
                        if ((($.readyState = 1), h && m.trigger("ajaxSend", [$, v]), 2 === k)) return $;
                        v.async &&
                            0 < v.timeout &&
                            (f = x.setTimeout(function () {
                                $.abort("timeout");
                            }, v.timeout));
                        try {
                            (k = 1), d.send(r, i);
                        } catch (e) {
                            if (!(k < 2)) throw e;
                            i(-1, e);
                        }
                    } else i(-1, "No Transport");
                    return $;
                },
                getJSON: function (e, t, i) {
                    return Z.get(e, t, i, "json");
                },
                getScript: function (e, t) {
                    return Z.get(e, void 0, t, "script");
                },
            }),
            Z.each(["get", "post"], function (e, o) {
                Z[o] = function (e, t, i, n) {
                    return Z.isFunction(t) && ((n = n || i), (i = t), (t = void 0)), Z.ajax(Z.extend({ url: e, type: o, dataType: n, data: t, success: i }, Z.isPlainObject(e) && e));
                };
            }),
            (Z._evalUrl = function (e) {
                return Z.ajax({ url: e, type: "GET", dataType: "script", async: !1, global: !1, throws: !0 });
            }),
            Z.fn.extend({
                wrapAll: function (t) {
                    var e;
                    return Z.isFunction(t)
                        ? this.each(function (e) {
                              Z(this).wrapAll(t.call(this, e));
                          })
                        : (this[0] &&
                              ((e = Z(t, this[0].ownerDocument).eq(0).clone(!0)),
                              this[0].parentNode && e.insertBefore(this[0]),
                              e
                                  .map(function () {
                                      for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                                      return e;
                                  })
                                  .append(this)),
                          this);
                },
                wrapInner: function (i) {
                    return Z.isFunction(i)
                        ? this.each(function (e) {
                              Z(this).wrapInner(i.call(this, e));
                          })
                        : this.each(function () {
                              var e = Z(this),
                                  t = e.contents();
                              t.length ? t.wrapAll(i) : e.append(i);
                          });
                },
                wrap: function (t) {
                    var i = Z.isFunction(t);
                    return this.each(function (e) {
                        Z(this).wrapAll(i ? t.call(this, e) : t);
                    });
                },
                unwrap: function () {
                    return this.parent()
                        .each(function () {
                            Z.nodeName(this, "body") || Z(this).replaceWith(this.childNodes);
                        })
                        .end();
                },
            }),
            (Z.expr.filters.hidden = function (e) {
                return !Z.expr.filters.visible(e);
            }),
            (Z.expr.filters.visible = function (e) {
                return 0 < e.offsetWidth || 0 < e.offsetHeight || 0 < e.getClientRects().length;
            });
        var Ot = /%20/g,
            Dt = /\[\]$/,
            _t = /\r?\n/g,
            Ht = /^(?:submit|button|image|reset|file)$/i,
            Pt = /^(?:input|select|textarea|keygen)/i;
        (Z.param = function (e, t) {
            function i(e, t) {
                (t = Z.isFunction(t) ? t() : null == t ? "" : t), (o[o.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t));
            }
            var n,
                o = [];
            if ((void 0 === t && (t = Z.ajaxSettings && Z.ajaxSettings.traditional), Z.isArray(e) || (e.jquery && !Z.isPlainObject(e))))
                Z.each(e, function () {
                    i(this.name, this.value);
                });
            else
                for (n in e)
                    !(function i(n, e, o, s) {
                        var t;
                        if (Z.isArray(e))
                            Z.each(e, function (e, t) {
                                o || Dt.test(n) ? s(n, t) : i(n + "[" + ("object" == typeof t && null != t ? e : "") + "]", t, o, s);
                            });
                        else if (o || "object" !== Z.type(e)) s(n, e);
                        else for (t in e) i(n + "[" + t + "]", e[t], o, s);
                    })(n, e[n], t, i);
            return o.join("&").replace(Ot, "+");
        }),
            Z.fn.extend({
                serialize: function () {
                    return Z.param(this.serializeArray());
                },
                serializeArray: function () {
                    return this.map(function () {
                        var e = Z.prop(this, "elements");
                        return e ? Z.makeArray(e) : this;
                    })
                        .filter(function () {
                            var e = this.type;
                            return this.name && !Z(this).is(":disabled") && Pt.test(this.nodeName) && !Ht.test(e) && (this.checked || !Te.test(e));
                        })
                        .map(function (e, t) {
                            var i = Z(this).val();
                            return null == i
                                ? null
                                : Z.isArray(i)
                                ? Z.map(i, function (e) {
                                      return { name: t.name, value: e.replace(_t, "\r\n") };
                                  })
                                : { name: t.name, value: i.replace(_t, "\r\n") };
                        })
                        .get();
                },
            }),
            (Z.ajaxSettings.xhr = function () {
                try {
                    return new x.XMLHttpRequest();
                } catch (e) {}
            });
        var Lt = { 0: 200, 1223: 204 },
            It = Z.ajaxSettings.xhr();
        (K.cors = !!It && "withCredentials" in It),
            (K.ajax = It = !!It),
            Z.ajaxTransport(function (o) {
                var s, r;
                return K.cors || (It && !o.crossDomain)
                    ? {
                          send: function (e, t) {
                              var i,
                                  n = o.xhr();
                              if ((n.open(o.type, o.url, o.async, o.username, o.password), o.xhrFields)) for (i in o.xhrFields) n[i] = o.xhrFields[i];
                              for (i in (o.mimeType && n.overrideMimeType && n.overrideMimeType(o.mimeType), o.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"), e)) n.setRequestHeader(i, e[i]);
                              (s = function (e) {
                                  return function () {
                                      s &&
                                          ((s = r = n.onload = n.onerror = n.onabort = n.onreadystatechange = null),
                                          "abort" === e
                                              ? n.abort()
                                              : "error" === e
                                              ? "number" != typeof n.status
                                                  ? t(0, "error")
                                                  : t(n.status, n.statusText)
                                              : t(
                                                    Lt[n.status] || n.status,
                                                    n.statusText,
                                                    "text" !== (n.responseType || "text") || "string" != typeof n.responseText ? { binary: n.response } : { text: n.responseText },
                                                    n.getAllResponseHeaders()
                                                ));
                                  };
                              }),
                                  (n.onload = s()),
                                  (r = n.onerror = s("error")),
                                  void 0 !== n.onabort
                                      ? (n.onabort = r)
                                      : (n.onreadystatechange = function () {
                                            4 === n.readyState &&
                                                x.setTimeout(function () {
                                                    s && r();
                                                });
                                        }),
                                  (s = s("abort"));
                              try {
                                  n.send((o.hasContent && o.data) || null);
                              } catch (e) {
                                  if (s) throw e;
                              }
                          },
                          abort: function () {
                              s && s();
                          },
                      }
                    : void 0;
            }),
            Z.ajaxSetup({
                accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
                contents: { script: /\b(?:java|ecma)script\b/ },
                converters: {
                    "text script": function (e) {
                        return Z.globalEval(e), e;
                    },
                },
            }),
            Z.ajaxPrefilter("script", function (e) {
                void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
            }),
            Z.ajaxTransport("script", function (i) {
                var n, o;
                if (i.crossDomain)
                    return {
                        send: function (e, t) {
                            (n = Z("<script>")
                                .prop({ charset: i.scriptCharset, src: i.url })
                                .on(
                                    "load error",
                                    (o = function (e) {
                                        n.remove(), (o = null), e && t("error" === e.type ? 404 : 200, e.type);
                                    })
                                )),
                                W.head.appendChild(n[0]);
                        },
                        abort: function () {
                            o && o();
                        },
                    };
            });
        var Mt = [],
            zt = /(=)\?(?=&|$)|\?\?/;
        Z.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
                var e = Mt.pop() || Z.expando + "_" + bt++;
                return (this[e] = !0), e;
            },
        }),
            Z.ajaxPrefilter("json jsonp", function (e, t, i) {
                var n,
                    o,
                    s,
                    r = !1 !== e.jsonp && (zt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && zt.test(e.data) && "data");
                return r || "jsonp" === e.dataTypes[0]
                    ? ((n = e.jsonpCallback = Z.isFunction(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                      r ? (e[r] = e[r].replace(zt, "$1" + n)) : !1 !== e.jsonp && (e.url += (kt.test(e.url) ? "&" : "?") + e.jsonp + "=" + n),
                      (e.converters["script json"] = function () {
                          return s || Z.error(n + " was not called"), s[0];
                      }),
                      (e.dataTypes[0] = "json"),
                      (o = x[n]),
                      (x[n] = function () {
                          s = arguments;
                      }),
                      i.always(function () {
                          void 0 === o ? Z(x).removeProp(n) : (x[n] = o), e[n] && ((e.jsonpCallback = t.jsonpCallback), Mt.push(n)), s && Z.isFunction(o) && o(s[0]), (s = o = void 0);
                      }),
                      "script")
                    : void 0;
            }),
            (Z.parseHTML = function (e, t, i) {
                if (!e || "string" != typeof e) return null;
                "boolean" == typeof t && ((i = t), (t = !1)), (t = t || W);
                var n = re.exec(e),
                    o = !i && [];
                return n ? [t.createElement(n[1])] : ((n = m([e], t, o)), o && o.length && Z(o).remove(), Z.merge([], n.childNodes));
            });
        var qt = Z.fn.load;
        (Z.fn.load = function (e, t, i) {
            if ("string" != typeof e && qt) return qt.apply(this, arguments);
            var n,
                o,
                s,
                r = this,
                a = e.indexOf(" ");
            return (
                -1 < a && ((n = Z.trim(e.slice(a))), (e = e.slice(0, a))),
                Z.isFunction(t) ? ((i = t), (t = void 0)) : t && "object" == typeof t && (o = "POST"),
                0 < r.length &&
                    Z.ajax({ url: e, type: o || "GET", dataType: "html", data: t })
                        .done(function (e) {
                            (s = arguments), r.html(n ? Z("<div>").append(Z.parseHTML(e)).find(n) : e);
                        })
                        .always(
                            i &&
                                function (e, t) {
                                    r.each(function () {
                                        i.apply(this, s || [e.responseText, t, e]);
                                    });
                                }
                        ),
                this
            );
        }),
            Z.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
                Z.fn[t] = function (e) {
                    return this.on(t, e);
                };
            }),
            (Z.expr.filters.animated = function (t) {
                return Z.grep(Z.timers, function (e) {
                    return t === e.elem;
                }).length;
            }),
            (Z.offset = {
                setOffset: function (e, t, i) {
                    var n,
                        o,
                        s,
                        r,
                        a,
                        l,
                        c = Z.css(e, "position"),
                        d = Z(e),
                        u = {};
                    "static" === c && (e.style.position = "relative"),
                        (a = d.offset()),
                        (s = Z.css(e, "top")),
                        (l = Z.css(e, "left")),
                        (o = ("absolute" === c || "fixed" === c) && -1 < (s + l).indexOf("auto") ? ((r = (n = d.position()).top), n.left) : ((r = parseFloat(s) || 0), parseFloat(l) || 0)),
                        Z.isFunction(t) && (t = t.call(e, i, Z.extend({}, a))),
                        null != t.top && (u.top = t.top - a.top + r),
                        null != t.left && (u.left = t.left - a.left + o),
                        "using" in t ? t.using.call(e, u) : d.css(u);
                },
            }),
            Z.fn.extend({
                offset: function (t) {
                    if (arguments.length)
                        return void 0 === t
                            ? this
                            : this.each(function (e) {
                                  Z.offset.setOffset(this, t, e);
                              });
                    var e,
                        i,
                        n = this[0],
                        o = { top: 0, left: 0 },
                        s = n && n.ownerDocument;
                    return s ? ((e = s.documentElement), Z.contains(e, n) ? ((o = n.getBoundingClientRect()), (i = q(s)), { top: o.top + i.pageYOffset - e.clientTop, left: o.left + i.pageXOffset - e.clientLeft }) : o) : void 0;
                },
                position: function () {
                    if (this[0]) {
                        var e,
                            t,
                            i = this[0],
                            n = { top: 0, left: 0 };
                        return (
                            "fixed" === Z.css(i, "position")
                                ? (t = i.getBoundingClientRect())
                                : ((e = this.offsetParent()), (t = this.offset()), Z.nodeName(e[0], "html") || (n = e.offset()), (n.top += Z.css(e[0], "borderTopWidth", !0)), (n.left += Z.css(e[0], "borderLeftWidth", !0))),
                            { top: t.top - n.top - Z.css(i, "marginTop", !0), left: t.left - n.left - Z.css(i, "marginLeft", !0) }
                        );
                    }
                },
                offsetParent: function () {
                    return this.map(function () {
                        for (var e = this.offsetParent; e && "static" === Z.css(e, "position"); ) e = e.offsetParent;
                        return e || Ke;
                    });
                },
            }),
            Z.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (t, o) {
                var s = "pageYOffset" === o;
                Z.fn[t] = function (e) {
                    return ve(
                        this,
                        function (e, t, i) {
                            var n = q(e);
                            return void 0 === i ? (n ? n[o] : e[t]) : void (n ? n.scrollTo(s ? n.pageXOffset : i, s ? i : n.pageYOffset) : (e[t] = i));
                        },
                        t,
                        e,
                        arguments.length
                    );
                };
            }),
            Z.each(["top", "left"], function (e, i) {
                Z.cssHooks[i] = S(K.pixelPosition, function (e, t) {
                    return t ? ((t = T(e, i)), Ge.test(t) ? Z(e).position()[i] + "px" : t) : void 0;
                });
            }),
            Z.each({ Height: "height", Width: "width" }, function (s, r) {
                Z.each({ padding: "inner" + s, content: r, "": "outer" + s }, function (n, e) {
                    Z.fn[e] = function (e, t) {
                        var i = arguments.length && (n || "boolean" != typeof e),
                            o = n || (!0 === e || !0 === t ? "margin" : "border");
                        return ve(
                            this,
                            function (e, t, i) {
                                var n;
                                return Z.isWindow(e)
                                    ? e.document.documentElement["client" + s]
                                    : 9 === e.nodeType
                                    ? ((n = e.documentElement), Math.max(e.body["scroll" + s], n["scroll" + s], e.body["offset" + s], n["offset" + s], n["client" + s]))
                                    : void 0 === i
                                    ? Z.css(e, t, o)
                                    : Z.style(e, t, i, o);
                            },
                            r,
                            i ? e : void 0,
                            i,
                            null
                        );
                    };
                });
            }),
            Z.fn.extend({
                bind: function (e, t, i) {
                    return this.on(e, null, t, i);
                },
                unbind: function (e, t) {
                    return this.off(e, null, t);
                },
                delegate: function (e, t, i, n) {
                    return this.on(t, e, i, n);
                },
                undelegate: function (e, t, i) {
                    return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", i);
                },
                size: function () {
                    return this.length;
                },
            }),
            (Z.fn.andSelf = Z.fn.addBack),
            "function" == typeof define &&
                define.amd &&
                define("jquery", [], function () {
                    return Z;
                });
        var Ft = x.jQuery,
            Rt = x.$;
        return (
            (Z.noConflict = function (e) {
                return x.$ === Z && (x.$ = Rt), e && x.jQuery === Z && (x.jQuery = Ft), Z;
            }),
            e || (x.jQuery = x.$ = Z),
            Z
        );
    }),
    (function (h) {
        var n = { url: !1, callback: !1, target: !1, duration: 120, on: "mouseover", touch: !0, onZoomIn: !1, onZoomOut: !1, magnify: 1 };
        (h.zoom = function (e, t, n, i) {
            var o,
                s,
                r,
                a,
                l,
                c,
                d,
                u = h(e),
                p = u.css("position"),
                f = h(t);
            return (
                (e.style.position = /(absolute|fixed)/.test(p) ? p : "relative"),
                (e.style.overflow = "hidden"),
                (n.style.width = n.style.height = ""),
                h(n)
                    .addClass("zoomImg")
                    .css({ position: "absolute", top: 0, left: 0, opacity: 0, width: n.width * i, height: n.height * i, border: "none", maxWidth: "none", maxHeight: "none" })
                    .appendTo(e),
                {
                    init: function () {
                        (s = u.outerWidth()), (o = u.outerHeight()), (r = t === e ? ((a = s), o) : ((a = f.outerWidth()), f.outerHeight())), (l = (n.width - s) / a), (c = (n.height - o) / r), (d = f.offset());
                    },
                    move: function (e) {
                        var t = e.pageX - d.left,
                            i = e.pageY - d.top,
                            i = Math.max(Math.min(i, r), 0),
                            t = Math.max(Math.min(t, a), 0);
                        (n.style.left = t * -l + "px"), (n.style.top = i * -c + "px");
                    },
                }
            );
        }),
            (h.fn.zoom = function (i) {
                return this.each(function () {
                    var o = h.extend({}, n, i || {}),
                        s = (o.target && h(o.target)[0]) || this,
                        e = this,
                        r = h(e),
                        a = document.createElement("img"),
                        l = h(a),
                        c = "mousemove.zoom",
                        d = !1,
                        u = !1;
                    if (!o.url) {
                        var t = e.querySelector("img");
                        if ((t && (o.url = t.getAttribute("data-src") || t.currentSrc || t.src), !o.url)) return;
                    }
                    r.one(
                        "zoom.destroy",
                        function (e, t) {
                            r.off(".zoom"), (s.style.position = e), (s.style.overflow = t), (a.onload = null), l.remove();
                        }.bind(this, s.style.position, s.style.overflow)
                    ),
                        (a.onload = function () {
                            function t(e) {
                                n.init(), n.move(e), l.stop().fadeTo(h.support.opacity ? o.duration : 0, 1, !!h.isFunction(o.onZoomIn) && o.onZoomIn.call(a));
                            }
                            function i() {
                                l.stop().fadeTo(o.duration, 0, !!h.isFunction(o.onZoomOut) && o.onZoomOut.call(a));
                            }
                            var n = h.zoom(s, e, a, o.magnify);
                            "grab" === o.on
                                ? r.on("mousedown.zoom", function (e) {
                                      1 === e.which &&
                                          (h(document).one("mouseup.zoom", function () {
                                              i(), h(document).off(c, n.move);
                                          }),
                                          t(e),
                                          h(document).on(c, n.move),
                                          e.preventDefault());
                                  })
                                : "click" === o.on
                                ? r.on("click.zoom", function (e) {
                                      return d
                                          ? void 0
                                          : ((d = !0),
                                            t(e),
                                            h(document).on(c, n.move),
                                            h(document).one("click.zoom", function () {
                                                i(), (d = !1), h(document).off(c, n.move);
                                            }),
                                            !1);
                                  })
                                : "toggle" === o.on
                                ? r.on("click.zoom", function (e) {
                                      d ? i() : t(e), (d = !d);
                                  })
                                : "mouseover" === o.on && (n.init(), r.on("mouseenter.zoom", t).on("mouseleave.zoom", i).on(c, n.move)),
                                o.touch &&
                                    r
                                        .on("touchstart.zoom", function (e) {
                                            e.preventDefault(), u ? ((u = !1), i()) : ((u = !0), t(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]));
                                        })
                                        .on("touchmove.zoom", function (e) {
                                            e.preventDefault(), n.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
                                        })
                                        .on("touchend.zoom", function (e) {
                                            e.preventDefault(), u && ((u = !1), i());
                                        }),
                                h.isFunction(o.callback) && o.callback.call(a);
                        }),
                        a.setAttribute("role", "presentation"),
                        (a.alt = ""),
                        (a.src = o.url);
                });
            }),
            (h.fn.zoom.defaults = n);
    })(window.jQuery),
    function () {
        function a(e, t) {
            for (var i = -1, n = t.length, o = e.length; ++i < n; ) e[o + i] = t[i];
            return e;
        }
        function t(e, t, i) {
            for (var n = -1, o = e.length; ++n < o; ) {
                var s,
                    r,
                    a = e[n],
                    l = t(a);
                null != l && (s === V ? l == l : i(l, s)) && ((s = l), (r = a));
            }
            return r;
        }
        function e(e) {
            return e && e.Object === Object ? e : null;
        }
        function i(e) {
            return te[e];
        }
        function u(e) {
            var t = !1;
            if (null != e && "function" != typeof e.toString)
                try {
                    t = !!(e + "");
                } catch (e) {}
            return t;
        }
        function c(e, t) {
            return -1 < (e = "number" == typeof e || ee.test(e) ? +e : -1) && 0 == e % 1 && e < (null == t ? 9007199254740991 : t);
        }
        function s(e) {
            if (q(e) && !Oe(e)) {
                if (e instanceof n) return e;
                if (pe.call(e, "__wrapped__")) {
                    var t = new n(e.__wrapped__, e.__chain__);
                    return (t.__actions__ = $(e.__actions__)), t;
                }
            }
            return new n(e);
        }
        function n(e, t) {
            (this.__wrapped__ = e), (this.__actions__ = []), (this.__chain__ = !!t);
        }
        function o(e, t, i, n) {
            var o;
            return (o = e === V) || (o = (e === (o = ue[i]) || (e != e && o != o)) && !pe.call(n, i)), o ? t : e;
        }
        function r(e) {
            return z(e) ? ye(e) : {};
        }
        function l(e, t, i) {
            if ("function" != typeof e) throw new TypeError("Expected a function");
            return setTimeout(function () {
                e.apply(V, i);
            }, t);
        }
        function d(e, n) {
            var o = [];
            return (
                xe(e, function (e, t, i) {
                    n(e, t, i) && o.push(e);
                }),
                o
            );
        }
        function p(e, t, i, n) {
            n = n || [];
            for (var o = -1, s = e.length; ++o < s; ) {
                var r = e[o];
                0 < t && q(r) && L(r) && (i || Oe(r) || P(r)) ? (1 < t ? p(r, t - 1, i, n) : a(n, r)) : i || (n[n.length] = r);
            }
            return n;
        }
        function f(e, t) {
            return e && Te(e, t, B);
        }
        function h(t, e) {
            return d(e, function (e) {
                return I(t[e]);
            });
        }
        function v(e, t, i, n, o) {
            return (
                e === t ||
                (null == e || null == t || (!z(e) && !q(t))
                    ? e != e && t != t
                    : (function (t, e, i, n, o, s) {
                          var r = Oe(t),
                              a = Oe(e),
                              l = "[object Array]",
                              c = "[object Array]";
                          r || ("[object Arguments]" == (l = he.call(t)) && (l = "[object Object]")), a || ("[object Arguments]" == (c = he.call(e)) && (c = "[object Object]"));
                          var d = "[object Object]" == l && !u(t),
                              a = "[object Object]" == c && !u(e);
                          return !(c = l == c) || r || d
                              ? 2 & o || ((l = d && pe.call(t, "__wrapped__")), (a = a && pe.call(e, "__wrapped__")), !l && !a)
                                  ? !!c &&
                                    ((l = N((s = s || []), function (e) {
                                        return e[0] === t;
                                    })) && l[1]
                                        ? l[1] == e
                                        : (s.push([t, e]),
                                          (e = (r
                                              ? function (e, t, i, n, o, s) {
                                                    var r = -1,
                                                        a = 1 & o,
                                                        l = e.length,
                                                        c = t.length;
                                                    if (l != c && !(2 & o && l < c)) return !1;
                                                    for (c = !0; ++r < l; ) {
                                                        var d = e[r],
                                                            u = t[r];
                                                        if (void 0 !== V) {
                                                            c = !1;
                                                            break;
                                                        }
                                                        if (a) {
                                                            if (
                                                                !x(t, function (e) {
                                                                    return d === e || i(d, e, n, o, s);
                                                                })
                                                            ) {
                                                                c = !1;
                                                                break;
                                                            }
                                                        } else if (d !== u && !i(d, u, n, o, s)) {
                                                            c = !1;
                                                            break;
                                                        }
                                                    }
                                                    return c;
                                                }
                                              : function (e, t, i, n, o, s) {
                                                    var r = 2 & o,
                                                        a = B(e),
                                                        l = a.length,
                                                        c = B(t).length;
                                                    if (l != c && !r) return !1;
                                                    for (var d = l; d--; ) {
                                                        var u = a[d];
                                                        if (!(r ? u in t : pe.call(t, u))) return !1;
                                                    }
                                                    for (c = !0; ++d < l; ) {
                                                        var p = e[(u = a[d])],
                                                            f = t[u];
                                                        if (void 0 !== V || (p !== f && !i(p, f, n, o, s))) {
                                                            c = !1;
                                                            break;
                                                        }
                                                        r = r || "constructor" == u;
                                                    }
                                                    return (
                                                        c &&
                                                            !r &&
                                                            (i = e.constructor) != (n = t.constructor) &&
                                                            "constructor" in e &&
                                                            "constructor" in t &&
                                                            !("function" == typeof i && i instanceof i && "function" == typeof n && n instanceof n) &&
                                                            (c = !1),
                                                        c
                                                    );
                                                })(t, e, i, n, o, s)),
                                          s.pop(),
                                          e))
                                  : i(l ? t.value() : t, a ? e.value() : e, n, o, s)
                              : (function (e, t) {
                                    switch (l) {
                                        case "[object Boolean]":
                                        case "[object Date]":
                                            return +e == +t;
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object Number]":
                                            return e != +e ? t != +t : e == +t;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                    }
                                    return !1;
                                })(t, e);
                      })(e, t, v, i, n, o))
            );
        }
        function g(e) {
            var t = typeof e;
            return "function" == t ? e : null == e ? Q : ("object" == t ? w : b)(e);
        }
        function m(e) {
            e = null == e ? e : Object(e);
            var t,
                i = [];
            for (t in e) i.push(t);
            return i;
        }
        function y(e, n) {
            var o = -1,
                s = L(e) ? Array(e.length) : [];
            return (
                xe(e, function (e, t, i) {
                    s[++o] = n(e, t, i);
                }),
                s
            );
        }
        function w(n) {
            var o = B(n);
            return function (e) {
                var t = o.length;
                if (null == e) return !t;
                for (e = Object(e); t--; ) {
                    var i = o[t];
                    if (!(i in e && v(n[i], e[i], V, 3))) return !1;
                }
                return !0;
            };
        }
        function b(t) {
            return function (e) {
                return null == e ? V : e[t];
            };
        }
        function k(e, t, i) {
            var n = -1,
                o = e.length;
            for (t < 0 && (t = o < -t ? 0 : o + t), (i = o < i ? o : i) < 0 && (i += o), o = i < t ? 0 : (i - t) >>> 0, t >>>= 0, i = Array(o); ++n < o; ) i[n] = e[n + t];
            return i;
        }
        function $(e) {
            return k(e, 0, e.length);
        }
        function x(e, n) {
            var o;
            return (
                xe(e, function (e, t, i) {
                    return !(o = n(e, t, i));
                }),
                !!o
            );
        }
        function T(e, t, i, n) {
            i = i || {};
            for (var o = -1, s = t.length; ++o < s; ) {
                var r = t[o],
                    a = n ? n(i[r], e[r], r, i, e) : e[r],
                    l = i,
                    c = l[r];
                (pe.call(l, r) && (c === a || (c != c && a != a)) && (a !== V || r in l)) || (l[r] = a);
            }
            return i;
        }
        function S(r) {
            return _(function (e, t) {
                var i = -1,
                    n = t.length,
                    o = "function" == typeof (o = 1 < n ? t[n - 1] : V) ? (n--, o) : V;
                for (e = Object(e); ++i < n; ) {
                    var s = t[i];
                    s && r(e, s, i, o);
                }
                return e;
            });
        }
        function C(e) {
            var t = e ? e.length : V;
            if (M(t) && (Oe(e) || R(e) || P(e))) {
                e = String;
                for (var i = -1, n = Array(t); ++i < t; ) n[i] = e(i);
                t = n;
            } else t = null;
            return t;
        }
        function A(e) {
            var t;
            return e === ((I((t = e && e.constructor)) && t.prototype) || ue);
        }
        function E(e) {
            return e ? e[0] : V;
        }
        function N(e, t) {
            return (
                (i = e),
                (n = g(t)),
                xe(i, function (e, t, i) {
                    return n(e, t, i) ? ((o = e), !1) : void 0;
                }),
                o
            );
            var i, n, o;
        }
        function j(e, t) {
            return xe(e, "function" == typeof t ? t : Q);
        }
        function O(e, t, i) {
            return (
                (n = e),
                (o = g(t)),
                (s = i),
                (r = arguments.length < 3),
                xe(n, function (e, t, i) {
                    s = r ? ((r = !1), e) : o(s, e, t, i);
                }),
                s
            );
            var n, o, s, r;
        }
        function D(e, t) {
            var i;
            if ("function" != typeof t) throw new TypeError("Expected a function");
            return (
                (e = De(e)),
                function () {
                    return 0 < --e && (i = t.apply(this, arguments)), e <= 1 && (t = V), i;
                }
            );
        }
        function _(o) {
            var s;
            if ("function" != typeof o) throw new TypeError("Expected a function");
            return (
                (s = $e(s === V ? o.length - 1 : De(s), 0)),
                function () {
                    for (var e = arguments, t = -1, i = $e(e.length - s, 0), n = Array(i); ++t < i; ) n[t] = e[s + t];
                    for (i = Array(s + 1), t = -1; ++t < s; ) i[t] = e[t];
                    return (i[s] = n), o.apply(this, i);
                }
            );
        }
        function H(e, t) {
            return t < e;
        }
        function P(e) {
            return q(e) && L(e) && pe.call(e, "callee") && (!we.call(e, "callee") || "[object Arguments]" == he.call(e));
        }
        function L(e) {
            return null != e && !("function" == typeof e && I(e)) && M(Ce(e));
        }
        function I(e) {
            return "[object Function]" == (e = z(e) ? he.call(e) : "") || "[object GeneratorFunction]" == e;
        }
        function M(e) {
            return "number" == typeof e && -1 < e && 0 == e % 1 && e <= 9007199254740991;
        }
        function z(e) {
            var t = typeof e;
            return !!e && ("object" == t || "function" == t);
        }
        function q(e) {
            return !!e && "object" == typeof e;
        }
        function F(e) {
            return "number" == typeof e || (q(e) && "[object Number]" == he.call(e));
        }
        function R(e) {
            return "string" == typeof e || (!Oe(e) && q(e) && "[object String]" == he.call(e));
        }
        function W(e, t) {
            return e < t;
        }
        function U(e) {
            return "string" == typeof e ? e : null == e ? "" : e + "";
        }
        function B(e) {
            var t = A(e);
            if (!t && !L(e)) return ke(Object(e));
            var i,
                n,
                o = !!(n = C(e)),
                s = (n = n || []).length;
            for (i in e) !pe.call(e, i) || (o && ("length" == i || c(i, s))) || (t && "constructor" == i) || n.push(i);
            return n;
        }
        function X(e) {
            for (var t, i = -1, n = A(e), o = m(e), s = o.length, r = !!(t = C(e)), a = (t = t || []).length; ++i < s; ) {
                var l = o[i];
                (r && ("length" == l || c(l, a))) || ("constructor" == l && (n || !pe.call(e, l))) || t.push(l);
            }
            return t;
        }
        function Y(e) {
            return e
                ? y(B((t = e)), function (e) {
                      return t[e];
                  })
                : [];
            var t;
        }
        function Q(e) {
            return e;
        }
        function G(n, t, e) {
            var i = B(t),
                o = h(t, i);
            null != e || (z(t) && (o.length || !i.length)) || ((e = t), (t = n), (n = this), (o = h(t, B(t))));
            var s = !(z(e) && "chain" in e) || e.chain,
                r = I(n);
            return (
                xe(o, function (e) {
                    var i = t[e];
                    (n[e] = i),
                        r &&
                            (n.prototype[e] = function () {
                                var e = this.__chain__;
                                if (s || e) {
                                    var t = n(this.__wrapped__);
                                    return (t.__actions__ = $(this.__actions__)).push({ func: i, args: arguments, thisArg: n }), (t.__chain__ = e), t;
                                }
                                return i.apply(n, a([this.value()], arguments));
                            });
                }),
                n
            );
        }
        var V,
            K,
            Z = /[&<>"'`]/g,
            J = RegExp(Z.source),
            ee = /^(?:0|[1-9]\d*)$/,
            te = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "`": "&#96;" },
            ie = { function: !0, object: !0 },
            ne = ie[typeof exports] && exports && !exports.nodeType ? exports : V,
            oe = ie[typeof module] && module && !module.nodeType ? module : V,
            se = oe && oe.exports === ne ? ne : V,
            re = e(ie[typeof self] && self),
            ae = e(ie[typeof window] && window),
            le = e(ie[typeof this] && this),
            ce = e(ne && oe && "object" == typeof global && global) || (ae !== (le && le.window) && ae) || re || le || Function("return this")(),
            de = Array.prototype,
            ue = Object.prototype,
            pe = ue.hasOwnProperty,
            fe = 0,
            he = ue.toString,
            ve = ce._,
            ge = ce.Reflect,
            me = ge ? ge.f : V,
            ye = Object.create,
            we = ue.propertyIsEnumerable,
            be = ce.isFinite,
            ke = Object.keys,
            $e = Math.max,
            xe =
                ((K = f),
                function (e, t) {
                    if (null == e) return e;
                    if (!L(e)) return K(e, t);
                    for (var i = e.length, n = -1, o = Object(e); ++n < i && !1 !== t(o[n], n, o); );
                    return e;
                }),
            Te = function (e, t, i) {
                for (var n = -1, o = Object(e), s = (i = i(e)).length; s--; ) {
                    var r = i[++n];
                    if (!1 === t(o[r], r, o)) break;
                }
                return e;
            };
        me &&
            !we.call({ valueOf: 1 }, "valueOf") &&
            (m = function (e) {
                e = me(e);
                for (var t, i = []; !(t = e.next()).done; ) i.push(t.value);
                return i;
            });
        var Se,
            Ce = b("length"),
            Ae = _(function (e, t) {
                return Oe(e) || (e = null == e ? [] : [Object(e)]), p(t, 1), a($(e), Y);
            }),
            Ee = _(function (a, l, c) {
                if ("function" != typeof a) throw new TypeError("Expected a function");
                var i,
                    d =
                        ((i = a),
                        function () {
                            var e = arguments,
                                t = r(i.prototype);
                            return z((e = i.apply(t, e))) ? e : t;
                        });
                return function e() {
                    for (var t = -1, i = arguments.length, n = -1, o = c.length, s = Array(o + i), r = this && this !== ce && this instanceof e ? d : a; ++n < o; ) s[n] = c[n];
                    for (; i--; ) s[n++] = arguments[++t];
                    return r.apply(l, s);
                };
            }),
            Ne = _(function (e, t) {
                return l(e, 1, t);
            }),
            je = _(function (e, t, i) {
                return l(e, _e(t) || 0, i);
            }),
            Oe = Array.isArray,
            De = Number,
            _e = Number,
            He = S(function (e, t) {
                T(t, B(t), e);
            }),
            Pe = S(function (e, t) {
                T(t, X(t), e);
            }),
            Le = S(function (e, t, i, n) {
                T(t, X(t), e, n);
            }),
            Ie = _(function (e) {
                return e.push(V, o), Le.apply(V, e);
            }),
            Me = _(function (e, t) {
                return null == e
                    ? {}
                    : ((i = e),
                      (n = p(t, 1)),
                      (i = Object(i)),
                      O(
                          n,
                          function (e, t) {
                              return t in i && (e[t] = i[t]), e;
                          },
                          {}
                      ));
                var i, n;
            }),
            ze = g;
        ((n.prototype = r(s.prototype)).constructor = n),
            (s.assignIn = Pe),
            (s.before = D),
            (s.bind = Ee),
            (s.chain = function (e) {
                return ((e = s(e)).__chain__ = !0), e;
            }),
            (s.compact = function (e) {
                return d(e, Boolean);
            }),
            (s.concat = Ae),
            (s.create = function (e, t) {
                var i = r(e);
                return t ? He(i, t) : i;
            }),
            (s.defaults = Ie),
            (s.defer = Ne),
            (s.delay = je),
            (s.filter = function (e, t) {
                return d(e, g(t));
            }),
            (s.flatten = function (e) {
                return e && e.length ? p(e, 1) : [];
            }),
            (s.flattenDeep = function (e) {
                return e && e.length ? p(e, 1 / 0) : [];
            }),
            (s.iteratee = ze),
            (s.keys = B),
            (s.map = function (e, t) {
                return y(e, g(t));
            }),
            (s.matches = function (e) {
                return w(He({}, e));
            }),
            (s.mixin = G),
            (s.negate = function (e) {
                if ("function" != typeof e) throw new TypeError("Expected a function");
                return function () {
                    return !e.apply(this, arguments);
                };
            }),
            (s.once = function (e) {
                return D(2, e);
            }),
            (s.pick = Me),
            (s.slice = function (e, t, i) {
                var n = e ? e.length : 0;
                return (i = i === V ? n : +i), n ? k(e, null == t ? 0 : +t, i) : [];
            }),
            (s.sortBy = function (e, n) {
                var o = 0;
                return (
                    (n = g(n)),
                    y(
                        y(e, function (e, t, i) {
                            return { c: e, b: o++, a: n(e, t, i) };
                        }).sort(function (e, t) {
                            var i;
                            e: {
                                i = e.a;
                                var n = t.a;
                                if (i !== n) {
                                    var o = null === i,
                                        s = i === V,
                                        r = i == i,
                                        a = null === n,
                                        l = n === V,
                                        c = n == n;
                                    if ((n < i && !a) || !r || (o && !l && c) || (s && c)) {
                                        i = 1;
                                        break e;
                                    }
                                    if ((i < n && !o) || !c || (a && !s && r) || (l && r)) {
                                        i = -1;
                                        break e;
                                    }
                                }
                                i = 0;
                            }
                            return i || e.b - t.b;
                        }),
                        b("c")
                    )
                );
            }),
            (s.tap = function (e, t) {
                return t(e), e;
            }),
            (s.thru = function (e, t) {
                return t(e);
            }),
            (s.toArray = function (e) {
                return L(e) ? (e.length ? $(e) : []) : Y(e);
            }),
            (s.values = Y),
            (s.extend = Pe),
            G(s, s),
            (s.clone = function (e) {
                return z(e) ? (Oe(e) ? $(e) : T(e, B(e))) : e;
            }),
            (s.escape = function (e) {
                return (e = U(e)) && J.test(e) ? e.replace(Z, i) : e;
            }),
            (s.every = function (e, t, i) {
                return (
                    (n = e),
                    (o = g((t = i ? V : t))),
                    (s = !0),
                    xe(n, function (e, t, i) {
                        return (s = !!o(e, t, i));
                    }),
                    s
                );
                var n, o, s;
            }),
            (s.find = N),
            (s.forEach = j),
            (s.has = function (e, t) {
                return null != e && pe.call(e, t);
            }),
            (s.head = E),
            (s.identity = Q),
            (s.indexOf = function (e, t, i) {
                var n = e ? e.length : 0;
                i = ((i = "number" == typeof i ? (i < 0 ? $e(n + i, 0) : i) : 0) || 0) - 1;
                for (var o = t == t; ++i < n; ) {
                    var s = e[i];
                    if (o ? s === t : s != s) return i;
                }
                return -1;
            }),
            (s.isArguments = P),
            (s.isArray = Oe),
            (s.isBoolean = function (e) {
                return !0 === e || !1 === e || (q(e) && "[object Boolean]" == he.call(e));
            }),
            (s.isDate = function (e) {
                return q(e) && "[object Date]" == he.call(e);
            }),
            (s.isEmpty = function (e) {
                if (L(e) && (Oe(e) || R(e) || I(e.splice) || P(e))) return !e.length;
                for (var t in e) if (pe.call(e, t)) return !1;
                return !0;
            }),
            (s.isEqual = function (e, t) {
                return v(e, t);
            }),
            (s.isFinite = function (e) {
                return "number" == typeof e && be(e);
            }),
            (s.isFunction = I),
            (s.isNaN = function (e) {
                return F(e) && e != +e;
            }),
            (s.isNull = function (e) {
                return null === e;
            }),
            (s.isNumber = F),
            (s.isObject = z),
            (s.isRegExp = function (e) {
                return z(e) && "[object RegExp]" == he.call(e);
            }),
            (s.isString = R),
            (s.isUndefined = function (e) {
                return e === V;
            }),
            (s.last = function (e) {
                var t = e ? e.length : 0;
                return t ? e[t - 1] : V;
            }),
            (s.max = function (e) {
                return e && e.length ? t(e, Q, H) : V;
            }),
            (s.min = function (e) {
                return e && e.length ? t(e, Q, W) : V;
            }),
            (s.noConflict = function () {
                return ce._ === this && (ce._ = ve), this;
            }),
            (s.noop = function () {}),
            (s.reduce = O),
            (s.result = function (e, t, i) {
                return (t = null == e ? V : e[t]) === V && (t = i), I(t) ? t.call(e) : t;
            }),
            (s.size = function (e) {
                return null == e ? 0 : (e = L(e) ? e : B(e)).length;
            }),
            (s.some = function (e, t, i) {
                return x(e, g((t = i ? V : t)));
            }),
            (s.uniqueId = function (e) {
                var t = ++fe;
                return U(e) + t;
            }),
            (s.each = j),
            (s.first = E),
            G(
                s,
                ((Se = {}),
                f(s, function (e, t) {
                    pe.call(s.prototype, t) || (Se[t] = e);
                }),
                Se),
                { chain: !1 }
            ),
            (s.VERSION = "4.17.20"),
            xe("pop join replace reverse split push shift sort splice unshift".split(" "), function (e) {
                var i = (/^(?:replace|split)$/.test(e) ? String.prototype : de)[e],
                    n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                    o = /^(?:pop|join|replace|shift)$/.test(e);
                s.prototype[e] = function () {
                    var t = arguments;
                    return o && !this.__chain__
                        ? i.apply(this.value(), t)
                        : this[n](function (e) {
                              return i.apply(e, t);
                          });
                };
            }),
            (s.prototype.toJSON = s.prototype.valueOf = s.prototype.value = function () {
                return (
                    (e = this.__wrapped__),
                    O(
                        this.__actions__,
                        function (e, t) {
                            return t.func.apply(t.thisArg, a([e], t.args));
                        },
                        e
                    )
                );
                var e;
            }),
            ((ae || re || {})._ = s),
            "function" == typeof define && "object" == typeof define.amd && define.amd
                ? define(function () {
                      return s;
                  })
                : ne && oe
                ? (se && ((oe.exports = s)._ = s), (ne._ = s))
                : (ce._ = s);
    }.call(this),
    (window.mobileCheck = function () {
        var e = !1,
            t = navigator.userAgent || navigator.vendor || window.opera;
        return (
            (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                t
            ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    t.substr(0, 4)
                )) &&
                (e = !0),
            e
        );
    }),
    (function (p, f, h) {
        function a(e, t) {
            return typeof e === t;
        }
        function v(e) {
            return "function" != typeof f.createElement ? f.createElement(e) : y ? f.createElementNS.call(f, "http://www.w3.org/2000/svg", e) : f.createElement.apply(f, arguments);
        }
        function g(e) {
            return e
                .replace(/([A-Z])/g, function (e, t) {
                    return "-" + t.toLowerCase();
                })
                .replace(/^ms-/, "-ms-");
        }
        function n(e, t, i, n, o) {
            var s = e.charAt(0).toUpperCase() + e.slice(1),
                r = (e + " " + u.join(s + " ") + s).split(" ");
            return a(t, "string") || void 0 === t
                ? (function (e, t, i, n) {
                      function o() {
                          r && (delete $.style, delete $.modElem);
                      }
                      if (((n = !(void 0 === n) && n), void 0 !== i)) {
                          var s = (function (e, t) {
                              var i = e.length;
                              if ("CSS" in p && "supports" in p.CSS) {
                                  for (; i--; ) if (p.CSS.supports(g(e[i]), t)) return !0;
                                  return !1;
                              }
                              if ("CSSSupportsRule" in p) {
                                  for (var n = []; i--; ) n.push("(" + g(e[i]) + ":" + t + ")");
                                  return (function (e, t) {
                                      var i,
                                          n,
                                          o,
                                          s,
                                          r,
                                          a = "modernizr",
                                          l = v("div"),
                                          c = ((r = f.body) || ((r = v(y ? "svg" : "body")).fake = !0), r);
                                      if (parseInt(t, 10)) for (; t--; ) ((o = v("div")).id = a + (t + 1)), l.appendChild(o);
                                      return (
                                          ((i = v("style")).type = "text/css"),
                                          (i.id = "s" + a),
                                          (c.fake ? c : l).appendChild(i),
                                          c.appendChild(l),
                                          i.styleSheet ? (i.styleSheet.cssText = e) : i.appendChild(f.createTextNode(e)),
                                          (l.id = a),
                                          c.fake && ((c.style.background = ""), (c.style.overflow = "hidden"), (s = m.style.overflow), (m.style.overflow = "hidden"), m.appendChild(c)),
                                          (n = "absolute" == getComputedStyle(l, null).position),
                                          c.fake ? (c.parentNode.removeChild(c), (m.style.overflow = s), m.offsetHeight) : l.parentNode.removeChild(l),
                                          !!n
                                      );
                                  })("@supports (" + (n = n.join(" or ")) + ") { #modernizr { position: absolute; } }");
                              }
                              return h;
                          })(e, i);
                          if (void 0 !== s) return s;
                      }
                      for (var r, a, l, c, d, u = ["modernizr", "tspan", "samp"]; !$.style && u.length; ) (r = !0), ($.modElem = v(u.shift())), ($.style = $.modElem.style);
                      for (l = e.length, a = 0; a < l; a++)
                          if (
                              ((c = e[a]),
                              (d = $.style[c]),
                              ~("" + c).indexOf("-") &&
                                  (c = c
                                      .replace(/([a-z])-([a-z])/g, function (e, t, i) {
                                          return t + i.toUpperCase();
                                      })
                                      .replace(/^-/, "")),
                              $.style[c] !== h)
                          ) {
                              if (n || void 0 === i) return o(), "pfx" != t || c;
                              try {
                                  $.style[c] = i;
                              } catch (e) {}
                              if ($.style[c] != d) return o(), "pfx" != t || c;
                          }
                      return o(), !1;
                  })(r, t, n, o)
                : (function (e, t, i) {
                      var n;
                      for (var o in e)
                          if (e[o] in t)
                              return !1 === i
                                  ? e[o]
                                  : a((n = t[e[o]]), "function")
                                  ? (function (e, t) {
                                        return function () {
                                            return e.apply(t, arguments);
                                        };
                                    })(n, i || t)
                                  : n;
                      return !1;
                  })((r = (e + " " + w.join(s + " ") + s).split(" ")), t, i);
        }
        function e(e, t, i) {
            return n(e, h, h, t, i);
        }
        var l = [],
            c = [],
            t = {
                _version: "3.3.1",
                _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
                _q: [],
                on: function (e, t) {
                    var i = this;
                    setTimeout(function () {
                        t(i[e]);
                    }, 0);
                },
                addTest: function (e, t, i) {
                    c.push({ name: e, fn: t, options: i });
                },
                addAsyncTest: function (e) {
                    c.push({ name: null, fn: e });
                },
            },
            d = function () {};
        (d.prototype = t), (d = new d()).addTest("svg", !!f.createElementNS && !!f.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
        var m = f.documentElement,
            y = "svg" === m.nodeName.toLowerCase(),
            i = "Moz O ms Webkit",
            u = t._config.usePrefixes ? i.split(" ") : [];
        t._cssomPrefixes = u;
        var w = t._config.usePrefixes ? i.toLowerCase().split(" ") : [];
        t._domPrefixes = w;
        var o = { elem: v("modernizr") };
        d._q.push(function () {
            delete o.elem;
        });
        var s,
            r,
            b,
            k,
            $ = { style: o.elem.style };
        d._q.unshift(function () {
            delete $.style;
        }),
            (t.testAllProps = n),
            (t.testAllProps = e),
            d.addTest("flexbox", e("flexBasis", "1px", !0)),
            d.addTest("csstransforms", function () {
                return -1 === navigator.userAgent.indexOf("Android 2.") && e("transform", "scale(1)", !0);
            }),
            (function () {
                var e, t, i, n, o, s;
                for (var r in c)
                    if (c.hasOwnProperty(r)) {
                        if (((e = []), (t = c[r]).name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)))
                            for (i = 0; i < t.options.aliases.length; i++) e.push(t.options.aliases[i].toLowerCase());
                        for (n = a(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++)
                            1 === (s = e[o].split(".")).length ? (d[s[0]] = n) : (!d[s[0]] || d[s[0]] instanceof Boolean || (d[s[0]] = new Boolean(d[s[0]])), (d[s[0]][s[1]] = n)), l.push((n ? "" : "no-") + s.join("-"));
                    }
            })(),
            (s = l),
            (b = m.className),
            (k = d._config.classPrefix || ""),
            y && (b = b.baseVal),
            d._config.enableJSClass && ((r = new RegExp("(^|\\s)" + k + "no-js(\\s|$)")), (b = b.replace(r, "$1" + k + "js$2"))),
            d._config.enableClasses && ((b += " " + k + s.join(" " + k)), y ? (m.className.baseVal = b) : (m.className = b)),
            delete t.addTest,
            delete t.addAsyncTest;
        for (var x = 0; x < d._q.length; x++) d._q[x]();
        p.Modernizr = d;
    })(window, document),
    (function (e) {
        e.fn.prepareTransition = function () {
            return this.each(function () {
                var i = e(this);
                i.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
                    i.removeClass("is-transitioning");
                });
                var n = 0;
                e.each(["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"], function (e, t) {
                    n = n || parseFloat(i.css(t));
                }),
                    0 != n && (i.addClass("is-transitioning"), i[0].offsetWidth);
            });
        };
    })(jQuery),
    (function (e) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? (module.exports = e(require("jquery"))) : e(jQuery);
    })(function (a) {
        "use strict";
        var r = window.Slick,
            o = 0;
        ((r = function (e, t) {
            var i,
                n = this;
            (n.defaults = {
                accessibility: !0,
                appendArrows: a(e),
                appendDots: a(e),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous slide" tabindex="0" role="button">Previous slide</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next slide" tabindex="0" role="button">Next slide</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                cssEase: "ease",
                customPaging: function (e, t) {
                    return a('<button type="button" data-role="none" role="button" tabindex="0" />').text("Slide " + (t + 1));
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: 0.35,
                fade: !1,
                focusOnSelect: !1,
                initialSlide: 0,
                lazyLoad: !0,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                waitForAnimate: !0,
                zIndex: 1e3,
            }),
                (n.initials = {
                    animating: !1,
                    dragging: !1,
                    autoPlayTimer: null,
                    currentDirection: 0,
                    currentLeft: null,
                    currentSlide: 0,
                    direction: 1,
                    $dots: null,
                    listWidth: null,
                    listHeight: null,
                    loadIndex: 0,
                    $nextArrow: null,
                    $prevArrow: null,
                    slideCount: null,
                    slideWidth: null,
                    $slideTrack: null,
                    $slides: null,
                    sliding: !1,
                    slideOffset: 0,
                    swipeLeft: null,
                    $list: null,
                    touchObject: {},
                    transformsEnabled: !1,
                    unslicked: !1,
                }),
                a.extend(n, n.initials),
                (n.activeBreakpoint = null),
                (n.animType = null),
                (n.animProp = null),
                (n.breakpoints = []),
                (n.breakpointSettings = []),
                (n.cssTransitions = !1),
                (n.focussed = !1),
                (n.interrupted = !1),
                (n.hidden = "hidden"),
                (n.paused = !0),
                (n.positionProp = null),
                (n.respondTo = null),
                (n.rowCount = 1),
                (n.shouldClick = !0),
                (n.$slider = a(e)),
                (n.$slidesCache = null),
                (n.transformType = null),
                (n.transitionType = null),
                (n.visibilityChange = "visibilitychange"),
                (n.windowWidth = 0),
                (n.windowTimer = null),
                (i = a(e).data("slick") || {}),
                (n.options = a.extend({}, n.defaults, t, i)),
                (n.currentSlide = n.options.initialSlide),
                (n.originalSettings = n.options),
                void 0 !== document.mozHidden ? ((n.hidden = "mozHidden"), (n.visibilityChange = "mozvisibilitychange")) : void 0 !== document.webkitHidden && ((n.hidden = "webkitHidden"), (n.visibilityChange = "webkitvisibilitychange")),
                (n.autoPlay = a.proxy(n.autoPlay, n)),
                (n.autoPlayClear = a.proxy(n.autoPlayClear, n)),
                (n.autoPlayIterator = a.proxy(n.autoPlayIterator, n)),
                (n.changeSlide = a.proxy(n.changeSlide, n)),
                (n.clickHandler = a.proxy(n.clickHandler, n)),
                (n.selectHandler = a.proxy(n.selectHandler, n)),
                (n.setPosition = a.proxy(n.setPosition, n)),
                (n.swipeHandler = a.proxy(n.swipeHandler, n)),
                (n.dragHandler = a.proxy(n.dragHandler, n)),
                (n.keyHandler = a.proxy(n.keyHandler, n)),
                (n.instanceUid = o++),
                (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                n.init(!0);
        }).prototype.activateADA = function () {
            this.$slides.add(this.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }),
                this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
        }),
            (r.prototype.animateSlide = function (e, t) {
                var i = {},
                    n = this;
                !0 === n.options.rtl && (e = -e),
                    !1 === n.transformsEnabled
                        ? n.$slideTrack.animate({ left: e }, n.options.speed, n.options.easing, t)
                        : !1 === n.cssTransitions
                        ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
                          a({ animStart: n.currentLeft }).animate(
                              { animStart: e },
                              {
                                  duration: n.options.speed,
                                  easing: n.options.easing,
                                  step: function (e) {
                                      (e = Math.ceil(e)), (i[n.animType] = "translate(" + e + "px, 0px)"), n.$slideTrack.css(i);
                                  },
                                  complete: function () {
                                      t && t.call();
                                  },
                              }
                          ))
                        : (n.applyTransition(),
                          (e = Math.ceil(e)),
                          (i[n.animType] = "translate3d(" + e + "px, 0px, 0px)"),
                          n.$slideTrack.css(i),
                          t &&
                              setTimeout(function () {
                                  n.disableTransition(), t.call();
                              }, n.options.speed));
            }),
            (r.prototype.getNavTarget = function () {
                var e = this.options.asNavFor;
                return e && null !== e && (e = a(e).not(this.$slider)), e;
            }),
            (r.prototype.asNavFor = function (t) {
                var e = this.getNavTarget();
                null !== e &&
                    "object" == typeof e &&
                    e.each(function () {
                        var e = a(this).slick("getSlick");
                        e.unslicked || e.slideHandler(t, !0);
                    });
            }),
            (r.prototype.applyTransition = function (e) {
                var t = this,
                    i = {};
                !1 === t.options.fade ? (i[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase) : (i[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase),
                    !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i);
            }),
            (r.prototype.autoPlay = function () {
                var e = this;
                e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed));
            }),
            (r.prototype.autoPlayClear = function () {
                this.autoPlayTimer && clearInterval(this.autoPlayTimer);
            }),
            (r.prototype.autoPlayIterator = function () {
                var e = this,
                    t = e.currentSlide + e.options.slidesToScroll;
                e.paused || e.interrupted || e.focussed || e.slideHandler(t);
            }),
            (r.prototype.buildArrows = function () {
                var e = this;
                !0 === e.options.arrows &&
                    ((e.$prevArrow = a(e.options.prevArrow).addClass("slick-arrow")),
                    (e.$nextArrow = a(e.options.nextArrow).addClass("slick-arrow")),
                    e.slideCount > e.options.slidesToShow
                        ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
                          e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
                          !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                        : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
            }),
            (r.prototype.buildDots = function () {
                var e,
                    t,
                    i = this;
                if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
                    for (i.$slider.addClass("slick-dotted"), t = a("<ul />").addClass(i.options.dotsClass), e = 0; e <= i.getDotCount(); e += 1) t.append(a("<li />").append(i.options.customPaging.call(this, i, e)));
                    (i.$dots = t.appendTo(i.options.appendDots)), i.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
                }
            }),
            (r.prototype.buildOut = function () {
                var e = this;
                (e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                    (e.slideCount = e.$slides.length),
                    e.$slides.each(function (e, t) {
                        a(t)
                            .attr("data-slick-index", e)
                            .data("originalStyling", a(t).attr("style") || "");
                    }),
                    e.$slider.addClass("slick-slider"),
                    (e.$slideTrack = 0 === e.slideCount ? a('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
                    (e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent()),
                    e.$slideTrack.css("opacity", 0),
                    !0 === e.options.swipeToSlide && (e.options.slidesToScroll = 1),
                    a("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
                    e.setupInfinite(),
                    e.buildArrows(),
                    e.buildDots(),
                    e.updateDots(),
                    e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
                    !0 === e.options.draggable && e.$list.addClass("draggable");
            }),
            (r.prototype.buildRows = function () {
                var e,
                    t,
                    i,
                    n = this,
                    o = document.createDocumentFragment(),
                    s = n.$slider.children();
                if (1 < n.options.rows) {
                    for (i = n.options.slidesPerRow * n.options.rows, t = Math.ceil(s.length / i), e = 0; e < t; e++) {
                        for (var r = document.createElement("div"), a = 0; a < n.options.rows; a++) {
                            for (var l = document.createElement("div"), c = 0; c < n.options.slidesPerRow; c++) {
                                var d = e * i + (a * n.options.slidesPerRow + c);
                                s.get(d) && l.appendChild(s.get(d));
                            }
                            r.appendChild(l);
                        }
                        o.appendChild(r);
                    }
                    n.$slider.empty().append(o),
                        n.$slider
                            .children()
                            .children()
                            .children()
                            .css({ width: 100 / n.options.slidesPerRow + "%", display: "inline-block" });
                }
            }),
            (r.prototype.changeSlide = function (e, t) {
                var i,
                    n,
                    o = this,
                    s = a(e.currentTarget);
                switch ((s.is("a") && e.preventDefault(), s.is("li") || (s = s.closest("li")), (i = o.slideCount % o.options.slidesToScroll != 0 ? 0 : (o.slideCount - o.currentSlide) % o.options.slidesToScroll), e.data.message)) {
                    case "previous":
                        (n = 0 == i ? o.options.slidesToScroll : o.options.slidesToShow - i), o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - n, !1, t);
                        break;
                    case "next":
                        (n = 0 == i ? o.options.slidesToScroll : i), o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + n, !1, t);
                        break;
                    case "index":
                        var r = 0 === e.data.index ? 0 : e.data.index || s.index() * o.options.slidesToScroll;
                        o.slideHandler(o.checkNavigable(r), !1, t), s.children().trigger("focus");
                        break;
                    default:
                        return;
                }
            }),
            (r.prototype.checkNavigable = function (e) {
                var t,
                    i = 0;
                if (e > (t = this.getNavigableIndexes())[t.length - 1]) e = t[t.length - 1];
                else
                    for (var n in t) {
                        if (e < t[n]) {
                            e = i;
                            break;
                        }
                        i = t[n];
                    }
                return e;
            }),
            (r.prototype.cleanUpEvents = function () {
                var e = this;
                e.options.dots && null !== e.$dots && a("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", a.proxy(e.interrupt, e, !0)).off("mouseleave.slick", a.proxy(e.interrupt, e, !1)),
                    e.$slider.off("focus.slick blur.slick"),
                    !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
                    e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
                    e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
                    e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
                    e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
                    e.$list.off("click.slick", e.clickHandler),
                    a(document).off(e.visibilityChange, e.visibility),
                    e.cleanUpSlideEvents(),
                    !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler),
                    !0 === e.options.focusOnSelect && a(e.$slideTrack).children().off("click.slick", e.selectHandler),
                    a(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
                    a(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
                    a("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
                    a(window).off("load.slick.slick-" + e.instanceUid, e.setPosition),
                    a(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition);
            }),
            (r.prototype.cleanUpSlideEvents = function () {
                var e = this;
                e.$list.off("mouseenter.slick", a.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", a.proxy(e.interrupt, e, !1));
            }),
            (r.prototype.cleanUpRows = function () {
                var e;
                1 < this.options.rows && ((e = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(e));
            }),
            (r.prototype.clickHandler = function (e) {
                !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault());
            }),
            (r.prototype.destroy = function (e) {
                var t = this;
                t.autoPlayClear(),
                    (t.touchObject = {}),
                    t.cleanUpEvents(),
                    a(".slick-cloned", t.$slider).detach(),
                    t.$dots && t.$dots.remove(),
                    t.$prevArrow &&
                        t.$prevArrow.length &&
                        (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
                    t.$nextArrow &&
                        t.$nextArrow.length &&
                        (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
                    t.$slides &&
                        (t.$slides
                            .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                            .removeAttr("aria-hidden")
                            .removeAttr("data-slick-index")
                            .each(function () {
                                a(this).attr("style", a(this).data("originalStyling"));
                            }),
                        t.$slideTrack.children(this.options.slide).detach(),
                        t.$slideTrack.detach(),
                        t.$list.detach(),
                        t.$slider.append(t.$slides)),
                    t.cleanUpRows(),
                    t.$slider.removeClass("slick-slider"),
                    t.$slider.removeClass("slick-initialized"),
                    t.$slider.removeClass("slick-dotted"),
                    (t.unslicked = !0),
                    e || t.$slider.trigger("destroy", [t]);
            }),
            (r.prototype.disableTransition = function (e) {
                var t = {};
                (t[this.transitionType] = ""), !1 === this.options.fade ? this.$slideTrack.css(t) : this.$slides.eq(e).css(t);
            }),
            (r.prototype.fadeSlide = function (e, t) {
                var i = this;
                !1 === i.cssTransitions
                    ? (i.$slides.eq(e).css({ zIndex: i.options.zIndex }), i.$slides.eq(e).animate({ opacity: 1 }, i.options.speed, i.options.easing, t))
                    : (i.applyTransition(e),
                      i.$slides.eq(e).css({ opacity: 1, zIndex: i.options.zIndex }),
                      t &&
                          setTimeout(function () {
                              i.disableTransition(e), t.call();
                          }, i.options.speed));
            }),
            (r.prototype.fadeSlideOut = function (e) {
                var t = this;
                !1 === t.cssTransitions ? t.$slides.eq(e).animate({ opacity: 0, zIndex: t.options.zIndex - 2 }, t.options.speed, t.options.easing) : (t.applyTransition(e), t.$slides.eq(e).css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
            }),
            (r.prototype.filterSlides = r.prototype.slickFilter = function (e) {
                var t = this;
                null !== e && ((t.$slidesCache = t.$slides), t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit());
            }),
            (r.prototype.focusHandler = function () {
                var i = this;
                i.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function (e) {
                    e.stopImmediatePropagation();
                    var t = a(this);
                    setTimeout(function () {
                        i.options.pauseOnFocus && ((i.focussed = t.is(":focus")), i.autoPlay());
                    }, 0);
                });
            }),
            (r.prototype.getCurrent = r.prototype.slickCurrentSlide = function () {
                return this.currentSlide;
            }),
            (r.prototype.getDotCount = function () {
                for (var e = this, t = 0, i = 0, n = 0; t < e.slideCount; ) ++n, (t = i + e.options.slidesToScroll), (i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                return n - 1;
            }),
            (r.prototype.getLeft = function (e) {
                var t = this;
                return (
                    (t.slideOffset = 0),
                    t.$slides.first().outerHeight(!0),
                    t.slideCount > t.options.slidesToShow && ((t.slideOffset = t.slideWidth * t.options.slidesToShow * -1), t.options.slidesToShow),
                    t.slideCount % t.options.slidesToScroll != 0 &&
                        e + t.options.slidesToScroll > t.slideCount &&
                        t.slideCount > t.options.slidesToShow &&
                        (e > t.slideCount
                            ? ((t.slideOffset = (t.options.slidesToShow - (e - t.slideCount)) * t.slideWidth * -1), t.options.slidesToShow, t.slideCount)
                            : ((t.slideOffset = (t.slideCount % t.options.slidesToScroll) * t.slideWidth * -1), t.slideCount, t.options.slidesToScroll)),
                    t.slideCount <= t.options.slidesToShow && (t.slideOffset = 0),
                    e * t.slideWidth * -1 + t.slideOffset
                );
            }),
            (r.prototype.getOption = r.prototype.slickGetOption = function (e) {
                return this.options[e];
            }),
            (r.prototype.getNavigableIndexes = function () {
                for (var e = this, t = 0, i = 0, n = [], t = -1 * e.options.slidesToScroll, i = -1 * e.options.slidesToScroll, o = 2 * e.slideCount; t < o; )
                    n.push(t), (t = i + e.options.slidesToScroll), (i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                return n;
            }),
            (r.prototype.getSlick = function () {
                return this;
            }),
            (r.prototype.getSlideCount = function () {
                var i,
                    n = this;
                return !0 === n.options.swipeToSlide
                    ? (n.$slideTrack.find(".slick-slide").each(function (e, t) {
                          if (+t.offsetLeft + a(t).outerWidth() / 2 > -1 * n.swipeLeft) return (i = t), !1;
                      }),
                      Math.abs(a(i).attr("data-slick-index") - n.currentSlide) || 1)
                    : n.options.slidesToScroll;
            }),
            (r.prototype.goTo = r.prototype.slickGoTo = function (e, t) {
                this.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
            }),
            (r.prototype.init = function (e) {
                var t = this;
                a(t.$slider).hasClass("slick-initialized") || (a(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateDots(), t.focusHandler()),
                    e && t.$slider.trigger("init", [t]),
                    !0 === t.options.accessibility && t.initADA(),
                    t.options.autoplay && ((t.paused = !1), t.autoPlay());
            }),
            (r.prototype.initADA = function () {
                var i,
                    n,
                    o,
                    s = this;
                s.$slides.not(s.$slideTrack.find(".slick-cloned")).each(function (e) {
                    a(this).attr("role", "option");
                    var t = Math.floor(e / s.options.slidesToShow);
                    !0 === s.options.dots &&
                        ((n = "" + s.instanceUid + t),
                        i === (o = n) && (n = "" + n + e),
                        a(this)
                            .attr("id", "slickSlide" + n)
                            .attr("role", "tabpanel")
                            .attr("aria-labelledby", "slickDot" + o),
                        (i = "" + s.instanceUid + t));
                }),
                    null !== s.$dots &&
                        s.$dots
                            .attr("role", "tablist")
                            .find("li")
                            .each(function (e) {
                                a(this).attr({ role: "tab", "aria-selected": "false", "aria-controls": "slickSlide" + s.instanceUid + e, id: "slickDot" + s.instanceUid + e });
                            })
                            .first()
                            .attr("aria-selected", "true"),
                    s.activateADA();
            }),
            (r.prototype.initArrowEvents = function () {
                var e = this;
                !0 === e.options.arrows &&
                    e.slideCount > e.options.slidesToShow &&
                    (e.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, e.changeSlide));
            }),
            (r.prototype.updateADA = function () {
                null !== this.$dots && (this.$dots.find("li").attr("aria-selected", "false"), this.$dots.find(".slick-active").attr("aria-selected", "true")), this.activateADA();
            }),
            (r.prototype.initArrowEvents = function () {
                var e = this;
                !0 === e.options.arrows &&
                    e.slideCount > e.options.slidesToShow &&
                    (e.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, e.changeSlide));
            }),
            (r.prototype.initDotEvents = function () {
                var e = this;
                !0 === e.options.dots && e.slideCount > e.options.slidesToShow && a("li", e.$dots).on("click.slick", { message: "index" }, e.changeSlide),
                    !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && a("li", e.$dots).on("mouseenter.slick", a.proxy(e.interrupt, e, !0)).on("mouseleave.slick", a.proxy(e.interrupt, e, !1));
            }),
            (r.prototype.initSlideEvents = function () {
                var e = this;
                e.options.pauseOnHover && (e.$list.on("mouseenter.slick", a.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", a.proxy(e.interrupt, e, !1)));
            }),
            (r.prototype.initializeEvents = function () {
                var e = this;
                e.initArrowEvents(),
                    e.initDotEvents(),
                    e.initSlideEvents(),
                    e.$list.on("touchstart.slick mousedown.slick", { action: "start" }, e.swipeHandler),
                    e.$list.on("touchmove.slick mousemove.slick", { action: "move" }, e.swipeHandler),
                    e.$list.on("touchend.slick mouseup.slick", { action: "end" }, e.swipeHandler),
                    e.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, e.swipeHandler),
                    e.$list.on("click.slick", e.clickHandler),
                    a(document).on(e.visibilityChange, a.proxy(e.visibility, e)),
                    !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler),
                    !0 === e.options.focusOnSelect && a(e.$slideTrack).children().on("click.slick", e.selectHandler),
                    a(window).on("orientationchange.slick.slick-" + e.instanceUid, a.proxy(e.orientationChange, e)),
                    a(window).on("resize.slick.slick-" + e.instanceUid, a.proxy(e.resize, e)),
                    a("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
                    a(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
                    a(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition);
            }),
            (r.prototype.initUI = function () {
                var e = this;
                !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show();
            }),
            (r.prototype.keyHandler = function (e) {
                var t = this;
                e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                    (37 === e.keyCode && !0 === t.options.accessibility
                        ? t.changeSlide({ data: { message: !0 === t.options.rtl ? "next" : "previous" } })
                        : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({ data: { message: !0 === t.options.rtl ? "previous" : "next" } }));
            }),
            (r.prototype.lazyLoad = function () {
                function e(e) {
                    a("img[data-lazy]", e).each(function () {
                        var e = a(this),
                            t = a(this).attr("data-lazy"),
                            i = document.createElement("img");
                        (i.onload = function () {
                            e.animate({ opacity: 0 }, 100, function () {
                                e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                                    e.removeAttr("data-lazy").removeClass("slick-loading");
                                }),
                                    n.$slider.trigger("lazyLoaded", [n, e, t]);
                            });
                        }),
                            (i.onerror = function () {
                                e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, e, t]);
                            }),
                            (i.src = t);
                    });
                }
                var n = this,
                    t = n.options.slidesToShow,
                    i = Math.ceil(t + n.options.slidesToShow);
                !0 === n.options.fade && (0 < t && t--, i <= n.slideCount && i++),
                    e(n.$slider.find(".slick-slide").slice(t, i)),
                    n.slideCount <= n.options.slidesToShow
                        ? e(n.$slider.find(".slick-slide"))
                        : n.currentSlide >= n.slideCount - n.options.slidesToShow
                        ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow))
                        : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow));
            }),
            (r.prototype.loadSlider = function () {
                this.setPosition(), this.$slideTrack.css({ opacity: 1 }), this.$slider.removeClass("slick-loading"), this.initUI();
            }),
            (r.prototype.next = r.prototype.slickNext = function () {
                this.changeSlide({ data: { message: "next" } });
            }),
            (r.prototype.orientationChange = function () {
                this.setPosition();
            }),
            (r.prototype.pause = r.prototype.slickPause = function () {
                this.autoPlayClear(), (this.paused = !0);
            }),
            (r.prototype.play = r.prototype.slickPlay = function () {
                var e = this;
                e.autoPlay(), (e.options.autoplay = !0), (e.paused = !1), (e.focussed = !1), (e.interrupted = !1);
            }),
            (r.prototype.postSlide = function (e) {
                var t = this;
                t.unslicked || (t.$slider.trigger("afterChange", [t, e]), (t.animating = !1), t.setPosition(), (t.swipeLeft = null), t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && t.updateADA());
            }),
            (r.prototype.prev = r.prototype.slickPrev = function () {
                this.changeSlide({ data: { message: "previous" } });
            }),
            (r.prototype.preventDefault = function (e) {
                e.preventDefault();
            }),
            (r.prototype.refresh = function (e) {
                var t,
                    i = this;
                i.slideCount,
                    i.options.slidesToShow,
                    i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0),
                    (t = i.currentSlide),
                    i.destroy(!0),
                    a.extend(i, i.initials, { currentSlide: t }),
                    i.init(),
                    e || i.changeSlide({ data: { message: "index", index: t } }, !1);
            }),
            (r.prototype.reinit = function () {
                var e = this;
                (e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide")),
                    (e.slideCount = e.$slides.length),
                    e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
                    e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
                    e.setProps(),
                    e.setupInfinite(),
                    e.buildArrows(),
                    e.initArrowEvents(),
                    e.buildDots(),
                    e.updateDots(),
                    e.initDotEvents(),
                    e.cleanUpSlideEvents(),
                    e.initSlideEvents(),
                    !0 === e.options.focusOnSelect && a(e.$slideTrack).children().on("click.slick", e.selectHandler),
                    e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
                    e.setPosition(),
                    e.focusHandler(),
                    (e.paused = !e.options.autoplay),
                    e.autoPlay(),
                    e.$slider.trigger("reInit", [e]);
            }),
            (r.prototype.resize = function () {
                var e = this;
                a(window).width() !== e.windowWidth &&
                    (clearTimeout(e.windowDelay),
                    (e.windowDelay = window.setTimeout(function () {
                        (e.windowWidth = a(window).width()), e.unslicked || e.setPosition();
                    }, 50)));
            }),
            (r.prototype.setCSS = function (e) {
                var t,
                    i,
                    n = this,
                    o = {};
                !0 === n.options.rtl && (e = -e),
                    (t = "left" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
                    (i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
                    (o[n.positionProp] = e),
                    !1 === n.transformsEnabled || (!(o = {}) === n.cssTransitions ? (o[n.animType] = "translate(" + t + ", " + i + ")") : (o[n.animType] = "translate3d(" + t + ", " + i + ", 0px)")),
                    n.$slideTrack.css(o);
            }),
            (r.prototype.setDimensions = function () {
                var e = this;
                (e.listWidth = e.$list.width()),
                    (e.listHeight = e.$list.height()),
                    (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)),
                    e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length));
                var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
                e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
            }),
            (r.prototype.setFade = function () {
                var i,
                    n = this;
                n.$slides.each(function (e, t) {
                    (i = n.slideWidth * e * -1),
                        !0 === n.options.rtl ? a(t).css({ position: "relative", right: i, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 }) : a(t).css({ position: "relative", left: i, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 });
                }),
                    n.$slides.eq(n.currentSlide).css({ zIndex: n.options.zIndex - 1, opacity: 1 });
            }),
            (r.prototype.setOption = r.prototype.slickSetOption = function () {
                var e,
                    t,
                    i,
                    n = this,
                    o = !1;
                "object" === a.type(arguments[0]) ? ((e = arguments[0]), (o = arguments[1]), (i = "multiple")) : "string" === a.type(arguments[0]) && ((e = arguments[0]), (o = arguments[2]), void 0 !== (t = arguments[1]) && (i = "single")),
                    "single" === i
                        ? (n.options[e] = t)
                        : "multiple" === i &&
                          a.each(e, function (e, t) {
                              n.options[e] = t;
                          }),
                    o && (n.unload(), n.reinit());
            }),
            (r.prototype.setPosition = function () {
                var e = this;
                e.setDimensions(), !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e]);
            }),
            (r.prototype.setProps = function () {
                var e = this,
                    t = document.body.style;
                (e.positionProp = "left"),
                    e.$slider.removeClass("slick-vertical"),
                    (void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition) || (!0 === e.options.useCSS && (e.cssTransitions = !0)),
                    e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : (e.options.zIndex = e.defaults.zIndex)),
                    void 0 !== t.OTransform && ((e.animType = "OTransform"), (e.transformType = "-o-transform"), (e.transitionType = "OTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                    void 0 !== t.MozTransform &&
                        ((e.animType = "MozTransform"), (e.transformType = "-moz-transform"), (e.transitionType = "MozTransition"), void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)),
                    void 0 !== t.webkitTransform &&
                        ((e.animType = "webkitTransform"), (e.transformType = "-webkit-transform"), (e.transitionType = "webkitTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                    void 0 !== t.msTransform && ((e.animType = "msTransform"), (e.transformType = "-ms-transform"), (e.transitionType = "msTransition"), void 0 === t.msTransform && (e.animType = !1)),
                    void 0 !== t.transform && !1 !== e.animType && ((e.animType = "transform"), (e.transformType = "transform"), (e.transitionType = "transition")),
                    (e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType);
            }),
            (r.prototype.setSlideClasses = function (e) {
                var t,
                    i,
                    n = this,
                    o = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true");
                n.$slides.eq(e).addClass("slick-current"),
                    0 <= e && e <= n.slideCount - n.options.slidesToShow
                        ? n.$slides
                              .slice(e, e + n.options.slidesToShow)
                              .addClass("slick-active")
                              .attr("aria-hidden", "false")
                        : o.length <= n.options.slidesToShow
                        ? o.addClass("slick-active").attr("aria-hidden", "false")
                        : ((i = n.slideCount % n.options.slidesToShow),
                          (t = n.options.slidesToShow + e),
                          n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - e < n.options.slidesToShow
                              ? o
                                    .slice(t - (n.options.slidesToShow - i), t + i)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false")
                              : o
                                    .slice(t, t + n.options.slidesToShow)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false")),
                    !0 === n.options.lazyLoad && n.lazyLoad();
            }),
            (r.prototype.setupInfinite = function () {
                var e,
                    t,
                    i,
                    n = this;
                if (!1 === n.options.fade && ((t = null), n.slideCount > n.options.slidesToShow)) {
                    for (i = n.options.slidesToShow, e = n.slideCount; e > n.slideCount - i; --e)
                        (t = e - 1),
                            a(n.$slides[t])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", t - n.slideCount)
                                .prependTo(n.$slideTrack)
                                .addClass("slick-cloned");
                    for (e = 0; e < i; e += 1)
                        (t = e),
                            a(n.$slides[t])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", t + n.slideCount)
                                .appendTo(n.$slideTrack)
                                .addClass("slick-cloned");
                    n.$slideTrack
                        .find(".slick-cloned")
                        .find("[id]")
                        .each(function () {
                            a(this).attr("id", "");
                        });
                }
            }),
            (r.prototype.interrupt = function (e) {
                e || this.autoPlay(), (this.interrupted = e);
            }),
            (r.prototype.selectHandler = function (e) {
                var t = this,
                    i = a(e.target).is(".slick-slide") ? a(e.target) : a(e.target).parents(".slick-slide"),
                    n = (n = parseInt(i.attr("data-slick-index"))) || 0;
                return t.slideCount <= t.options.slidesToShow ? (t.setSlideClasses(n), void t.asNavFor(n)) : void t.slideHandler(n);
            }),
            (r.prototype.slideHandler = function (e, t, i) {
                var n,
                    o,
                    s,
                    r,
                    a,
                    l = null,
                    c = this;
                if (((t = t || !1), (!0 !== c.animating || !0 !== c.options.waitForAnimate) && !((!0 === c.options.fade && c.currentSlide === e) || c.slideCount <= c.options.slidesToShow)))
                    return (
                        !1 === t && c.asNavFor(e),
                        (n = e),
                        (l = c.getLeft(n)),
                        (r = c.getLeft(c.currentSlide)),
                        (c.currentLeft = null === c.swipeLeft ? r : c.swipeLeft),
                        c.options.autoplay && clearInterval(c.autoPlayTimer),
                        (o =
                            n < 0
                                ? c.slideCount % c.options.slidesToScroll != 0
                                    ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                                    : c.slideCount + n
                                : n >= c.slideCount
                                ? c.slideCount % c.options.slidesToScroll != 0
                                    ? 0
                                    : n - c.slideCount
                                : n),
                        (c.animating = !0),
                        c.$slider.trigger("beforeChange", [c, c.currentSlide, o]),
                        (s = c.currentSlide),
                        (c.currentSlide = o),
                        c.setSlideClasses(c.currentSlide),
                        c.options.asNavFor && (a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(c.currentSlide),
                        c.updateDots(),
                        !0 === c.options.fade
                            ? void (!0 !== i
                                  ? (c.fadeSlideOut(s),
                                    c.fadeSlide(o, function () {
                                        c.postSlide(o);
                                    }))
                                  : c.postSlide(o))
                            : void (!0 !== i
                                  ? c.animateSlide(l, function () {
                                        c.postSlide(o);
                                    })
                                  : c.postSlide(o))
                    );
            }),
            (r.prototype.startLoad = function () {
                var e = this;
                !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()),
                    !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
                    e.$slider.addClass("slick-loading");
            }),
            (r.prototype.swipeDirection = function () {
                var e,
                    t = this,
                    i = t.touchObject.startX - t.touchObject.curX,
                    n = t.touchObject.startY - t.touchObject.curY,
                    o = Math.atan2(n, i);
                return (
                    (e = Math.round((180 * o) / Math.PI)) < 0 && (e = 360 - Math.abs(e)),
                    (e <= 45 && 0 <= e) || (e <= 360 && 315 <= e) ? (!1 === t.options.rtl ? "left" : "right") : 135 <= e && e <= 225 ? (!1 === t.options.rtl ? "right" : "left") : "vertical"
                );
            }),
            (r.prototype.swipeEnd = function (e) {
                var t,
                    i,
                    n = this;
                if (((n.dragging = !1), (n.interrupted = !1), (n.shouldClick = !(10 < n.touchObject.swipeLength)), void 0 === n.touchObject.curX)) return !1;
                if ((!0 === n.touchObject.edgeHit && n.$slider.trigger("edge", [n, n.swipeDirection()]), n.touchObject.swipeLength >= n.touchObject.minSwipe)) {
                    switch ((i = n.swipeDirection())) {
                        case "left":
                        case "down":
                            (t = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide + n.getSlideCount()) : n.currentSlide + n.getSlideCount()), (n.currentDirection = 0);
                            break;
                        case "right":
                        case "up":
                            (t = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide - n.getSlideCount()) : n.currentSlide - n.getSlideCount()), (n.currentDirection = 1);
                    }
                    "vertical" != i && (n.slideHandler(t), (n.touchObject = {}), n.$slider.trigger("swipe", [n, i]));
                } else n.touchObject.startX !== n.touchObject.curX && (n.slideHandler(n.currentSlide), (n.touchObject = {}));
            }),
            (r.prototype.swipeHandler = function (e) {
                var t = this;
                if (!(!1 === t.options.swipe || ("ontouchend" in document && !1 === t.options.swipe) || (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))))
                    switch (((t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1), (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold), e.data.action)) {
                        case "start":
                            t.swipeStart(e);
                            break;
                        case "move":
                            t.swipeMove(e);
                            break;
                        case "end":
                            t.swipeEnd(e);
                    }
            }),
            (r.prototype.swipeMove = function (e) {
                var t,
                    i,
                    n,
                    o = this,
                    s = void 0 !== e.originalEvent ? e.originalEvent.touches : null;
                return (
                    !(!o.dragging || (s && 1 !== s.length)) &&
                    ((t = o.getLeft(o.currentSlide)),
                    (o.touchObject.curX = void 0 !== s ? s[0].pageX : e.clientX),
                    (o.touchObject.curY = void 0 !== s ? s[0].pageY : e.clientY),
                    (o.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(o.touchObject.curX - o.touchObject.startX, 2)))),
                    "vertical" !== o.swipeDirection()
                        ? (void 0 !== e.originalEvent && 4 < o.touchObject.swipeLength && e.preventDefault(),
                          (n = (!1 === o.options.rtl ? 1 : -1) * (o.touchObject.curX > o.touchObject.startX ? 1 : -1)),
                          !0 === o.options.verticalSwiping && (n = o.touchObject.curY > o.touchObject.startY ? 1 : -1),
                          (i = o.touchObject.swipeLength),
                          (o.touchObject.edgeHit = !1),
                          (o.swipeLeft = t + i * n),
                          !0 !== o.options.fade && !1 !== o.options.touchMove && (!0 === o.animating ? ((o.swipeLeft = null), !1) : void o.setCSS(o.swipeLeft)))
                        : void 0)
                );
            }),
            (r.prototype.swipeStart = function (e) {
                var t,
                    i = this;
                return (
                    (i.interrupted = !0),
                    1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow
                        ? !(i.touchObject = {})
                        : (void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]),
                          (i.touchObject.startX = i.touchObject.curX = void 0 !== t ? t.pageX : e.clientX),
                          (i.touchObject.startY = i.touchObject.curY = void 0 !== t ? t.pageY : e.clientY),
                          void (i.dragging = !0))
                );
            }),
            (r.prototype.unfilterSlides = r.prototype.slickUnfilter = function () {
                var e = this;
                null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit());
            }),
            (r.prototype.unload = function () {
                var e = this;
                a(".slick-cloned", e.$slider).remove(),
                    e.$dots && e.$dots.remove(),
                    e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
                    e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
                    e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
            }),
            (r.prototype.unslick = function (e) {
                this.$slider.trigger("unslick", [this, e]), this.destroy();
            }),
            (r.prototype.updateDots = function () {
                var e = this;
                null !== e.$dots &&
                    (e.$dots.find("li").removeClass("slick-active"),
                    e.$dots
                        .find("li")
                        .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
                        .addClass("slick-active"));
            }),
            (r.prototype.visibility = function () {
                this.options.autoplay && (document[this.hidden] ? (this.interrupted = !0) : (this.interrupted = !1));
            }),
            (a.fn.slick = function () {
                for (var e, t = this, i = arguments[0], n = Array.prototype.slice.call(arguments, 1), o = t.length, s = 0; s < o; s++)
                    if (("object" == typeof i || void 0 === i ? (t[s].slick = new r(t[s], i)) : (e = t[s].slick[i].apply(t[s].slick, n)), void 0 !== e)) return e;
                return t;
            });
    }),
    (function (e, d) {
        var n,
            t = e.jQuery || e.Cowboy || (e.Cowboy = {});
        (t.throttle = n = function (o, s, r, a) {
            function e() {
                function e() {
                    (c = +new Date()), r.apply(t, n);
                }
                var t = this,
                    i = new Date() - c,
                    n = arguments;
                a && !l && e(),
                    l && clearTimeout(l),
                    a === d && o < i
                        ? e()
                        : !0 !== s &&
                          (l = setTimeout(
                              a
                                  ? function () {
                                        l = d;
                                    }
                                  : e,
                              a === d ? o - i : o
                          ));
            }
            var l,
                c = 0;
            return "boolean" != typeof s && ((a = r), (r = s), (s = d)), t.guid && (e.guid = r.guid = r.guid || t.guid++), e;
        }),
            (t.debounce = function (e, t, i) {
                return i === d ? n(e, t, !1) : n(e, i, !1 !== t);
            });
    })(this),
    (window.theme = window.theme || {}),
    (theme.Sections = function () {
        (this.constructors = {}),
            (this.instances = []),
            $(document)
                .on("shopify:section:load", this._onSectionLoad.bind(this))
                .on("shopify:section:unload", this._onSectionUnload.bind(this))
                .on("shopify:section:select", this._onSelect.bind(this))
                .on("shopify:section:deselect", this._onDeselect.bind(this))
                .on("shopify:block:select", this._onBlockSelect.bind(this))
                .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
    }),
    (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function (e, t) {
            var i,
                n = $(e),
                o = n.attr("data-section-id"),
                s = n.attr("data-section-type");
            (t = t || this.constructors[s]), _.isUndefined(t) || ((i = _.assignIn(new t(e), { id: o, type: s, container: e })), this.instances.push(i));
        },
        _onSectionLoad: function (e) {
            var t = $("[data-section-id]", e.target)[0];
            t && this._createInstance(t);
        },
        _onSectionUnload: function (i) {
            this.instances = _.filter(this.instances, function (e) {
                var t = e.id === i.detail.sectionId;
                return t && _.isFunction(e.onUnload) && e.onUnload(i), !t;
            });
        },
        _onSelect: function (t) {
            var e = _.find(this.instances, function (e) {
                return e.id === t.detail.sectionId;
            });
            !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t);
        },
        _onDeselect: function (t) {
            var e = _.find(this.instances, function (e) {
                return e.id === t.detail.sectionId;
            });
            !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t);
        },
        _onBlockSelect: function (t) {
            var e = _.find(this.instances, function (e) {
                return e.id === t.detail.sectionId;
            });
            !_.isUndefined(e) && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t);
        },
        _onBlockDeselect: function (t) {
            var e = _.find(this.instances, function (e) {
                return e.id === t.detail.sectionId;
            });
            !_.isUndefined(e) && _.isFunction(e.onBlockDeselect) && e.onBlockDeselect(t);
        },
        register: function (e, i) {
            (this.constructors[e] = i),
                $("[data-section-type=" + e + "]").each(
                    function (e, t) {
                        this._createInstance(t, i);
                    }.bind(this)
                );
        },
    })),
    (window.slate = window.slate || {}),
    (slate.utils = {
        getParameterByName: function (e, t) {
            (t = t || window.location.href), (e = e.replace(/[[\]]/g, "\\$&"));
            var i = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
            return i ? (i[2] ? decodeURIComponent(i[2].replace(/\+/g, " ")) : "") : null;
        },
        keyboardKeys: { TAB: 9, ENTER: 13, ESCAPE: 27, LEFTARROW: 37, RIGHTARROW: 39 },
    }),
    (window.slate = window.slate || {}),
    (slate.rte = {
        wrapTable: function (e) {
            e.$tables.wrap('<div class="' + e.tableWrapperClass + '"></div>');
        },
        wrapIframe: function (e) {
            e.$iframes.each(function () {
                $(this).wrap('<div class="' + e.iframeWrapperClass + '"></div>'), this.src;
            });
        },
    }),
    (window.slate = window.slate || {}),
    (slate.a11y = {
        pageLinkFocus: function (e) {
            var t = "js-focus-hidden";
            e.first()
                .attr("tabIndex", "-1")
                .focus()
                .addClass(t)
                .one("blur", function () {
                    e.first().removeClass(t).removeAttr("tabindex");
                });
        },
        focusHash: function () {
            var e = window.location.hash;
            e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e));
        },
        bindInPageLinks: function () {
            $("a[href*=#]").on(
                "click",
                function (e) {
                    this.pageLinkFocus($(e.currentTarget.hash));
                }.bind(this)
            );
        },
        trapFocus: function (e) {
            var t = { focusin: e.namespace ? "focusin." + e.namespace : "focusin", focusout: e.namespace ? "focusout." + e.namespace : "focusout", keydown: e.namespace ? "keydown." + e.namespace : "keydown.handleFocus" },
                i = e.$container.find($('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])').filter(":visible")),
                n = i[0],
                o = i[i.length - 1];
            e.$elementToFocus || (e.$elementToFocus = e.$container),
                e.$container.attr("tabindex", "-1"),
                e.$elementToFocus.focus(),
                $(document).off("focusin"),
                $(document).on(t.focusout, function () {
                    $(document).off(t.keydown);
                }),
                $(document).on(t.focusin, function (e) {
                    (e.target !== o && e.target !== n) ||
                        $(document).on(t.keydown, function (e) {
                            var t;
                            (t = e).keyCode === slate.utils.keyboardKeys.TAB && (t.target !== o || t.shiftKey || (t.preventDefault(), n.focus()), t.target === n && t.shiftKey && (t.preventDefault(), o.focus()));
                        });
                });
        },
        removeTrapFocus: function (e) {
            var t = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$container && e.$container.length && e.$container.removeAttr("tabindex"), $(document).off(t);
        },
        accessibleLinks: function (e) {
            var s = document.querySelector("body"),
                r = { newWindow: "a11y-new-window-message", external: "a11y-external-message", newWindowExternal: "a11y-new-window-external-message" };
            (void 0 !== e.$links && e.$links.jquery) || (e.$links = $("a[href]:not([aria-describedby])")),
                $.each(e.$links, function () {
                    var e,
                        t = $(this),
                        i = t.attr("target"),
                        n = t.attr("rel"),
                        o = ((e = window.location.hostname), t[0].hostname !== e),
                        s = "_blank" === i;
                    o && t.attr("aria-describedby", r.external),
                        s &&
                            ((void 0 !== n && -1 !== n.indexOf("noopener")) ||
                                t.attr("rel", function (e, t) {
                                    return (void 0 === t ? "" : t + " ") + "noopener";
                                }),
                            t.attr("aria-describedby", r.newWindow)),
                        o && s && t.attr("aria-describedby", r.newWindowExternal);
                }),
                (function (e) {
                    "object" != typeof e && (e = {});
                    var t = $.extend({ newWindow: "Opens in a new window.", external: "Opens external website.", newWindowExternal: "Opens external website in a new window." }, e),
                        i = document.createElement("ul"),
                        n = "";
                    for (var o in t) n += "<li id=" + r[o] + ">" + t[o] + "</li>";
                    i.setAttribute("hidden", !0), (i.innerHTML = n), s.appendChild(i);
                })(e.messages);
        },
    }),
    (theme.Images = {
        preload: function (e, t) {
            "string" == typeof e && (e = [e]);
            for (var i = 0; i < e.length; i++) {
                var n = e[i];
                this.loadImage(this.getSizedImageUrl(n, t));
            }
        },
        loadImage: function (e) {
            new Image().src = e;
        },
        switchImage: function (e, t, i) {
            var n = this.imageSize(t.src),
                o = this.getSizedImageUrl(e.src, n);
            i ? i(o, e, t) : (t.src = o);
        },
        imageSize: function (e) {
            var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
            return null !== t ? (void 0 !== t[2] ? t[1] + t[2] : t[1]) : null;
        },
        getSizedImageUrl: function (e, t) {
            if (null === t) return e;
            if ("master" === t) return this.removeProtocol(e);
            var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null === i) return null;
            var n = e.split(i[0]),
                o = i[0];
            return this.removeProtocol(n[0] + "_" + t + o);
        },
        removeProtocol: function (e) {
            return e.replace(/http(s)?:/, "");
        },
    }),
    (theme.Currency = {
        formatMoney: function (e, t) {
            "string" == typeof e && (e = e.replace(".", ""));
            var i = "",
                n = /\{\{\s*(\w+)\s*\}\}/,
                o = t || "${{amount}}";
            function s(e, t, i, n) {
                if (((i = i || ","), (n = n || "."), isNaN(e) || null === e)) return 0;
                var o = (e = (e / 100).toFixed(t)).split(".");
                return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (o[1] ? n + o[1] : "");
            }
            switch (o.match(n)[1]) {
                case "amount":
                    i = s(e, 2);
                    break;
                case "amount_no_decimals":
                    i = s(e, 0);
                    break;
                case "amount_with_comma_separator":
                    i = s(e, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    i = s(e, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    i = s(e, 0, " ");
                    break;
                case "amount_with_apostrophe_separator":
                    i = s(e, 2, "'");
            }
            return o.replace(n, i);
        },
    }),
    (theme.Drawers = (function () {
        function e(e, t, i) {
            var n = { close: ".js-drawer-close", open: ".js-drawer-open-" + t, openClass: "js-drawer-open", dirOpenClass: "js-drawer-open-" + t };
            if (((this.nodes = { $parent: $("html").add("body"), $page: $("#PageContainer") }), (this.config = $.extend(n, i)), (this.position = t), (this.$drawer = $("#" + e)), !this.$drawer.length)) return !1;
            (this.drawerIsOpen = !1), this.init();
        }
        return (
            (e.prototype.init = function () {
                $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
            }),
            (e.prototype.open = function (e) {
                var t = !1;
                return (
                    e ? e.preventDefault() : (t = !0),
                    e && e.stopPropagation && (e.stopPropagation(), (this.$activeSource = $(e.currentTarget))),
                    this.drawerIsOpen && !t
                        ? this.close()
                        : (this.$drawer.prepareTransition(),
                          this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass),
                          (this.drawerIsOpen = !0),
                          slate.a11y.trapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                          this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (t || this.config.onDrawerOpen()),
                          this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
                          this.bindEvents(),
                          this)
                );
            }),
            (e.prototype.close = function () {
                this.drawerIsOpen &&
                    ($(document.activeElement).trigger("blur"),
                    this.$drawer.prepareTransition(),
                    this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass),
                    this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"),
                    (this.drawerIsOpen = !1),
                    slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                    this.unbindEvents(),
                    this.config.onDrawerClose && "function" == typeof this.config.onDrawerClose && this.config.onDrawerClose());
            }),
            (e.prototype.bindEvents = function () {
                this.nodes.$parent.on(
                    "keyup.drawer",
                    $.proxy(function (e) {
                        return 27 !== e.keyCode || (this.close(), !1);
                    }, this)
                ),
                    this.nodes.$page.on("touchmove.drawer", function () {
                        return !1;
                    }),
                    this.nodes.$page.on(
                        "click.drawer",
                        $.proxy(function () {
                            return this.close(), !1;
                        }, this)
                    );
            }),
            (e.prototype.unbindEvents = function () {
                this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer");
            }),
            e
        );
    })()),
    (window.theme = window.theme || {}),
    (theme.Header = (function () {
        var i = "body",
            e = "#AccessibleNav",
            t = "[data-has-dropdowns]",
            n = ".site-nav--active-dropdown",
            o = ".site-nav__link--main",
            s = ".site-nav__link--last",
            r = "site-nav--active-dropdown",
            a = "site-nav__dropdown--right",
            l = "site-nav__dropdown--left",
            c = {};
        function d(e) {
            e.find(o).attr("aria-expanded", "false"), e.removeClass(r), (c.$activeDropdown = $(n)), $(i).off("click.siteNav"), $(window).off("keyup.siteNav");
        }
        function u(e) {
            e.each(function () {
                var e = $(this).find(".site-nav__dropdown");
                e.length && (Math.ceil($(this).offset().left) > Math.floor(c.$siteHeader.outerWidth()) / 2 ? e.removeClass(l).addClass(a) : e.removeClass(a).addClass(l));
            });
        }
        function p() {
            $(".site-nav--has-centered-dropdown").each(function () {
                var e = $(this),
                    t = e.find(".site-nav__dropdown--centered"),
                    i = e.position().top + 41;
                t.css("top", i);
            });
        }
        return {
            init: function () {
                (c = { $nav: $(e), $topLevel: $(o), $parents: $(e).find(t), $subMenuLinks: $(".site-nav__child-link"), $activeDropdown: $(n), $siteHeader: $(".site-header") }),
                    u($(t)),
                    p(),
                    c.$parents.on("click.siteNav", function () {
                        var t,
                            e = $(this);
                        e.hasClass(r)
                            ? d(e)
                            : ((t = e).addClass(r),
                              c.$activeDropdown.length && d(c.$activeDropdown),
                              (c.$activeDropdown = t).find(o).attr("aria-expanded", "true"),
                              setTimeout(function () {
                                  $(window).on("keyup.siteNav", function (e) {
                                      27 === e.keyCode && d(t);
                                  }),
                                      $(i).on("click.siteNav", function () {
                                          d(t);
                                      });
                              }, 250));
                    }),
                    $(s).on("focusout.siteNav", function () {
                        setTimeout(function () {
                            !$(document.activeElement).hasClass("site-nav__child-link") && c.$activeDropdown.length && d(c.$activeDropdown);
                        });
                    }),
                    c.$topLevel.on("focus.siteNav", function () {
                        c.$activeDropdown.length && d(c.$activeDropdown);
                    }),
                    c.$subMenuLinks.on("click.siteNav", function (e) {
                        e.stopImmediatePropagation();
                    }),
                    $("[data-currency-selector]").on("change", function () {
                        $(this).parents("form").submit();
                    }),
                    $(window).resize(
                        $.debounce(50, function () {
                            u($(t)), p();
                        })
                    );
            },
            unload: function () {
                $(window).off(".siteNav"), c.$parents.off(".siteNav"), c.$subMenuLinks.off(".siteNav"), c.$topLevel.off(".siteNav"), $(s).off(".siteNav"), $(i).off(".siteNav");
            },
        };
    })()),
    (window.theme = window.theme || {}),
    (theme.MobileNav = (function () {
        var r,
            a,
            n,
            l = {
                mobileNavOpenIcon: "mobile-nav--open",
                mobileNavCloseIcon: "mobile-nav--close",
                navLinkWrapper: "mobile-nav__item",
                navLink: "mobile-nav__link",
                subNavLink: "mobile-nav__sublist-link",
                return: "mobile-nav__return-btn",
                subNavActive: "is-active",
                subNavClosing: "is-closing",
                navOpen: "js-menu--is-open",
                subNavShowing: "sub-nav--is-open",
                thirdNavShowing: "third-nav--is-open",
                subNavToggleBtn: "js-toggle-submenu",
            },
            c = {},
            d = 1;
        function e() {
            var e;
            c.$mobileNavToggle.hasClass(l.mobileNavCloseIcon)
                ? t()
                : ((e = c.$siteHeader.outerHeight()),
                  c.$mobileNavContainer.prepareTransition().addClass(l.navOpen),
                  c.$mobileNavContainer.css({ transform: "translateY(" + e + "px)" }),
                  c.$pageContainer.css({ transform: "translate3d(0, " + c.$mobileNavContainer[0].scrollHeight + "px, 0)" }),
                  slate.a11y.trapFocus({ $container: c.$sectionHeader, $elementToFocus: c.$mobileNavToggle, namespace: "navFocus" }),
                  c.$mobileNavToggle.addClass(l.mobileNavCloseIcon).removeClass(l.mobileNavOpenIcon).attr("aria-expanded", !0),
                  $(window).on("keyup.mobileNav", function (e) {
                      27 === e.which && t();
                  }));
        }
        function t() {
            c.$mobileNavContainer.prepareTransition().removeClass(l.navOpen),
                c.$mobileNavContainer.css({ transform: "translateY(-100%)" }),
                c.$pageContainer.removeAttr("style"),
                slate.a11y.trapFocus({ $container: $("html"), $elementToFocus: $("body") }),
                c.$mobileNavContainer.one("TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle", function () {
                    slate.a11y.removeTrapFocus({ $container: c.$mobileNav, namespace: "navFocus" });
                }),
                c.$mobileNavToggle.addClass(l.mobileNavOpenIcon).removeClass(l.mobileNavCloseIcon).attr("aria-expanded", !1).focus(),
                $(window).off("keyup.mobileNav"),
                scrollTo(0, 0);
        }
        function i(e) {
            var t, i;
            r ||
                ((i = (t = $(e.currentTarget)).hasClass(l.return)),
                (r = !0),
                i ? ($("." + l.subNavToggleBtn + '[data-level="' + (d - 1) + '"]').removeClass(l.subNavActive), n && n.length && n.removeClass(l.subNavActive)) : t.addClass(l.subNavActive),
                (function (e) {
                    var t = e ? $('.mobile-nav__dropdown[data-parent="' + e + '"]') : c.$mobileNav;
                    (d = t.data("level") ? t.data("level") : 1), a && a.length && a.prepareTransition().addClass(l.subNavClosing);
                    var i = (a = t).outerHeight(),
                        n = 2 < d ? l.thirdNavShowing : l.subNavShowing;
                    c.$mobileNavContainer.css("height", i).removeClass(l.thirdNavShowing).addClass(n), e || c.$mobileNavContainer.removeClass(l.thirdNavShowing).removeClass(l.subNavShowing);
                    var o = 1 === d ? c.$sectionHeader : t,
                        s = t.find("[data-menu-title=" + d + "]") || t;
                    c.$mobileNavContainer.one("TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle", function () {
                        slate.a11y.trapFocus({ $container: o, $elementToFocus: s, namespace: "subNavFocus" }), c.$mobileNavContainer.off(".subnavToggle"), (r = !1);
                    }),
                        c.$pageContainer.css({ transform: "translateY(" + i + "px)" }),
                        a.removeClass(l.subNavClosing);
                })((n = t).data("target")));
        }
        return {
            init: function () {
                (c = {
                    $pageContainer: $("#PageContainer"),
                    $siteHeader: $(".site-header"),
                    $mobileNavToggle: $(".js-mobile-nav-toggle"),
                    $mobileNavContainer: $(".mobile-nav-wrapper"),
                    $mobileNav: $("#MobileNav"),
                    $sectionHeader: $("#shopify-section-header"),
                    $subNavToggleBtn: $("." + l.subNavToggleBtn),
                }).$mobileNavToggle.on("click", e),
                    c.$subNavToggleBtn.on("click.subNav", i),
                    enquire.register("screen and (max-width: 749px)", {
                        unmatch: function () {
                            c.$mobileNavContainer.hasClass(l.navOpen) && t();
                        },
                    });
            },
            closeMobileNav: t,
        };
    })(jQuery)),
    (window.theme = window.theme || {}),
    (theme.Search = (function () {
        var i = ".site-header",
            e = ".site-header__search-toggle";
        function t() {
            n($(".search-bar__input")), $(".mobile-nav-wrapper").hasClass("js-menu--is-open") && theme.MobileNav.closeMobileNav();
        }
        function n(e) {
            e.focus(), e[0].setSelectionRange(0, e[0].value.length);
        }
        function o() {
            $(e).focus();
        }
        function s(e) {
            0 === this.$searchResultInput.val().trim().length
                ? (void 0 !== e && e.preventDefault(),
                  n(this.$searchResultInput),
                  function () {
                      this.$searchErrorMessage.removeClass("hide"), this.$searchResultInput.attr("aria-describedby", "error-search-form").attr("aria-invalid", !0);
                  }.call(this))
                : function () {
                      this.$searchErrorMessage.addClass("hide"), this.$searchResultInput.removeAttr("aria-describedby").removeAttr("aria-invalid");
                  }.call(this);
        }
        return {
            init: function () {
                $(i).length &&
                    ((this.$searchResultInput = $("#SearchInput")),
                    (this.$searchErrorMessage = $("[data-search-error-message]")),
                    $("#PageContainer").addClass("drawer-page-content"),
                    $(".js-drawer-open-top").attr("aria-controls", "SearchDrawer").attr("aria-expanded", "false").attr("aria-haspopup", "dialog"),
                    (theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", { onDrawerOpen: t, onDrawerClose: o })),
                    null !== slate.utils.getParameterByName("q") && $("body").hasClass("template-search") && s.call(this),
                    $("#SearchResultSubmit").on("click", s.bind(this)),
                    $(".search-header__input")
                        .add(".search-header__submit")
                        .on("focus blur", function () {
                            $(".search-header").toggleClass("search--focus");
                        }),
                    $(e).on("click", function () {
                        var e = $(i).outerHeight(),
                            t = $(i).offset().top - e;
                        $(".search-bar").css({ height: e + "px", top: t + "px" });
                    }));
            },
        };
    })()),
    (function () {
        var e = $(".return-link");
        function i(e) {
            var t = document.createElement("a");
            return (t.ref = e), t.hostname;
        }
        document.referrer &&
            e.length &&
            window.history.length &&
            e.one("click", function (e) {
                e.preventDefault();
                var t = i(document.referrer);
                return i(window.location.href) === t && history.back(), !1;
            });
    })(),
    (window.theme = window.theme || {}),
    (theme.FormStatus = {
        init: function () {
            (this.$statusMessage = $("[data-form-status]")),
                this.$statusMessage &&
                    (this.$statusMessage.attr("tabindex", -1).focus(),
                    this.$statusMessage.on(
                        "blur",
                        function () {
                            this.$statusMessage.removeAttr("tabindex");
                        }.bind(this)
                    ));
        },
    }),
    (window.theme = window.theme || {}),
    (theme.HeaderSection = (function () {
        function e() {
            theme.Header.init(), theme.MobileNav.init(), theme.Search.init();
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                onUnload: function () {
                    theme.Header.unload();
                },
            })),
            e
        );
    })()),
    $(document).ready(function () {
        var e = new theme.Sections();
        e.register("header-section", theme.HeaderSection);
    }),
    $(theme.init),
    $(document).ready(function () {
        $("ul.tabs").each(function () {
            var e = $(this).find("a"),
                t = e.first().addClass("active"),
                i = $(t.attr("href"));
            e.not(":first").each(function () {
                $($(this).attr("href")).hide();
            }),
                $(this)
                    .find("a")
                    .click(function (e) {
                        return t.removeClass("active"), i.hide(), (t = $(this)), (i = $($(this).attr("href"))), t.addClass("active"), i.show(), !1;
                    });
        });
    });
var Shopify = Shopify || {};
(Shopify.money_format = "${{amount}}"),
    (Shopify.formatMoney = function (e, t) {
        "string" == typeof e && (e = e.replace(".", ""));
        var i = "",
            n = /\{\{\s*(\w+)\s*\}\}/,
            o = t || this.money_format;
        function s(e, t) {
            return void 0 === e ? t : e;
        }
        function r(e, t, i, n) {
            if (((t = s(t, 2)), (i = s(i, ",")), (n = s(n, ".")), isNaN(e) || null == e)) return 0;
            var o = (e = (e / 100).toFixed(t)).split(".");
            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (o[1] ? n + o[1] : "");
        }
        switch (o.match(n)[1]) {
            case "amount":
                i = r(e, 2);
                break;
            case "amount_no_decimals":
                i = r(e, 0);
                break;
            case "amount_with_comma_separator":
                i = r(e, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = r(e, 0, ".", ",");
        }
        return o.replace(n, i);
    }),
    $(function () {}),
    (function (e) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? (module.exports = e(require("jquery"))) : e(jQuery);
    })(function (c) {
        "use strict";
        var s = window.Slick,
            o = 0;
        ((s = function (e, t) {
            var i,
                n = this;
            (n.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: c(e),
                appendDots: c(e),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function (e, t) {
                    return c('<button type="button" />').text(t + 1);
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: 0.35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3,
            }),
                (n.initials = {
                    animating: !1,
                    dragging: !1,
                    autoPlayTimer: null,
                    currentDirection: 0,
                    currentLeft: null,
                    currentSlide: 0,
                    direction: 1,
                    $dots: null,
                    listWidth: null,
                    listHeight: null,
                    loadIndex: 0,
                    $nextArrow: null,
                    $prevArrow: null,
                    scrolling: !1,
                    slideCount: null,
                    slideWidth: null,
                    $slideTrack: null,
                    $slides: null,
                    sliding: !1,
                    slideOffset: 0,
                    swipeLeft: null,
                    swiping: !1,
                    $list: null,
                    touchObject: {},
                    transformsEnabled: !1,
                    unslicked: !1,
                }),
                c.extend(n, n.initials),
                (n.activeBreakpoint = null),
                (n.animType = null),
                (n.animProp = null),
                (n.breakpoints = []),
                (n.breakpointSettings = []),
                (n.cssTransitions = !1),
                (n.focussed = !1),
                (n.interrupted = !1),
                (n.hidden = "hidden"),
                (n.paused = !0),
                (n.positionProp = null),
                (n.respondTo = null),
                (n.rowCount = 1),
                (n.shouldClick = !0),
                (n.$slider = c(e)),
                (n.$slidesCache = null),
                (n.transformType = null),
                (n.transitionType = null),
                (n.visibilityChange = "visibilitychange"),
                (n.windowWidth = 0),
                (n.windowTimer = null),
                (i = c(e).data("slick") || {}),
                (n.options = c.extend({}, n.defaults, t, i)),
                (n.currentSlide = n.options.initialSlide),
                (n.originalSettings = n.options),
                void 0 !== document.mozHidden ? ((n.hidden = "mozHidden"), (n.visibilityChange = "mozvisibilitychange")) : void 0 !== document.webkitHidden && ((n.hidden = "webkitHidden"), (n.visibilityChange = "webkitvisibilitychange")),
                (n.autoPlay = c.proxy(n.autoPlay, n)),
                (n.autoPlayClear = c.proxy(n.autoPlayClear, n)),
                (n.autoPlayIterator = c.proxy(n.autoPlayIterator, n)),
                (n.changeSlide = c.proxy(n.changeSlide, n)),
                (n.clickHandler = c.proxy(n.clickHandler, n)),
                (n.selectHandler = c.proxy(n.selectHandler, n)),
                (n.setPosition = c.proxy(n.setPosition, n)),
                (n.swipeHandler = c.proxy(n.swipeHandler, n)),
                (n.dragHandler = c.proxy(n.dragHandler, n)),
                (n.keyHandler = c.proxy(n.keyHandler, n)),
                (n.instanceUid = o++),
                (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                n.registerBreakpoints(),
                n.init(!0);
        }).prototype.activateADA = function () {
            this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
        }),
            (s.prototype.addSlide = s.prototype.slickAdd = function (e, t, i) {
                var n = this;
                if ("boolean" == typeof t) (i = t), (t = null);
                else if (t < 0 || t >= n.slideCount) return !1;
                n.unload(),
                    "number" == typeof t
                        ? 0 === t && 0 === n.$slides.length
                            ? c(e).appendTo(n.$slideTrack)
                            : i
                            ? c(e).insertBefore(n.$slides.eq(t))
                            : c(e).insertAfter(n.$slides.eq(t))
                        : !0 === i
                        ? c(e).prependTo(n.$slideTrack)
                        : c(e).appendTo(n.$slideTrack),
                    (n.$slides = n.$slideTrack.children(this.options.slide)),
                    n.$slideTrack.children(this.options.slide).detach(),
                    n.$slideTrack.append(n.$slides),
                    n.$slides.each(function (e, t) {
                        c(t).attr("data-slick-index", e);
                    }),
                    (n.$slidesCache = n.$slides),
                    n.reinit();
            }),
            (s.prototype.animateHeight = function () {
                var e;
                1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical && ((e = this.$slides.eq(this.currentSlide).outerHeight(!0)), this.$list.animate({ height: e }, this.options.speed));
            }),
            (s.prototype.animateSlide = function (e, t) {
                var i = {},
                    n = this;
                n.animateHeight(),
                    !0 === n.options.rtl && !1 === n.options.vertical && (e = -e),
                    !1 === n.transformsEnabled
                        ? !1 === n.options.vertical
                            ? n.$slideTrack.animate({ left: e }, n.options.speed, n.options.easing, t)
                            : n.$slideTrack.animate({ top: e }, n.options.speed, n.options.easing, t)
                        : !1 === n.cssTransitions
                        ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
                          c({ animStart: n.currentLeft }).animate(
                              { animStart: e },
                              {
                                  duration: n.options.speed,
                                  easing: n.options.easing,
                                  step: function (e) {
                                      (e = Math.ceil(e)), !1 === n.options.vertical ? (i[n.animType] = "translate(" + e + "px, 0px)") : (i[n.animType] = "translate(0px," + e + "px)"), n.$slideTrack.css(i);
                                  },
                                  complete: function () {
                                      t && t.call();
                                  },
                              }
                          ))
                        : (n.applyTransition(),
                          (e = Math.ceil(e)),
                          !1 === n.options.vertical ? (i[n.animType] = "translate3d(" + e + "px, 0px, 0px)") : (i[n.animType] = "translate3d(0px," + e + "px, 0px)"),
                          n.$slideTrack.css(i),
                          t &&
                              setTimeout(function () {
                                  n.disableTransition(), t.call();
                              }, n.options.speed));
            }),
            (s.prototype.getNavTarget = function () {
                var e = this.options.asNavFor;
                return e && null !== e && (e = c(e).not(this.$slider)), e;
            }),
            (s.prototype.asNavFor = function (t) {
                var e = this.getNavTarget();
                null !== e &&
                    "object" == typeof e &&
                    e.each(function () {
                        var e = c(this).slick("getSlick");
                        e.unslicked || e.slideHandler(t, !0);
                    });
            }),
            (s.prototype.applyTransition = function (e) {
                var t = this,
                    i = {};
                !1 === t.options.fade ? (i[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase) : (i[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase),
                    !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i);
            }),
            (s.prototype.autoPlay = function () {
                this.autoPlayClear(), this.slideCount > this.options.slidesToShow && (this.autoPlayTimer = setInterval(this.autoPlayIterator, this.options.autoplaySpeed));
            }),
            (s.prototype.autoPlayClear = function () {
                this.autoPlayTimer && clearInterval(this.autoPlayTimer);
            }),
            (s.prototype.autoPlayIterator = function () {
                var e = this,
                    t = e.currentSlide + e.options.slidesToScroll;
                e.paused ||
                    e.interrupted ||
                    e.focussed ||
                    (!1 === e.options.infinite &&
                        (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? (e.direction = 0) : 0 === e.direction && ((t = e.currentSlide - e.options.slidesToScroll), e.currentSlide - 1 == 0 && (e.direction = 1))),
                    e.slideHandler(t));
            }),
            (s.prototype.buildArrows = function () {
                var e = this;
                !0 === e.options.arrows &&
                    ((e.$prevArrow = c(e.options.prevArrow).addClass("slick-arrow")),
                    (e.$nextArrow = c(e.options.nextArrow).addClass("slick-arrow")),
                    e.slideCount > e.options.slidesToShow
                        ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
                          e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
                          !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                        : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
            }),
            (s.prototype.buildDots = function () {
                var e, t;
                if (!0 === this.options.dots) {
                    for (this.$slider.addClass("slick-dotted"), t = c("<ul />").addClass(this.options.dotsClass), e = 0; e <= this.getDotCount(); e += 1) t.append(c("<li />").append(this.options.customPaging.call(this, this, e)));
                    (this.$dots = t.appendTo(this.options.appendDots)), this.$dots.find("li").first().addClass("slick-active");
                }
            }),
            (s.prototype.buildOut = function () {
                var e = this;
                (e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                    (e.slideCount = e.$slides.length),
                    e.$slides.each(function (e, t) {
                        c(t)
                            .attr("data-slick-index", e)
                            .data("originalStyling", c(t).attr("style") || "");
                    }),
                    e.$slider.addClass("slick-slider"),
                    (e.$slideTrack = 0 === e.slideCount ? c('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
                    (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
                    e.$slideTrack.css("opacity", 0),
                    (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) || (e.options.slidesToScroll = 1),
                    c("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
                    e.setupInfinite(),
                    e.buildArrows(),
                    e.buildDots(),
                    e.updateDots(),
                    e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
                    !0 === e.options.draggable && e.$list.addClass("draggable");
            }),
            (s.prototype.buildRows = function () {
                var e,
                    t,
                    i,
                    n = this,
                    o = document.createDocumentFragment(),
                    s = n.$slider.children();
                if (1 < n.options.rows) {
                    for (i = n.options.slidesPerRow * n.options.rows, t = Math.ceil(s.length / i), e = 0; e < t; e++) {
                        for (var r = document.createElement("div"), a = 0; a < n.options.rows; a++) {
                            for (var l = document.createElement("div"), c = 0; c < n.options.slidesPerRow; c++) {
                                var d = e * i + (a * n.options.slidesPerRow + c);
                                s.get(d) && l.appendChild(s.get(d));
                            }
                            r.appendChild(l);
                        }
                        o.appendChild(r);
                    }
                    n.$slider.empty().append(o),
                        n.$slider
                            .children()
                            .children()
                            .children()
                            .css({ width: 100 / n.options.slidesPerRow + "%", display: "inline-block" });
                }
            }),
            (s.prototype.checkResponsive = function (e, t) {
                var i,
                    n,
                    o,
                    s = this,
                    r = !1,
                    a = s.$slider.width(),
                    l = window.innerWidth || c(window).width();
                if (("window" === s.respondTo ? (o = l) : "slider" === s.respondTo ? (o = a) : "min" === s.respondTo && (o = Math.min(l, a)), s.options.responsive && s.options.responsive.length && null !== s.options.responsive)) {
                    for (i in ((n = null), s.breakpoints)) s.breakpoints.hasOwnProperty(i) && (!1 === s.originalSettings.mobileFirst ? o < s.breakpoints[i] && (n = s.breakpoints[i]) : o > s.breakpoints[i] && (n = s.breakpoints[i]));
                    null !== n
                        ? (null !== s.activeBreakpoint && n === s.activeBreakpoint && !t) ||
                          ((s.activeBreakpoint = n),
                          "unslick" === s.breakpointSettings[n] ? s.unslick(n) : ((s.options = c.extend({}, s.originalSettings, s.breakpointSettings[n])), !0 === e && (s.currentSlide = s.options.initialSlide), s.refresh(e)),
                          (r = n))
                        : null !== s.activeBreakpoint && ((s.activeBreakpoint = null), (s.options = s.originalSettings), !0 === e && (s.currentSlide = s.options.initialSlide), s.refresh(e), (r = n)),
                        e || !1 === r || s.$slider.trigger("breakpoint", [s, r]);
                }
            }),
            (s.prototype.changeSlide = function (e, t) {
                var i,
                    n,
                    o = this,
                    s = c(e.currentTarget);
                switch ((s.is("a") && e.preventDefault(), s.is("li") || (s = s.closest("li")), (i = o.slideCount % o.options.slidesToScroll != 0 ? 0 : (o.slideCount - o.currentSlide) % o.options.slidesToScroll), e.data.message)) {
                    case "previous":
                        (n = 0 == i ? o.options.slidesToScroll : o.options.slidesToShow - i), o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - n, !1, t);
                        break;
                    case "next":
                        (n = 0 == i ? o.options.slidesToScroll : i), o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + n, !1, t);
                        break;
                    case "index":
                        var r = 0 === e.data.index ? 0 : e.data.index || s.index() * o.options.slidesToScroll;
                        o.slideHandler(o.checkNavigable(r), !1, t), s.children().trigger("focus");
                        break;
                    default:
                        return;
                }
            }),
            (s.prototype.checkNavigable = function (e) {
                var t,
                    i = 0;
                if (e > (t = this.getNavigableIndexes())[t.length - 1]) e = t[t.length - 1];
                else
                    for (var n in t) {
                        if (e < t[n]) {
                            e = i;
                            break;
                        }
                        i = t[n];
                    }
                return e;
            }),
            (s.prototype.cleanUpEvents = function () {
                var e = this;
                e.options.dots &&
                    null !== e.$dots &&
                    (c("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", c.proxy(e.interrupt, e, !0)).off("mouseleave.slick", c.proxy(e.interrupt, e, !1)),
                    !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)),
                    e.$slider.off("focus.slick blur.slick"),
                    !0 === e.options.arrows &&
                        e.slideCount > e.options.slidesToShow &&
                        (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
                        e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
                        !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
                    e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
                    e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
                    e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
                    e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
                    e.$list.off("click.slick", e.clickHandler),
                    c(document).off(e.visibilityChange, e.visibility),
                    e.cleanUpSlideEvents(),
                    !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler),
                    !0 === e.options.focusOnSelect && c(e.$slideTrack).children().off("click.slick", e.selectHandler),
                    c(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
                    c(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
                    c("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
                    c(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
            }),
            (s.prototype.cleanUpSlideEvents = function () {
                this.$list.off("mouseenter.slick", c.proxy(this.interrupt, this, !0)), this.$list.off("mouseleave.slick", c.proxy(this.interrupt, this, !1));
            }),
            (s.prototype.cleanUpRows = function () {
                var e;
                1 < this.options.rows && ((e = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(e));
            }),
            (s.prototype.clickHandler = function (e) {
                !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault());
            }),
            (s.prototype.destroy = function (e) {
                var t = this;
                t.autoPlayClear(),
                    (t.touchObject = {}),
                    t.cleanUpEvents(),
                    c(".slick-cloned", t.$slider).detach(),
                    t.$dots && t.$dots.remove(),
                    t.$prevArrow &&
                        t.$prevArrow.length &&
                        (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
                    t.$nextArrow &&
                        t.$nextArrow.length &&
                        (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
                    t.$slides &&
                        (t.$slides
                            .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                            .removeAttr("aria-hidden")
                            .removeAttr("data-slick-index")
                            .each(function () {
                                c(this).attr("style", c(this).data("originalStyling"));
                            }),
                        t.$slideTrack.children(this.options.slide).detach(),
                        t.$slideTrack.detach(),
                        t.$list.detach(),
                        t.$slider.append(t.$slides)),
                    t.cleanUpRows(),
                    t.$slider.removeClass("slick-slider"),
                    t.$slider.removeClass("slick-initialized"),
                    t.$slider.removeClass("slick-dotted"),
                    (t.unslicked = !0),
                    e || t.$slider.trigger("destroy", [t]);
            }),
            (s.prototype.disableTransition = function (e) {
                var t = {};
                (t[this.transitionType] = ""), !1 === this.options.fade ? this.$slideTrack.css(t) : this.$slides.eq(e).css(t);
            }),
            (s.prototype.fadeSlide = function (e, t) {
                var i = this;
                !1 === i.cssTransitions
                    ? (i.$slides.eq(e).css({ zIndex: i.options.zIndex }), i.$slides.eq(e).animate({ opacity: 1 }, i.options.speed, i.options.easing, t))
                    : (i.applyTransition(e),
                      i.$slides.eq(e).css({ opacity: 1, zIndex: i.options.zIndex }),
                      t &&
                          setTimeout(function () {
                              i.disableTransition(e), t.call();
                          }, i.options.speed));
            }),
            (s.prototype.fadeSlideOut = function (e) {
                !1 === this.cssTransitions
                    ? this.$slides.eq(e).animate({ opacity: 0, zIndex: this.options.zIndex - 2 }, this.options.speed, this.options.easing)
                    : (this.applyTransition(e), this.$slides.eq(e).css({ opacity: 0, zIndex: this.options.zIndex - 2 }));
            }),
            (s.prototype.filterSlides = s.prototype.slickFilter = function (e) {
                null !== e && ((this.$slidesCache = this.$slides), this.unload(), this.$slideTrack.children(this.options.slide).detach(), this.$slidesCache.filter(e).appendTo(this.$slideTrack), this.reinit());
            }),
            (s.prototype.focusHandler = function () {
                var i = this;
                i.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (e) {
                    e.stopImmediatePropagation();
                    var t = c(this);
                    setTimeout(function () {
                        i.options.pauseOnFocus && ((i.focussed = t.is(":focus")), i.autoPlay());
                    }, 0);
                });
            }),
            (s.prototype.getCurrent = s.prototype.slickCurrentSlide = function () {
                return this.currentSlide;
            }),
            (s.prototype.getDotCount = function () {
                var e = this,
                    t = 0,
                    i = 0,
                    n = 0;
                if (!0 === e.options.infinite)
                    if (e.slideCount <= e.options.slidesToShow) ++n;
                    else for (; t < e.slideCount; ) ++n, (t = i + e.options.slidesToScroll), (i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                else if (!0 === e.options.centerMode) n = e.slideCount;
                else if (e.options.asNavFor) for (; t < e.slideCount; ) ++n, (t = i + e.options.slidesToScroll), (i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                else n = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
                return n - 1;
            }),
            (s.prototype.getLeft = function (e) {
                var t,
                    i,
                    n,
                    o,
                    s = this,
                    r = 0;
                return (
                    (s.slideOffset = 0),
                    (i = s.$slides.first().outerHeight(!0)),
                    !0 === s.options.infinite
                        ? (s.slideCount > s.options.slidesToShow &&
                              ((s.slideOffset = s.slideWidth * s.options.slidesToShow * -1),
                              (o = -1),
                              !0 === s.options.vertical && !0 === s.options.centerMode && (2 === s.options.slidesToShow ? (o = -1.5) : 1 === s.options.slidesToShow && (o = -2)),
                              (r = i * s.options.slidesToShow * o)),
                          s.slideCount % s.options.slidesToScroll != 0 &&
                              e + s.options.slidesToScroll > s.slideCount &&
                              s.slideCount > s.options.slidesToShow &&
                              (r =
                                  e > s.slideCount
                                      ? ((s.slideOffset = (s.options.slidesToShow - (e - s.slideCount)) * s.slideWidth * -1), (s.options.slidesToShow - (e - s.slideCount)) * i * -1)
                                      : ((s.slideOffset = (s.slideCount % s.options.slidesToScroll) * s.slideWidth * -1), (s.slideCount % s.options.slidesToScroll) * i * -1)))
                        : e + s.options.slidesToShow > s.slideCount && ((s.slideOffset = (e + s.options.slidesToShow - s.slideCount) * s.slideWidth), (r = (e + s.options.slidesToShow - s.slideCount) * i)),
                    s.slideCount <= s.options.slidesToShow && (r = s.slideOffset = 0),
                    !0 === s.options.centerMode && s.slideCount <= s.options.slidesToShow
                        ? (s.slideOffset = (s.slideWidth * Math.floor(s.options.slidesToShow)) / 2 - (s.slideWidth * s.slideCount) / 2)
                        : !0 === s.options.centerMode && !0 === s.options.infinite
                        ? (s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2) - s.slideWidth)
                        : !0 === s.options.centerMode && ((s.slideOffset = 0), (s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2))),
                    (t = !1 === s.options.vertical ? e * s.slideWidth * -1 + s.slideOffset : e * i * -1 + r),
                    !0 === s.options.variableWidth &&
                        ((n = s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite ? s.$slideTrack.children(".slick-slide").eq(e) : s.$slideTrack.children(".slick-slide").eq(e + s.options.slidesToShow)),
                        (t = !0 === s.options.rtl ? (n[0] ? -1 * (s.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0) : n[0] ? -1 * n[0].offsetLeft : 0),
                        !0 === s.options.centerMode &&
                            ((n = s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite ? s.$slideTrack.children(".slick-slide").eq(e) : s.$slideTrack.children(".slick-slide").eq(e + s.options.slidesToShow + 1)),
                            (t = !0 === s.options.rtl ? (n[0] ? -1 * (s.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0) : n[0] ? -1 * n[0].offsetLeft : 0),
                            (t += (s.$list.width() - n.outerWidth()) / 2))),
                    t
                );
            }),
            (s.prototype.getOption = s.prototype.slickGetOption = function (e) {
                return this.options[e];
            }),
            (s.prototype.getNavigableIndexes = function () {
                for (var e = this, t = 0, i = 0, n = [], o = !1 === e.options.infinite ? e.slideCount : ((t = -1 * e.options.slidesToScroll), (i = -1 * e.options.slidesToScroll), 2 * e.slideCount); t < o; )
                    n.push(t), (t = i + e.options.slidesToScroll), (i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                return n;
            }),
            (s.prototype.getSlick = function () {
                return this;
            }),
            (s.prototype.getSlideCount = function () {
                var i,
                    n = this,
                    o = !0 === n.options.centerMode ? n.slideWidth * Math.floor(n.options.slidesToShow / 2) : 0;
                return !0 === n.options.swipeToSlide
                    ? (n.$slideTrack.find(".slick-slide").each(function (e, t) {
                          if (t.offsetLeft - o + c(t).outerWidth() / 2 > -1 * n.swipeLeft) return (i = t), !1;
                      }),
                      Math.abs(c(i).attr("data-slick-index") - n.currentSlide) || 1)
                    : n.options.slidesToScroll;
            }),
            (s.prototype.goTo = s.prototype.slickGoTo = function (e, t) {
                this.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
            }),
            (s.prototype.init = function (e) {
                var t = this;
                c(t.$slider).hasClass("slick-initialized") ||
                    (c(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()),
                    e && t.$slider.trigger("init", [t]),
                    !0 === t.options.accessibility && t.initADA(),
                    t.options.autoplay && ((t.paused = !1), t.autoPlay());
            }),
            (s.prototype.initADA = function () {
                var i = this,
                    n = Math.ceil(i.slideCount / i.options.slidesToShow),
                    o = i.getNavigableIndexes().filter(function (e) {
                        return 0 <= e && e < i.slideCount;
                    });
                i.$slides.add(i.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }),
                    null !== i.$dots &&
                        (i.$slides.not(i.$slideTrack.find(".slick-cloned")).each(function (e) {
                            var t = o.indexOf(e);
                            c(this).attr({ role: "tabpanel", id: "slick-slide" + i.instanceUid + e, tabindex: -1 }), -1 !== t && c(this).attr({ "aria-describedby": "slick-slide-control" + i.instanceUid + t });
                        }),
                        i.$dots
                            .attr("role", "tablist")
                            .find("li")
                            .each(function (e) {
                                var t = o[e];
                                c(this).attr({ role: "presentation" }),
                                    c(this)
                                        .find("button")
                                        .first()
                                        .attr({ role: "tab", id: "slick-slide-control" + i.instanceUid + e, "aria-controls": "slick-slide" + i.instanceUid + t, "aria-label": e + 1 + " of " + n, "aria-selected": null, tabindex: "-1" });
                            })
                            .eq(i.currentSlide)
                            .find("button")
                            .attr({ "aria-selected": "true", tabindex: "0" })
                            .end());
                for (var e = i.currentSlide, t = e + i.options.slidesToShow; e < t; e++) i.$slides.eq(e).attr("tabindex", 0);
                i.activateADA();
            }),
            (s.prototype.initArrowEvents = function () {
                var e = this;
                !0 === e.options.arrows &&
                    e.slideCount > e.options.slidesToShow &&
                    (e.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, e.changeSlide),
                    e.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, e.changeSlide),
                    !0 === e.options.accessibility && (e.$prevArrow.on("keydown.slick", e.keyHandler), e.$nextArrow.on("keydown.slick", e.keyHandler)));
            }),
            (s.prototype.initDotEvents = function () {
                var e = this;
                !0 === e.options.dots && (c("li", e.$dots).on("click.slick", { message: "index" }, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)),
                    !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && c("li", e.$dots).on("mouseenter.slick", c.proxy(e.interrupt, e, !0)).on("mouseleave.slick", c.proxy(e.interrupt, e, !1));
            }),
            (s.prototype.initSlideEvents = function () {
                this.options.pauseOnHover && (this.$list.on("mouseenter.slick", c.proxy(this.interrupt, this, !0)), this.$list.on("mouseleave.slick", c.proxy(this.interrupt, this, !1)));
            }),
            (s.prototype.initializeEvents = function () {
                var e = this;
                e.initArrowEvents(),
                    e.initDotEvents(),
                    e.initSlideEvents(),
                    e.$list.on("touchstart.slick mousedown.slick", { action: "start" }, e.swipeHandler),
                    e.$list.on("touchmove.slick mousemove.slick", { action: "move" }, e.swipeHandler),
                    e.$list.on("touchend.slick mouseup.slick", { action: "end" }, e.swipeHandler),
                    e.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, e.swipeHandler),
                    e.$list.on("click.slick", e.clickHandler),
                    c(document).on(e.visibilityChange, c.proxy(e.visibility, e)),
                    !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler),
                    !0 === e.options.focusOnSelect && c(e.$slideTrack).children().on("click.slick", e.selectHandler),
                    c(window).on("orientationchange.slick.slick-" + e.instanceUid, c.proxy(e.orientationChange, e)),
                    c(window).on("resize.slick.slick-" + e.instanceUid, c.proxy(e.resize, e)),
                    c("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
                    c(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
                    c(e.setPosition);
            }),
            (s.prototype.initUI = function () {
                !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.show(), this.$nextArrow.show()), !0 === this.options.dots && this.slideCount > this.options.slidesToShow && this.$dots.show();
            }),
            (s.prototype.keyHandler = function (e) {
                e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                    (37 === e.keyCode && !0 === this.options.accessibility
                        ? this.changeSlide({ data: { message: !0 === this.options.rtl ? "next" : "previous" } })
                        : 39 === e.keyCode && !0 === this.options.accessibility && this.changeSlide({ data: { message: !0 === this.options.rtl ? "previous" : "next" } }));
            }),
            (s.prototype.lazyLoad = function () {
                function e(e) {
                    c("img[data-lazy]", e).each(function () {
                        var e = c(this),
                            t = c(this).attr("data-lazy"),
                            i = c(this).attr("data-srcset"),
                            n = c(this).attr("data-sizes") || s.$slider.attr("data-sizes"),
                            o = document.createElement("img");
                        (o.onload = function () {
                            e.animate({ opacity: 0 }, 100, function () {
                                i && (e.attr("srcset", i), n && e.attr("sizes", n)),
                                    e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                                        e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                                    }),
                                    s.$slider.trigger("lazyLoaded", [s, e, t]);
                            });
                        }),
                            (o.onerror = function () {
                                e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, e, t]);
                            }),
                            (o.src = t);
                    });
                }
                var t,
                    i,
                    n,
                    s = this;
                if (
                    (!0 === s.options.centerMode
                        ? (n =
                              !0 === s.options.infinite
                                  ? (i = s.currentSlide + (s.options.slidesToShow / 2 + 1)) + s.options.slidesToShow + 2
                                  : ((i = Math.max(0, s.currentSlide - (s.options.slidesToShow / 2 + 1))), s.options.slidesToShow / 2 + 1 + 2 + s.currentSlide))
                        : ((i = s.options.infinite ? s.options.slidesToShow + s.currentSlide : s.currentSlide), (n = Math.ceil(i + s.options.slidesToShow)), !0 === s.options.fade && (0 < i && i--, n <= s.slideCount && n++)),
                    (t = s.$slider.find(".slick-slide").slice(i, n)),
                    "anticipated" === s.options.lazyLoad)
                )
                    for (var o = i - 1, r = n, a = s.$slider.find(".slick-slide"), l = 0; l < s.options.slidesToScroll; l++) o < 0 && (o = s.slideCount - 1), (t = (t = t.add(a.eq(o))).add(a.eq(r))), o--, r++;
                e(t),
                    s.slideCount <= s.options.slidesToShow
                        ? e(s.$slider.find(".slick-slide"))
                        : s.currentSlide >= s.slideCount - s.options.slidesToShow
                        ? e(s.$slider.find(".slick-cloned").slice(0, s.options.slidesToShow))
                        : 0 === s.currentSlide && e(s.$slider.find(".slick-cloned").slice(-1 * s.options.slidesToShow));
            }),
            (s.prototype.loadSlider = function () {
                this.setPosition(), this.$slideTrack.css({ opacity: 1 }), this.$slider.removeClass("slick-loading"), this.initUI(), "progressive" === this.options.lazyLoad && this.progressiveLazyLoad();
            }),
            (s.prototype.next = s.prototype.slickNext = function () {
                this.changeSlide({ data: { message: "next" } });
            }),
            (s.prototype.orientationChange = function () {
                this.checkResponsive(), this.setPosition();
            }),
            (s.prototype.pause = s.prototype.slickPause = function () {
                this.autoPlayClear(), (this.paused = !0);
            }),
            (s.prototype.play = s.prototype.slickPlay = function () {
                this.autoPlay(), (this.options.autoplay = !0), (this.paused = !1), (this.focussed = !1), (this.interrupted = !1);
            }),
            (s.prototype.postSlide = function (e) {
                var t = this;
                t.unslicked ||
                    (t.$slider.trigger("afterChange", [t, e]),
                    (t.animating = !1),
                    t.slideCount > t.options.slidesToShow && t.setPosition(),
                    (t.swipeLeft = null),
                    t.options.autoplay && t.autoPlay(),
                    !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && c(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
            }),
            (s.prototype.prev = s.prototype.slickPrev = function () {
                this.changeSlide({ data: { message: "previous" } });
            }),
            (s.prototype.preventDefault = function (e) {
                e.preventDefault();
            }),
            (s.prototype.progressiveLazyLoad = function (e) {
                e = e || 1;
                var t,
                    i,
                    n,
                    o,
                    s,
                    r = this,
                    a = c("img[data-lazy]", r.$slider);
                a.length
                    ? ((t = a.first()),
                      (i = t.attr("data-lazy")),
                      (n = t.attr("data-srcset")),
                      (o = t.attr("data-sizes") || r.$slider.attr("data-sizes")),
                      ((s = document.createElement("img")).onload = function () {
                          n && (t.attr("srcset", n), o && t.attr("sizes", o)),
                              t.attr("src", i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),
                              !0 === r.options.adaptiveHeight && r.setPosition(),
                              r.$slider.trigger("lazyLoaded", [r, t, i]),
                              r.progressiveLazyLoad();
                      }),
                      (s.onerror = function () {
                          e < 3
                              ? setTimeout(function () {
                                    r.progressiveLazyLoad(e + 1);
                                }, 500)
                              : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, t, i]), r.progressiveLazyLoad());
                      }),
                      (s.src = i))
                    : r.$slider.trigger("allImagesLoaded", [r]);
            }),
            (s.prototype.refresh = function (e) {
                var t,
                    i = this,
                    n = i.slideCount - i.options.slidesToShow;
                !i.options.infinite && i.currentSlide > n && (i.currentSlide = n),
                    i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0),
                    (t = i.currentSlide),
                    i.destroy(!0),
                    c.extend(i, i.initials, { currentSlide: t }),
                    i.init(),
                    e || i.changeSlide({ data: { message: "index", index: t } }, !1);
            }),
            (s.prototype.registerBreakpoints = function () {
                var e,
                    t,
                    i,
                    n = this,
                    o = n.options.responsive || null;
                if ("array" === c.type(o) && o.length) {
                    for (e in ((n.respondTo = n.options.respondTo || "window"), o))
                        if (((i = n.breakpoints.length - 1), o.hasOwnProperty(e))) {
                            for (t = o[e].breakpoint; 0 <= i; ) n.breakpoints[i] && n.breakpoints[i] === t && n.breakpoints.splice(i, 1), i--;
                            n.breakpoints.push(t), (n.breakpointSettings[t] = o[e].settings);
                        }
                    n.breakpoints.sort(function (e, t) {
                        return n.options.mobileFirst ? e - t : t - e;
                    });
                }
            }),
            (s.prototype.reinit = function () {
                var e = this;
                (e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide")),
                    (e.slideCount = e.$slides.length),
                    e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
                    e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
                    e.registerBreakpoints(),
                    e.setProps(),
                    e.setupInfinite(),
                    e.buildArrows(),
                    e.updateArrows(),
                    e.initArrowEvents(),
                    e.buildDots(),
                    e.updateDots(),
                    e.initDotEvents(),
                    e.cleanUpSlideEvents(),
                    e.initSlideEvents(),
                    e.checkResponsive(!1, !0),
                    !0 === e.options.focusOnSelect && c(e.$slideTrack).children().on("click.slick", e.selectHandler),
                    e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
                    e.setPosition(),
                    e.focusHandler(),
                    (e.paused = !e.options.autoplay),
                    e.autoPlay(),
                    e.$slider.trigger("reInit", [e]);
            }),
            (s.prototype.resize = function () {
                var e = this;
                c(window).width() !== e.windowWidth &&
                    (clearTimeout(e.windowDelay),
                    (e.windowDelay = window.setTimeout(function () {
                        (e.windowWidth = c(window).width()), e.checkResponsive(), e.unslicked || e.setPosition();
                    }, 50)));
            }),
            (s.prototype.removeSlide = s.prototype.slickRemove = function (e, t, i) {
                var n = this;
                if (((e = "boolean" == typeof e ? (!0 === (t = e) ? 0 : n.slideCount - 1) : !0 === t ? --e : e), n.slideCount < 1 || e < 0 || e > n.slideCount - 1)) return !1;
                n.unload(),
                    !0 === i ? n.$slideTrack.children().remove() : n.$slideTrack.children(this.options.slide).eq(e).remove(),
                    (n.$slides = n.$slideTrack.children(this.options.slide)),
                    n.$slideTrack.children(this.options.slide).detach(),
                    n.$slideTrack.append(n.$slides),
                    (n.$slidesCache = n.$slides),
                    n.reinit();
            }),
            (s.prototype.setCSS = function (e) {
                var t,
                    i,
                    n = this,
                    o = {};
                !0 === n.options.rtl && (e = -e),
                    (t = "left" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
                    (i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
                    (o[n.positionProp] = e),
                    !1 === n.transformsEnabled || (!(o = {}) === n.cssTransitions ? (o[n.animType] = "translate(" + t + ", " + i + ")") : (o[n.animType] = "translate3d(" + t + ", " + i + ", 0px)")),
                    n.$slideTrack.css(o);
            }),
            (s.prototype.setDimensions = function () {
                var e = this;
                !1 === e.options.vertical
                    ? !0 === e.options.centerMode && e.$list.css({ padding: "0px " + e.options.centerPadding })
                    : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({ padding: e.options.centerPadding + " 0px" })),
                    (e.listWidth = e.$list.width()),
                    (e.listHeight = e.$list.height()),
                    !1 === e.options.vertical && !1 === e.options.variableWidth
                        ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length)))
                        : !0 === e.options.variableWidth
                        ? e.$slideTrack.width(5e3 * e.slideCount)
                        : ((e.slideWidth = Math.ceil(e.listWidth)), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
                var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
                !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
            }),
            (s.prototype.setFade = function () {
                var i,
                    n = this;
                n.$slides.each(function (e, t) {
                    (i = n.slideWidth * e * -1),
                        !0 === n.options.rtl ? c(t).css({ position: "relative", right: i, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 }) : c(t).css({ position: "relative", left: i, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 });
                }),
                    n.$slides.eq(n.currentSlide).css({ zIndex: n.options.zIndex - 1, opacity: 1 });
            }),
            (s.prototype.setHeight = function () {
                var e;
                1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical && ((e = this.$slides.eq(this.currentSlide).outerHeight(!0)), this.$list.css("height", e));
            }),
            (s.prototype.setOption = s.prototype.slickSetOption = function () {
                var e,
                    t,
                    i,
                    n,
                    o,
                    s = this,
                    r = !1;
                if (
                    ("object" === c.type(arguments[0])
                        ? ((i = arguments[0]), (r = arguments[1]), (o = "multiple"))
                        : "string" === c.type(arguments[0]) &&
                          ((n = arguments[1]), (r = arguments[2]), "responsive" === (i = arguments[0]) && "array" === c.type(arguments[1]) ? (o = "responsive") : void 0 !== arguments[1] && (o = "single")),
                    "single" === o)
                )
                    s.options[i] = n;
                else if ("multiple" === o)
                    c.each(i, function (e, t) {
                        s.options[e] = t;
                    });
                else if ("responsive" === o)
                    for (t in n)
                        if ("array" !== c.type(s.options.responsive)) s.options.responsive = [n[t]];
                        else {
                            for (e = s.options.responsive.length - 1; 0 <= e; ) s.options.responsive[e].breakpoint === n[t].breakpoint && s.options.responsive.splice(e, 1), e--;
                            s.options.responsive.push(n[t]);
                        }
                r && (s.unload(), s.reinit());
            }),
            (s.prototype.setPosition = function () {
                this.setDimensions(), this.setHeight(), !1 === this.options.fade ? this.setCSS(this.getLeft(this.currentSlide)) : this.setFade(), this.$slider.trigger("setPosition", [this]);
            }),
            (s.prototype.setProps = function () {
                var e = this,
                    t = document.body.style;
                (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
                    "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
                    (void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition) || (!0 === e.options.useCSS && (e.cssTransitions = !0)),
                    e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : (e.options.zIndex = e.defaults.zIndex)),
                    void 0 !== t.OTransform && ((e.animType = "OTransform"), (e.transformType = "-o-transform"), (e.transitionType = "OTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                    void 0 !== t.MozTransform &&
                        ((e.animType = "MozTransform"), (e.transformType = "-moz-transform"), (e.transitionType = "MozTransition"), void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)),
                    void 0 !== t.webkitTransform &&
                        ((e.animType = "webkitTransform"), (e.transformType = "-webkit-transform"), (e.transitionType = "webkitTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                    void 0 !== t.msTransform && ((e.animType = "msTransform"), (e.transformType = "-ms-transform"), (e.transitionType = "msTransition"), void 0 === t.msTransform && (e.animType = !1)),
                    void 0 !== t.transform && !1 !== e.animType && ((e.animType = "transform"), (e.transformType = "transform"), (e.transitionType = "transition")),
                    (e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType);
            }),
            (s.prototype.setSlideClasses = function (e) {
                var t,
                    i,
                    n,
                    o,
                    s = this,
                    r = s.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true");
                s.$slides.eq(e).addClass("slick-current"),
                    !0 === s.options.centerMode
                        ? ((n = s.options.slidesToShow % 2 == 0 ? 1 : 0),
                          (o = Math.floor(s.options.slidesToShow / 2)),
                          !0 === s.options.infinite &&
                              (o <= e && e <= s.slideCount - 1 - o
                                  ? s.$slides
                                        .slice(e - o + n, e + o + 1)
                                        .addClass("slick-active")
                                        .attr("aria-hidden", "false")
                                  : ((t = s.options.slidesToShow + e),
                                    r
                                        .slice(t - o + 1 + n, t + o + 2)
                                        .addClass("slick-active")
                                        .attr("aria-hidden", "false")),
                              0 === e ? r.eq(r.length - 1 - s.options.slidesToShow).addClass("slick-center") : e === s.slideCount - 1 && r.eq(s.options.slidesToShow).addClass("slick-center")),
                          s.$slides.eq(e).addClass("slick-center"))
                        : 0 <= e && e <= s.slideCount - s.options.slidesToShow
                        ? s.$slides
                              .slice(e, e + s.options.slidesToShow)
                              .addClass("slick-active")
                              .attr("aria-hidden", "false")
                        : r.length <= s.options.slidesToShow
                        ? r.addClass("slick-active").attr("aria-hidden", "false")
                        : ((i = s.slideCount % s.options.slidesToShow),
                          (t = !0 === s.options.infinite ? s.options.slidesToShow + e : e),
                          s.options.slidesToShow == s.options.slidesToScroll && s.slideCount - e < s.options.slidesToShow
                              ? r
                                    .slice(t - (s.options.slidesToShow - i), t + i)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false")
                              : r
                                    .slice(t, t + s.options.slidesToShow)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false")),
                    ("ondemand" !== s.options.lazyLoad && "anticipated" !== s.options.lazyLoad) || s.lazyLoad();
            }),
            (s.prototype.setupInfinite = function () {
                var e,
                    t,
                    i,
                    n = this;
                if ((!0 === n.options.fade && (n.options.centerMode = !1), !0 === n.options.infinite && !1 === n.options.fade && ((t = null), n.slideCount > n.options.slidesToShow))) {
                    for (i = !0 === n.options.centerMode ? n.options.slidesToShow + 1 : n.options.slidesToShow, e = n.slideCount; e > n.slideCount - i; --e)
                        (t = e - 1),
                            c(n.$slides[t])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", t - n.slideCount)
                                .prependTo(n.$slideTrack)
                                .addClass("slick-cloned");
                    for (e = 0; e < i + n.slideCount; e += 1)
                        (t = e),
                            c(n.$slides[t])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", t + n.slideCount)
                                .appendTo(n.$slideTrack)
                                .addClass("slick-cloned");
                    n.$slideTrack
                        .find(".slick-cloned")
                        .find("[id]")
                        .each(function () {
                            c(this).attr("id", "");
                        });
                }
            }),
            (s.prototype.interrupt = function (e) {
                e || this.autoPlay(), (this.interrupted = e);
            }),
            (s.prototype.selectHandler = function (e) {
                var t = c(e.target).is(".slick-slide") ? c(e.target) : c(e.target).parents(".slick-slide"),
                    i = (i = parseInt(t.attr("data-slick-index"))) || 0;
                this.slideCount <= this.options.slidesToShow ? this.slideHandler(i, !1, !0) : this.slideHandler(i);
            }),
            (s.prototype.slideHandler = function (e, t, i) {
                var n,
                    o,
                    s,
                    r,
                    a,
                    l = null,
                    c = this;
                if (((t = t || !1), !((!0 === c.animating && !0 === c.options.waitForAnimate) || (!0 === c.options.fade && c.currentSlide === e))))
                    if (
                        (!1 === t && c.asNavFor(e),
                        (n = e),
                        (l = c.getLeft(n)),
                        (r = c.getLeft(c.currentSlide)),
                        (c.currentLeft = null === c.swipeLeft ? r : c.swipeLeft),
                        !1 === c.options.infinite && !1 === c.options.centerMode && (e < 0 || e > c.getDotCount() * c.options.slidesToScroll))
                    )
                        !1 === c.options.fade &&
                            ((n = c.currentSlide),
                            !0 !== i
                                ? c.animateSlide(r, function () {
                                      c.postSlide(n);
                                  })
                                : c.postSlide(n));
                    else if (!1 === c.options.infinite && !0 === c.options.centerMode && (e < 0 || e > c.slideCount - c.options.slidesToScroll))
                        !1 === c.options.fade &&
                            ((n = c.currentSlide),
                            !0 !== i
                                ? c.animateSlide(r, function () {
                                      c.postSlide(n);
                                  })
                                : c.postSlide(n));
                    else {
                        if (
                            (c.options.autoplay && clearInterval(c.autoPlayTimer),
                            (o =
                                n < 0
                                    ? c.slideCount % c.options.slidesToScroll != 0
                                        ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                                        : c.slideCount + n
                                    : n >= c.slideCount
                                    ? c.slideCount % c.options.slidesToScroll != 0
                                        ? 0
                                        : n - c.slideCount
                                    : n),
                            (c.animating = !0),
                            c.$slider.trigger("beforeChange", [c, c.currentSlide, o]),
                            (s = c.currentSlide),
                            (c.currentSlide = o),
                            c.setSlideClasses(c.currentSlide),
                            c.options.asNavFor && (a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(c.currentSlide),
                            c.updateDots(),
                            c.updateArrows(),
                            !0 === c.options.fade)
                        )
                            return (
                                !0 !== i
                                    ? (c.fadeSlideOut(s),
                                      c.fadeSlide(o, function () {
                                          c.postSlide(o);
                                      }))
                                    : c.postSlide(o),
                                void c.animateHeight()
                            );
                        !0 !== i
                            ? c.animateSlide(l, function () {
                                  c.postSlide(o);
                              })
                            : c.postSlide(o);
                    }
            }),
            (s.prototype.startLoad = function () {
                var e = this;
                !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()),
                    !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
                    e.$slider.addClass("slick-loading");
            }),
            (s.prototype.swipeDirection = function () {
                var e,
                    t = this.touchObject.startX - this.touchObject.curX,
                    i = this.touchObject.startY - this.touchObject.curY,
                    n = Math.atan2(i, t);
                return (
                    (e = Math.round((180 * n) / Math.PI)) < 0 && (e = 360 - Math.abs(e)),
                    (e <= 45 && 0 <= e) || (e <= 360 && 315 <= e)
                        ? !1 === this.options.rtl
                            ? "left"
                            : "right"
                        : 135 <= e && e <= 225
                        ? !1 === this.options.rtl
                            ? "right"
                            : "left"
                        : !0 === this.options.verticalSwiping
                        ? 35 <= e && e <= 135
                            ? "down"
                            : "up"
                        : "vertical"
                );
            }),
            (s.prototype.swipeEnd = function (e) {
                var t,
                    i,
                    n = this;
                if (((n.dragging = !1), (n.swiping = !1), n.scrolling)) return (n.scrolling = !1);
                if (((n.interrupted = !1), (n.shouldClick = !(10 < n.touchObject.swipeLength)), void 0 === n.touchObject.curX)) return !1;
                if ((!0 === n.touchObject.edgeHit && n.$slider.trigger("edge", [n, n.swipeDirection()]), n.touchObject.swipeLength >= n.touchObject.minSwipe)) {
                    switch ((i = n.swipeDirection())) {
                        case "left":
                        case "down":
                            (t = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide + n.getSlideCount()) : n.currentSlide + n.getSlideCount()), (n.currentDirection = 0);
                            break;
                        case "right":
                        case "up":
                            (t = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide - n.getSlideCount()) : n.currentSlide - n.getSlideCount()), (n.currentDirection = 1);
                    }
                    "vertical" != i && (n.slideHandler(t), (n.touchObject = {}), n.$slider.trigger("swipe", [n, i]));
                } else n.touchObject.startX !== n.touchObject.curX && (n.slideHandler(n.currentSlide), (n.touchObject = {}));
            }),
            (s.prototype.swipeHandler = function (e) {
                var t = this;
                if (!(!1 === t.options.swipe || ("ontouchend" in document && !1 === t.options.swipe) || (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))))
                    switch (
                        ((t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1),
                        (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
                        !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold),
                        e.data.action)
                    ) {
                        case "start":
                            t.swipeStart(e);
                            break;
                        case "move":
                            t.swipeMove(e);
                            break;
                        case "end":
                            t.swipeEnd(e);
                    }
            }),
            (s.prototype.swipeMove = function (e) {
                var t,
                    i,
                    n,
                    o,
                    s,
                    r = this,
                    a = void 0 !== e.originalEvent ? e.originalEvent.touches : null;
                return (
                    !(!r.dragging || r.scrolling || (a && 1 !== a.length)) &&
                    ((t = r.getLeft(r.currentSlide)),
                    (r.touchObject.curX = void 0 !== a ? a[0].pageX : e.clientX),
                    (r.touchObject.curY = void 0 !== a ? a[0].pageY : e.clientY),
                    (r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2)))),
                    (s = Math.round(Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2)))),
                    !r.options.verticalSwiping && !r.swiping && 4 < s
                        ? !(r.scrolling = !0)
                        : (!0 === r.options.verticalSwiping && (r.touchObject.swipeLength = s),
                          (i = r.swipeDirection()),
                          void 0 !== e.originalEvent && 4 < r.touchObject.swipeLength && ((r.swiping = !0), e.preventDefault()),
                          (o = (!1 === r.options.rtl ? 1 : -1) * (r.touchObject.curX > r.touchObject.startX ? 1 : -1)),
                          !0 === r.options.verticalSwiping && (o = r.touchObject.curY > r.touchObject.startY ? 1 : -1),
                          (n = r.touchObject.swipeLength),
                          (r.touchObject.edgeHit = !1) === r.options.infinite &&
                              ((0 === r.currentSlide && "right" === i) || (r.currentSlide >= r.getDotCount() && "left" === i)) &&
                              ((n = r.touchObject.swipeLength * r.options.edgeFriction), (r.touchObject.edgeHit = !0)),
                          !1 === r.options.vertical ? (r.swipeLeft = t + n * o) : (r.swipeLeft = t + n * (r.$list.height() / r.listWidth) * o),
                          !0 === r.options.verticalSwiping && (r.swipeLeft = t + n * o),
                          !0 !== r.options.fade && !1 !== r.options.touchMove && (!0 === r.animating ? ((r.swipeLeft = null), !1) : void r.setCSS(r.swipeLeft))))
                );
            }),
            (s.prototype.swipeStart = function (e) {
                var t,
                    i = this;
                if (((i.interrupted = !0), 1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow)) return !(i.touchObject = {});
                void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]),
                    (i.touchObject.startX = i.touchObject.curX = void 0 !== t ? t.pageX : e.clientX),
                    (i.touchObject.startY = i.touchObject.curY = void 0 !== t ? t.pageY : e.clientY),
                    (i.dragging = !0);
            }),
            (s.prototype.unfilterSlides = s.prototype.slickUnfilter = function () {
                null !== this.$slidesCache && (this.unload(), this.$slideTrack.children(this.options.slide).detach(), this.$slidesCache.appendTo(this.$slideTrack), this.reinit());
            }),
            (s.prototype.unload = function () {
                var e = this;
                c(".slick-cloned", e.$slider).remove(),
                    e.$dots && e.$dots.remove(),
                    e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
                    e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
                    e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
            }),
            (s.prototype.unslick = function (e) {
                this.$slider.trigger("unslick", [this, e]), this.destroy();
            }),
            (s.prototype.updateArrows = function () {
                var e = this;
                Math.floor(e.options.slidesToShow / 2),
                    !0 === e.options.arrows &&
                        e.slideCount > e.options.slidesToShow &&
                        !e.options.infinite &&
                        (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        0 === e.currentSlide
                            ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                            : ((e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode) || (e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode)) &&
                              (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
            }),
            (s.prototype.updateDots = function () {
                null !== this.$dots &&
                    (this.$dots.find("li").removeClass("slick-active").end(),
                    this.$dots
                        .find("li")
                        .eq(Math.floor(this.currentSlide / this.options.slidesToScroll))
                        .addClass("slick-active"));
            }),
            (s.prototype.visibility = function () {
                this.options.autoplay && (document[this.hidden] ? (this.interrupted = !0) : (this.interrupted = !1));
            }),
            (c.fn.slick = function () {
                for (var e, t = arguments[0], i = Array.prototype.slice.call(arguments, 1), n = this.length, o = 0; o < n; o++)
                    if (("object" == typeof t || void 0 === t ? (this[o].slick = new s(this[o], t)) : (e = this[o].slick[t].apply(this[o].slick, i)), void 0 !== e)) return e;
                return this;
            });
    });
